import { AppEnvironment } from 'features/app/config/configType';

export enum Flight {
	//#region A
	/**
	 * Restricts billing account creation to AAD tenants only
	 *
	 * Owner: aditinarang
	 * Good Until: Unknown
	 */
	AADTenants = 'AADTenants',
	/**
	 * Increases number of customer search results from 10 to 50
	 *
	 * Owner: Cassandra
	 * Good Until: 5/31/2024
	 */
	accountExtensionsOrgSearchMoreResults = 'accountExtensionsOrgSearchMoreResults',
	/**
	 * New start date/end date picker requirements for Direct ACO
	 *
	 * Owner: Mariam
	 * Good Until: Unknown
	 */
	acoStartEndDate = 'acoStartEndDate',
	/**
	 * ACO Start/End Date for Fairfax (USGov) cloud - Government proposals only
	 *
	 * Owner/Requester: Shreyas
	 * Good Until: Unknown
	 */
	acoStartEndDateFairFax = 'acoStartEndDateFairFax',
	/**
	 * ACO Start/End Date for Air-Gapped clouds (UsSec/UsNat) - Government proposals only
	 *
	 * Owner/Requester: Shreyas
	 * Good Until: Unknown
	 */
	acoStartEndDateAirGapped = 'acoStartEndDateAirGapped',
	/**
	 * Expanded display for seats constraints information
	 *
	 * Owner/Requester: Harry
	 * Good Until: Unknown
	 */
	addOnMaxPurchaseInfo = 'addOnMaxPurchaseInfo',
	/**
	 * AirCapi Cloud
	 *
	 * Owner/Requester: Jason
	 * Good Until: PERMANENT - Aircapi is for test environments only
	 */
	airCapi = 'aircapi',
	/**
	 * Allows the users to pick specific end date(only month) for Azure Commitment Discount product
	 * Owner/Requester: Can/Tiffany
	 * Good Until: Unknown
	 */
	allowEndDateWithoutStartDateForAzureCommitmentDiscount = 'allowEndDateWithoutStartDateForAzureCommitmentDiscount',
	/**
	 * Allows user to select skus with unspecified locations in production.
	 *
	 * Owner/Requester: Julie
	 * Good Until: Unknown
	 */
	allowUnspecifiedOptionInLocationFilters = 'allowunspecifiedoptioninlocationfilters',
	/**
	 * Allows comments visible in Approvals page after submitting quote.
	 *
	 * Owner/Requester: Sonam/Karthika
	 * Good Until: April 2025 - For Testing/Demo Only
	 */
	approvalCommentsVisibleOnSubmit = 'approvalCommentsVisibleOnSubmit',
	/**
	 * Enables new approver search and selection UX in submit proposal dialog
	 *
	 * Owner/Requester: anjaisw
	 * Good Until: Unknown
	 */
	enableApproverSearchSelection = 'enableApproverSearchSelection',
	/**
	 * Allows to auto-approve quote after been submitted.
	 *
	 * Owner/Requester: Julie
	 * Good Until: PERMANENT - For Testing/Demo Only
	 */
	approvalOverride = 'approvaloverride',
	/**
	 * Enables Assign DES (Approval Exceptions) functionality for Direct Commercial/Gov proposals
	 *
	 * Owner/Requester: UI: Assign DES
	 * Good Until: TBD
	 */
	assignDES = 'assignDES',
	/**
	 * Properly filters events for latestPurchaseRecordId in GQL
	 *
	 * Owner/Requester: jejungk
	 * Good Until: Jan 2025
	 */
	assetEvents = 'assetEvents',
	/**
	 * Enables promo filtering by passing tenant id to QS as first class property
	 *
	 * Owner/Requester: sokushwaha
	 * Good Until: TBD
	 */
	addTenantIdOnQuote = 'addTenantIdOnQuote',
	/**
	 * Sets onBehalfOf flag to true for catalog fetch promos call
	 *
	 * Owner/Requester: sokushwaha
	 * Good Until: TBD
	 */
	addOnBehalfOfToCatalog = 'addOnBehalfOfToCatalog',
	/**
	 * Enables Parent Billing Account ID feature
	 * Owner/Requester: [Add owner if known]
	 * Good Until: [Add date if known]
	 */
	parentbillingAcountId = 'parentbillingAcountId',
	/**
	 * Uses filters when calling CommerceCache API for Assets
	 *
	 * Owner/Requester: jejungk
	 * Good Until: Nov 2024
	 */
	assetFilters = 'assetFilters',
	/**
	 * Will introduce new UX changes for Asset Panel - Subscription Management
	 *
	 * Owner/Requester: Pallavi
	 * Good Until: A month after release.
	 */
	assetPanelUxChanges = 'assetPanelUxChanges',
	/**
	 * Will introduce FlyInPanel experience for Azure Support
	 *
	 * Owner/Requester: Dixya
	 * Good Until: Unknown
	 */
	azureSupportConfigFlyInPanel = 'azureSupportConfigFlyInPanel',
	/**
	 * Support Azure Gov Proposals for Commercial Customers
	 *
	 * Owner/Requester: Sugubb
	 * Good Until: Unknown
	 */
	azuregovforcommercialcustomers = 'azuregovforcommercialcustomers',
	/**
	 * Support Azure Gov Proposals for Commercial Customers
	 *
	 * Owner/Requester: Sugubb
	 * Good Until: Unknown
	 */
	azuregovforcommercialcustomersUSGov = 'azuregovforcommercialcustomersUSGov',
	/**
	 * Logs for approve on behalf
	 *
	 * Owner/Requester: ramatta
	 * Good Until: Unknown
	 */
	approveOnBehalfLogs = 'approveOnBehalfLogs',
	/**
	 * Fix for approve on behalf
	 *
	 * Owner/Requester: ramatta
	 * Good Until: Unknown
	 */
	approveOnBehalfFix = 'approveOnBehalfFix',
	//#endregion

	//#region B
	/**
	 * Enables backdated late renewals flow
	 *
	 * Owner/Requester: v-buprasad
	 * Good Until: Unknown
	 */
	backdatelateRenewalsTest = 'backdatelateRenewalsTest',
	/**
	 * Enables the new BA (Billing Account) search experience on the Customer tab.
	 *
	 * Owner/Requester: N/A
	 * Good Until: Unknown
	 */
	baSearchExperience = 'baSearchExperience',
	/**
	 * Batches per-organization Modern Agreement/getOrganization calls into a single bulk getOrganizations request on the Properties tab.
	 *
	 * Owner/Requester: v-pgaurihar
	 * Good Until: Unknown
	 */
	batchOrganizationLoad = 'batchOrganizationLoad',
	/**
	 * Deduplicates the AAD Graph /organization call within a single request so the tenant
	 * lookups (managed type, display name, warm-up) share one GET instead of issuing three.
	 *
	 * Owner/Requester: v-pgaurihar
	 * Good Until: Unknown
	 */
	dedupeAadOrganizationCall = 'dedupeAadOrganizationCall',
	/**
	 * Collapses per-organization Modern Agreement GETs on the Properties tab into a single
	 * account-scoped (customerRootId) query, then filters the results locally per organization.
	 *
	 * Owner/Requester: v-pgaurihar
	 * Good Until: Unknown
	 */
	batchOrgAgreementLoad = 'batchOrgAgreementLoad',
	/**
	 * Routes the base quote fetch in the getQuote resolver through the shared quotes DataLoader so the
	 * Quote/SoldToSimple field resolvers reuse that single GET /quotes/{id} instead of firing a duplicate.
	 *
	 * Owner/Requester: v-pgaurihar
	 * Good Until: Unknown
	 */
	dedupeGetQuoteLoad = 'dedupeGetQuoteLoad',
	/**
	 * Umbrella flight for the Properties-tab dedupe work. When enabled it turns on the four proven-safe
	 * child optimizations at once (dedupeAadOrganizationCall, batchOrgAgreementLoad, dedupeGetQuoteLoad,
	 * batchOrganizationLoad) so the feature can be ramped with a single toggle. The backend expands this
	 * umbrella into those child flights during flight resolution. batchOrganizationLoad joined the umbrella
	 * once its skipBulk fix (single-org GET on the address-dependent market-filter path) was validated on Test.
	 *
	 * Owner/Requester: v-pgaurihar
	 * Good Until: Unknown
	 */
	propertiesTabDedupe = 'propertiesTabDedupe',
	/**
	 * Enables customer Billing Profiles to scope all discounts
	 *
	 * Owner/Requester: Mrinal
	 * Good Until: A month after release - TBD
	 */
	billingProfileForDiscounts = 'billingProfileForDiscounts',
	/**
	 * Enables customer Billing Profiles to scope all discounts for Outer Banks
	 *
	 * Owner/Requester: Brian
	 * Good Until: Unknown
	 */
	billingProfileForDiscountsForObx = 'billingProfileForDiscountsForObx',
	/**
	 * Enables customer Billing Profiles to scope all discounts for Rock Creek
	 *
	 * Owner/Requester: Brian
	 * Good Until: Unknown
	 */
	billingProfileForDiscountsForRockCreek = 'billingProfileForDiscountsForRockCreek',
	/**
	 * Switch to new api for customer partner relationship for china 21 v
	 *
	 * Owner/Requester: aditinarang
	 * Good Until: Unknown
	 */
	billingProfileChina21V = 'billingProfileChina21V',
	/**
	 * Enables billing RP asset migration API
	 *
	 * Owner/Requester:
	 * Good Until: Unknown
	 */
	billingRPAssetMigration = 'billingRPAssetMigration',
	/**
	 * Enables breadcrumbs in the Navigation Bar
	 *
	 * Owner/Requester: Jennie
	 * Good Until: A month after release - 09/01 (with FedGov)
	 */
	breadcrumbs = 'breadcrumbs',
	/**
	 * Allows bulk approval of list of quote ids.
	 *
	 * Owner/Requester: Can/Mark
	 * Good Until: Permanent - Issue in prod
	 */
	bulkApproveTransact = 'bulkapprovetransact',
	/**
	 * Enables Bulk import V1.
	 *
	 * Owner/Requester: anjaisw
	 * Good Until: Permanent
	 */
	bulkImportV1 = 'bulkImportV1',
	asyncProductExport = 'asyncProductExport',
	//#endregion

	//#region C
	/**
	 * Enables credit check for all national clouds (not just Global).
	 * When ON, credit checks apply to sovereign clouds (US-Gov, US-Sec, US-Nat, CN-Sovereign, FR-SOV).
	 *
	 * Owner/Requester: aditinarang
	 * Good Until: Unknown
	 */
	creditCheck = 'creditCheck',
	/**
	 * Enables Chatbot feature.
	 *
	 * Owner/Requester: Megha
	 * Good Until: Unknown
	 */
	chatbot = 'chatbot',
	/**
	 * Enables the new CI (Commerce Insights) search experience on the Home Customers page.
	 *
	 * Owner/Requester: vineet
	 * Good Until: Unknown
	 */
	ciSearchExperience = 'ciSearchExperience',
	/**
	 * Allows to cancel Assets of quote ids.
	 *
	 * Owner/Requester: Vijay/Julie
	 * Good Until: Short time
	 */
	canCancelAsset = 'canCancelAsset',
	/**
	 * Enables a button in the quote summary that duplicates a proposal
	 *
	 * Owner/Requestor: Jill/Natalia/Mariam
	 * Good Until: 06/23
	 */
	cloneProposal = 'cloneProposal',
	/**
	 * Enables the Clone Proposal Agent chatbot on the proposals page.
	 * When enabled, a floating chat widget appears in the bottom-right corner
	 * for analyzing and cloning proposals.
	 *
	 * Owner/Requester: prak
	 * Good Until: Unknown
	 */
	cloneProposalAgent = 'cloneProposalAgent',
	/**
	 * Enables the async Clone Proposal Version V2 flow (async createQuote/patchQuote
	 * handled by cloneQuoteProcessor). Only takes effect when quoteVersionV2 is also
	 * on - the two flights are combined with AND, not OR.
	 *
	 * Owner/Requester: TBD
	 * Good Until: Unknown
	 */
	cloneProposalVersionV2 = 'cloneProposalVersionV2',
	/**
	 * Convert dates to ISO String when doing bulk editing
	 * Owner/Requester: Can
	 * Good Until: Month after prod release
	 */
	convertDatesToISOStringOnBulkDiscount = 'convertDatesToISOStringOnBulkDiscount',
	/**
	 * Normalize discount dates to seconds precision (removes milliseconds)
	 * for applyDiscount mutations to ensure consistent date handling.
	 * Affects discount date fields such as startDate and endDate.
	 * Owner/Requester: Ambrish
	 * Good Until: Month after prod release
	 */
	normalizeDiscountDatesToSeconds = 'normalizeDiscountDatesToSeconds',
	/**
	 * Add Commerce Insights to converged workspace experience
	 *
	 * Owner/Requester: Jennie
	 * Good Until: unknown
	 */
	convergence = 'convergence',
	/**
	 * Enables configurable conversion windows for specific-date conversions.
	 *
	 * Owner/Requester: [Add owner if known]
	 * Good Until: [Add date if known]
	 */
	configurableConversionWindows = 'configurableConversionWindows',
	/**
	 * End date alignment with line item from proposal
	 *
	 * Owner/Requester: Harry/Tiffany
	 * Good Until: Month after prod release
	 */
	cotermWithLineItemFromProposal = 'cotermWithLineItemFromProposal',
	/**
	 * End date alignment with line item from proposal using mock data
	 *
	 * Owner/Requester: Harry/Tiffany
	 * Good Until: Month after prod release
	 */
	cotermWithLineItemFromProposalMockData = 'cotermWithLineItemFromProposalMockData',
	/**
	 * Enables CSAT feedback survey on successful proposal submission.
	 * When enabled, a satisfaction rating form appears after the user
	 * successfully submits a proposal.
	 *
	 * Owner/Requester: prak
	 * Good Until: Unknown
	 */
	csatFeedback = 'csatFeedback',
	/**
	 * Gates the Authenticated Petrol migration (getAccessToken callback).
	 * When OFF the legacy getUserAccessToken prop is used so feedback
	 * submission continues to work before pre-auth onboarding is complete.
	 *
	 * Owner/Requester: prak
	 * Good Until: Unknown
	 */
	csatAuthMigration = 'csatAuthMigration',
	/**
	 * Enables Floodgate-based system-initiated surveys with built-in
	 * sampling and cooldown.  When OFF the existing user-initiated OCV
	 * feedback (via @1js/scc-react-feedback-plugin) is used at trigger
	 * points.  When ON the Floodgate SDK handles survey eligibility.
	 *
	 * Owner/Requester: prak
	 * Good Until: Unknown
	 */
	csatFloodgate = 'csatFloodgate',
	/**
	 * Market currency override
	 *
	 * Owner/Requester: Jason Soden
	 * Good Until: PERMANENT
	 */
	currencyOverride = 'currencyOverride',
	/**
	 * Enables Agreement Revamp UX on the Customer Overview page (page tour
	 * triggered from search navigation, and the Billing Accounts dropdown
	 * in the customer nav bar header).
	 *
	 * Owner/Requester: vineetsingh
	 * Good Until: Unknown
	 */
	cwaAgreementRevamp = 'cwaAgreementRevamp',
	/**
	 * Enables mock data for the Agreement Revamp UX on the Customer Overview
	 * page. Used for local development and testing without backend dependencies.
	 *
	 * Owner/Requester: vineetsingh
	 * Good Until: Unknown
	 */
	cwaAgreementRevampMock = 'cwaAgreementRevampMock',
	/**
	 * Enables the revamped filter experience on the upcoming expiration and schedule event tab.
	 *
	 * Owner/Requester: vineetsingh
	 * Good Until: Unknown
	 */
	cwaOverviewTabRevamp = 'cwaOverviewTabRevamp',
	/**
	 * Enables CWA to be used by org id or tenant id instead of tpid
	 * TEST ONLY, should never be on by default
	 *
	 * Owner/Requester: stmill
	 * Good Until: PERMANENT - TEST ONLY
	 */
	cwaByModernIds = 'cwaByModernIds',
	/**
	 * Debug Flight for CWA
	 *
	 * Owner/Requester: Keshav
	 * Good Until: Unknown
	 */
	cwaDebug = 'cwaDebug',
	/**
	 * Restricts Commerce Insights proposal creation to only billing accounts with a
	 * direct purchase context (PurchaseContext.Direct)
	 *
	 * Owner/Requester: Unknown
	 * Good Until: Unknown
	 */
	cwaDirectCommercialFilterCI = 'cwaDirectCommercialFilterCI',
	/**
	 * Enables CWA to use Cache Service for data retrieval
	 *
	 * Owner/Requester: Keshav
	 * Good Until: Unknown
	 */
	cwaCacheService = 'cwaCacheService',
	/**
	 * Separates the MSInvestment Tab to ECIF
	 *
	 * Owner/Requester: Keshav
	 * Good Until: Unknown
	 */
	cwaCaco = 'cwaCaco',
	/**
	 * Enables CWA to use actual product data for CAOC instead of mock data
	 * Owner/Requester: Keshav
	 * Good Until: Unknown
	 */
	cwaCacoActualProductData = 'cwaCacoActualProductData',
	/**
	 * Separates the MSInvestment Tab to CAOC and ACO
	 *
	 * Owner/Requester: bhavya
	 * Good Until: Unknown
	 */
	cwaCacoMock = 'cwaCacoMock',
	/**
	 * Enables SS-CACO (Service Specific Conditional Azure Credit Offer) features
	 *
	 * Owner/Requester: Suchitra
	 * Good Until: Unknown
	 */
	cwaSsCaco = 'cwaSsCaco',
	/**
	 * Enables mock data for SS-CACO specific fields
	 *
	 * Owner/Requester: Manikuttan Sivadas
	 * Good Until: Unknown
	 */
	cwaSsCacoMock = 'cwaSsCacoMock',
	/**
	 * Enables CWA Enterprise Support Phase 2 to use UFP features
	 *
	 * Owner/Requester: Pankaj Janoti
	 * Good Until: unknown
	 */
	cwaEnterpriseSupportPhase2 = 'cwaEnterpriseSupportPhase2',
	/**
	 * Enables CWA Enterprise Support Phase 2 Mock Data to use UFP features
	 *
	 * Owner/Requester: Pankaj Janoti
	 * Good Until: unknown
	 */
	cwaEnterpriseSupportPhase2Mock = 'cwaEnterpriseSupportPhase2Mock',
	/**
	 * Enables CWA to use EST features
	 *
	 * Owner/Requester: Saket Kumar Singh
	 * Good Until: unknown
	 */
	cwaEst = 'cwaEst',
	/**
	 * Enables CWA to be used control panel
	 *
	 * Owner/Requester: saket
	 * Good Until: PERMANENT - TEST ONLY
	 */
	cwaControlPanel = 'cwaControlPanel',
	/**
	 * Separates the MSInvestment Tab to ECIF
	 *
	 * Owner/Requester: Keshav
	 * Good Until: Unknown
	 */
	cwaEcif = 'cwaEcif',
	/**
	 * Separates the MSInvestment Tab to ECIF Mock
	 *
	 * Owner/Requester: Keshav
	 * Good Until: Unknown
	 */
	cwaEcifMock = 'cwaEcifMock',
	/**
	 * Enables CWA Evidence of Signature Feature
	 *
	 * Owner/Requester: Megha
	 * Good Until: Unknown
	 */
	cwaEvidenceOfSignature = 'cwaEvidenceOfSignature',
	/**
	 * Enables CWA Evidence of Signature Mock Data
	 *
	 * Owner/Requester: Development
	 * Good Until: Unknown
	 */
	cwaEvidenceOfSignatureMock = 'cwaEvidenceOfSignatureMock',
	/**
	 * Enables enhanced View All filters with expiration and billing account ID on the RightNowTab
	 *
	 * Owner/Requester: NA
	 * Good Until: After testing completion
	 */
	cwaExpiringProposalsViewAllFilter = 'cwaExpiringProposalsViewAllFilter',
	/** Enables CWA LSA CLP View
	 *
	 * Owner/Requester: Megha
	 * Good Until: Unknown
	 */
	cwaLsaClpView = 'cwaLsaClpView',
	/**
	 * Enables CWA LSA CLP View Mock
	 *
	 * Owner/Requester: Megha
	 * Good Until: Unknown
	 */
	cwaLsaClpViewMock = 'cwaLsaClpViewMock',
	/**
	 * Enables CWA - Late Renewals
	 *
	 * Owner/Requester: Megha
	 * Good Until: Unknown
	 */
	cwaLateRenewals = 'cwaLateRenewals',
	/**
	 * Enables CWA - Concession Search by Resource ID
	 *
	 * Owner/Requester: Suchitra
	 * Good Until: Unknown
	 */
	cwaConcessionSearch = 'cwaConcessionSearch',
	/**
	 * Enables parallel background prefetching for all Concessions tabs with debug logging
	 *
	 * Owner/Requester: Suchitra
	 * Good Until: Unknown - Remove after rollout
	 */
	cwaConcessionPrefetch = 'cwaConcessionPrefetch',
	/**
	 * Enables CWA LSA Associated Purchases
	 *
	 * Owner/Requester: Tanroop singh
	 * Good Until: Unknown
	 */
	cwaLsaAssociatedPurchases = 'cwaLsaAssociatedPurchases',
	/**
	 * Macc Milestone
	 *
	 * Owner/Requester: Saket Kumar Singh
	 * Good Until: Unknown
	 */
	cwaMaccMilestone = 'cwaMaccMilestone',
	/**
	 * Macc Milestone Mock Data
	 *
	 * Owner/Requester: Saket Kumar Singh
	 * Good Until: Unknown
	 */
	cwaMaccMilestoneMock = 'cwaMaccMilestoneMock',
	/**
	 * enables CWA to use Multi Entity support
	 *
	 * Owner/Requester: Pankaj Janoti
	 * Good Until: unknown for now.
	 */
	cwaMultiEntitySupport = 'cwaMultiEntitySupport',
	/**
	 * enables CWA to use Multi Entity support
	 *
	 * Owner/Requester: Pankaj Janoti
	 * Good Until: unknown for now.
	 */
	cwaMultiEntitySupportMock = 'cwaMultiEntitySupportMock',
	/**
	 * enables CWA to use Benefits RP instead of balance service to display Contributor list for Primary BA if exists
	 *
	 * Owner/Requester: kasub/paul
	 * Good Until: unknown for now.
	 */
	cwaMultiMaccContriEntity = 'cwaMultiMaccContriEntity',
	/**
	 * Enables the Quantity, Future discount and Future amount columns on the
	 * Customer Overview Upcoming Expirations and Schedule Event grid.
	 * Owner/Requester: vineetsingh
	 * Good Until: Unknown
	 */
	cwaOverviewTabTableRevamp = 'cwaOverviewTabTableRevamp',
	/**
	 * Show planned accounts in Billing Accounts section
	 *
	 * Owner/Requester: simranpujji
	 * Good Until: after transition map release
	 */
	cwaPlannedAccounts = 'cwaPlannedAccounts',

	/**
	 * enables scheduled mid-term upgrades for Scheduled Events in CWA
	 *
	 * Owner/Requester: Megha
	 * Good Until: Unknown
	 */
	cwaScheduledMidTermUpgrades = 'cwaScheduledMidTermUpgrades',
	/**
	 * enables zero to be entered for macc shortfall post-paid invoices.
	 *
	 * Owner/Requester: stmill
	 * Good Until: zero-dollar post-paid MACC shortfalls are supported by downstream systems
	 */
	cwaShortfallPostPaidAllowZero = 'cwaShortfallPostPaidAllowZero',
	/**
	 * Flight changes to shortfall panel
	 *
	 * Owner/Requester: simranpujji
	 * Good until: unknown
	 */
	cwaShortfallPanelChanges = 'cwaShortfallPanelChanges',
	/**
	 * Enables refetching quote flow for MACC shortfall panel
	 *
	 * Owner/Requester: keagarwa
	 * Good Until: After testing and verification
	 */
	cwaShortfallRefetchingQuote = 'cwaShortfallRefetchingQuote',
	/**
	 * Skips passing the billing account when creating a proposal from the Commerce Insights Overview tabs
	 *
	 * Owner/Requester: Unknown
	 * Good Until: Unknown
	 */
	cwaSkipBillingAccountForProposal = 'cwaSkipBillingAccountForProposal',
	/**
	 * Enables Special Billing Plan for Subscriptions Expiration
	 *
	 * Owner/Requester: Saket Kumar Singh
	 * Good Until: Unknown
	 */
	cwaSpecialBillingPlan = 'cwaSpecialBillingPlan',
	/**
	 * Enables custom term subscription length and supporting documents
	 *
	 * Owner/Requester: v-vrswami
	 * Good Until: Unknown
	 */
	customTermSubscriptionLength = 'customTermSubscriptionLength',
	/**
	 * expired data not to shown AcquisitionDetail
	 *
	 * Owner: Abhishek singh
	 * Good Until: Unknown
	 */
	cwaTaco = 'cwaTaco',
	/**
	 * Enables True-Up enhancements
	 *
	 * Owner/Requester: Manikuttan Sivadas
	 * Good Until: Unknown
	 */
	cwaTrueUp = 'cwaTrueUp',
	/**
	 * Enables True-Up Mock Data
	 *
	 * Owner/Requester: Manikuttan Sivadas
	 * Good Until: Unknown
	 */
	cwaTrueUpMock = 'cwaTrueUpMock',
	/**
	 * Enables CWA - Upcoming Expirations Tab (New)
	 *
	 * Owner/Requester: Manikuttan Sivadas
	 * Good Until: Unknown
	 */
	cwaUpcomingExpirationTabNew = 'cwaUpcomingExpirationTabNew',
	/**
	 * Enables CWA - Unified For Partners
	 *
	 * Owner/Requester: Megha
	 * Good Until: Unknown
	 */
	cwaUnifiedForPartners = 'cwaUnifiedForPartners',
	/**
	 * Enables CWA - Unified For Partners Mock
	 *
	 * Owner/Requester: Keshav
	 * Good Until: Unknown
	 */
	cwaUnifiedForPartnersMock = 'cwaUnifiedForPartnersMock',
	/**
	 * use mock data for TACO in CWA
	 *
	 * Owner: Abhishek singh
	 * Good Until: Unknown
	 */
	cwaTacoMock = 'cwaTacoMock',
	/**
	 * Using telemetry in CWA
	 *
	 * Owner/Requester: Karthick
	 * Good until: unknown
	 */
	cwaTelemetry = 'cwaTelemetry',
	/**
	 * Checks to see if tenants have a valid id for the add customer flow
	 *
	 * Owner/Requester: nicoscalzo
	 * Good until: unknown
	 */
	cwaTenantAccountCheck = 'cwaTenantAccountCheck',
	/**
	 * Owner/Requester: Sarthak Maini
	 * Good Until: CACO feature goes live
	 */
	caco = 'caco',
	/**
	 * Conditional ACO Live - Only live CACO actions shown when enabled
	 *
	 * Owner/Requester: Anurag Kumar
	 * Good Until: Unknown
	 */
	conditionalACOLive = 'conditionalACOLive',
	/**
	 * use mock data for TACO in products grod
	 *
	 * Owner: V S G Adithya
	 * Good Until: Bug Fix from BenefitsRP
	 */
	cancelExistingACOMock = 'cancelExistingACOMock',

	/**
	 * Enable cancel existing ACO
	 *
	 * Owner/Requester: v-viselvaraj
	 * Good until: unknown
	 */
	cancelExistingAco = 'cancelExistingAco',

	/**
	 *
	 * removes logs from CWA
	 *
	 * Owner/Requester: Unknown
	 * Good Until: Unknown
	 */
	cwaRemoveLogs = 'cwaRemoveLogs',

	/**
	 * Enables new flight-controlled RightNowTab with enhanced features
	 *
	 * Owner/Requester: NA
	 * Good Until: After testing completion
	 */
	cwaRightNowTab = 'cwaRightNowTab',

	//#endregion

	//#region D

	/**
	 * Fixes date discrepancy bug where Created on date displays local time instead of UTC
	 *
	 * Owner/Requester: Raghavendra
	 * Good Until: A month after prod release
	 */
	dateDiscrepancyBug = 'dateDiscrepancyBug',
	/**
	 * Allows us to see Approved benefits and benefits on quote separately
	 *
	 * Owner/Requester: Jennie
	 * Good Until: A month after release - 09/27
	 */
	dealTotalityBenefitsOnQuote = 'dealTotalityBenefitsOnQuote',
	/**
	 * Enables publish-blocking messages to check if the partner or customer's tenant still exists.
	 * Owner/Requester: Steven
	 * Good Until: the feature is good and tested!
	 */
	deletedTenantCheck = 'deletedTenantCheck',
	/**
	 * Owner/Requester: Jason/Karina
	 * Good Until: Permanent - Test only
	 */
	demoMode = 'demomode',
	/**
	 * Owner/Requester: Can
	 * Good Until: Unknown
	 */
	deduplicateProductIdsOnMultiSelect = 'deduplicateProductIdsOnMultiSelect',
	/**
	 * Owner/Requester: Harry
	 * Good Until: Unknown
	 */
	delaySearchByMeterId = 'delaySearchByMeterId',
	/**
	 * Enable SignUp APIs from GraphQL instead of 3PA through QCS
	 *
	 * Owner/Requester: Mariam/ V-mparthasar
	 * Good Until: Unknown
	 */
	/**
	 * Allows direct commercial quotes to use nonDFD flow
	 *
	 * Owner/Requester: Nanor / Pallavi / Julie
	 * Good Until: testing complete
	 */
	directComNonDFD = 'directcomnondfd',
	/**
	 * Allows selection of fgoe on a direct-goverment quote
	 *
	 * Owner/Requester: Jason
	 * Good Until: A month after release - 10/01
	 */
	directFGOE = 'directfgoe',
	/**
	 * Allows direct-gov quotes to be created
	 *
	 * Owner/Requester: Jason
	 * Good Until: A month after release - 10/01
	 */
	directGov = 'directgov',
	/**
	 * Allows direct-gov quotes to use nonDFD flow
	 *
	 * Owner/Requester: Nanor / Pallavi / Julie
	 * Good Until: testing complete
	 */
	directGovNonDFD = 'directgovnondfd',
	/**
	 * Disable bulk edit for Passes product
	 *
	 * Owner/Requester: Harry
	 * Good Until: Unknown
	 */
	disableBulkEditForPasses = 'disableBulkEditForPasses',
	/**
	 * Disable one-time discount option for Passes/Entra products in Government Contractor
	 * scenarios with USNat or USSec clouds (AGC release)
	 *
	 * Owner/Requester: kbilkhis
	 * Good Until: Unknown
	 */
	disableOneTimeDiscountForAGC = 'disableOneTimeDiscountForAGC',
	/**
	 * Allows to search for Office products
	 *
	 * Owner/Requester: Julie
	 * Good Until: PERMANENT - TEST ONLY
	 */
	disableProductInclusionFilter = 'disableproductinclusionfilter',
	/**
	 * Owner/Requester: Can
	 * Disable Epics and Sagas
	 * Good Until: We verify that we do not need these
	 */
	disableSagasAndEpics = 'disableSagasAndEpics',
	/**
	 * Do not show test term recommendations
	 *
	 * Owner/Requester: Can/Julie
	 * Good Until: PERMANENT - TEST ONLY
	 */
	disableTestTermRecommendations = 'disabletesttermrecommendations',
	/**
	 * Enables you to see the changing etag in the UX for debugging purposes
	 *
	 * Owner/Requester: Can
	 * Good Until:PERMANENT - TEST ONLY
	 */
	displayEtagsForDebugging = 'displayEtagsForDebugging',
	/**
	 * Shows test MCAs in Commerce Insights
	 * TEST ONLY, should never be on by default
	 *
	 * Owner/Requester: Jennie
	 * Good Until: PERMANENT - TEST ONLY
	 */
	displayTestMCAs = 'displaytestmcas',
	/**
	 * Owner/Requester: Can
	 * Good Until: Unknown
	 */
	doNotUpdateLineItemRecipientAndAssetTo = 'doNotUpdateLineItemRecipientAndAssetTo',
	/**
	 * Owner/Requester: Pallavi/Tiffany
	 * Good Until: TBD
	 * Enables the new download PDF enhanced UX experience for passes product lineItems
	 */
	downloadPDFConvertChanges = 'downloadPDFConvertChanges',
	/**
	 * For Signing Tool selection in Agreement creation on Review and Publish page.
	 *
	 * Owner/Requester: Lavina Sanghvi
	 * Good Until: Unknown
	 */
	docuSignV1 = 'docuSignV1',
	/**
	 * Signature optimization: extended market modes (SA/RU/EG), Microsoft acceptance mode,
	 * customer acceptance mode rename on Review and Publish page.
	 *
	 * Owner/Requester: Lavina Sanghvi
	 * Good Until: Unknown
	 */
	docuSignV2 = 'docuSignV2',
	/**
	 * Owner/Requester: Lavina Sanghvi
	 * Good Until: Unknown
	 */
	dualUseRightsForFromSA = 'dualUseRightsForFromSA',
	//#endregion

	//#region E
	/**
	 * Enables the use of E2 Fragments instead of the ones implemented in this codebase, this also enables all of the other features needed to make those Fragments work.
	 *
	 * Owner: Jason O'Neill
	 * Good Until: Initial E2 fragments has been stable in production for a while
	 */
	e2Fragments = 'e2Fragments',
	/**
	 * Enables validations on line items to manadate M1261 amendment for EEA settlement
	 *
	 * Owner/Requester: sokushwaha
	 * Good Until: TBD
	 */
	eeaSettlement = 'eeaSettlement',
	/**
	 * Enables the use of the @e2/router library to replace the one built-in from react-router. This is necessary for compatibility with E2 Fragments.
	 *
	 * Owner: Jason O'Neill
	 * Good Until: Router changes have been tested in production and MSX.
	 */
	e2Router = 'e2Router',
	/**
	 * Owner/Requester: Lavina Sanghvi
	 * Good Until: Unknown
	 */
	dualProduct = 'dualProduct',
	/**
	 * Flight to be used for toggling the new ECIF Modify/Cancel feature.
	 *
	 * Owner/Requester: Abhishek Sahai
	 * Release date: Mid November 2025
	 */
	ecifModifyCancelFlight = 'ecifModifyCancelFlight',
	/**
	 * Enables Enterprise Support Commit (Phase 2) features including
	 * search, configuration, future discount, and post-sale management.
	 *
	 * Owner/Requester: Vishnu
	 * Good Until: After production rollout and stabilization
	 */
	enterpriseSupportCommit = 'enterpriseSupportCommit',
	/**
	 * Enables the Enterprise Support Commit MACC flow: the ES Commit base-offer requirement
	 * selection on MACC create, ESC base-offer auto-add/remove after MACC apply, the
	 * "Required Product Added" MACC banner, and delete protection for a Required ESC line.
	 * Only effective when `enterpriseSupportCommit` is also enabled; when off, MACC behaves
	 * as it did before the ESC integration.
	 *
	 * Owner/Requester: L2O Enterprise Support
	 * Good Until: After production rollout and stabilization
	 */
	enterpriseSupportCommitMacc = 'enterpriseSupportCommitMacc',
	/**
	 * Enables Multi-Entity Enterprise Support in Quote Center: surfaces the
	 * catalog multi-entity capability (Sku.isMultiEntitySharable), the
	 * "Create new / Contribute to existing" action panel, the allow-contributors
	 * toggle, and the contribution search/apply flow. Must match the backend
	 * flight name so it is honored by the GraphQL resolvers.
	 *
	 * Owner/Requester: L2O Enterprise Support
	 * Good Until: After production rollout and stabilization
	 */
	enterpriseSupportMultiEntity = 'enterpriseSupportMultiEntity',
	/**
	 * Flight to be used for toggling the ECIF Amendment feature.
	 *
	 * Owner/Requester: Unknown
	 * Release date: Same PR as the creation of this flight.
	 */
	ecifAmendmentFlight = 'ecifAmendmentFlight',
	/**
	 * Flight to be used for toggling the new ECIF Modify/Cancel feature for US Gov.
	 *
	 * Owner/Requester: Anubha Jain
	 * Release date: December Mid 2025
	 */
	usGovEcifModifyFlight = 'usGovEcifModifyFlight',
	/**
	 * Enables Apollo Request Inspector
	 * When turned off, you would not get any call headers in the response.
	 * Owner/Requester: Can
	 * Release date: Same PR as the creation of this flight.
	 */
	enableApolloRequestInspector = 'enableApolloRequestInspector',
	/**
	 * Enables Apollo Request Inspector experimental client filter options
	 * Owner/Requester: Can
	 * Release date: Same PR as the creation of this flight.
	 */
	enableApolloRequestInspectorClientFilters = 'enableApolloRequestInspectorClientFilters',
	/**
	 * Enables Cache Version 9 for Standard Acceleration
	 * Owner/Requester: Chaitri
	 * Release date: Unknown.
	 */
	enableCacheVersionNine = 'enableCacheVersionNine',
	/**
	 * Use this flight to use worker pool for processing quotes in backend GQL layer
	 * Owner/Requester: Ankit
	 * Good Until: Unknown
	 */
	enableCacheWorkerPool = 'enableCacheWorkerPool',
	/**
	 * Enables Multi-Tenant Proposals feature with Deal ID support
	 * Owner/Requester: Deepanshu
	 * Good Until: After production rollout and stabilization
	 */
	multiTenantProposals = 'multiTenantProposals',

	/**
	 * Detaches the linked dealId from a quote after a successful billing-account
	 * change (Edit / Add new / Select existing / Create account+org), so the quote
	 * is not left referencing a deal that no longer matches its billing account.
	 * When OFF: no auto-detach occurs after billing-account changes.
	 * Owner/Requester: Deepanshu
	 * Good Until: After production rollout and stabilization
	 */
	MEPdealDetachmentOnBillingAccountChange = 'MEPdealDetachmentOnBillingAccountChange',

	/**
	 * Enables Multi-Entity Proposals (MEP) deal flow for Large Quotes.
	 * Requires multiTenantProposals to also be enabled.
	 * When ON: large quotes can be grouped into deals.
	 * When OFF: large quotes always submit as standalone.
	 * Owner/Requester: Prasanna
	 * Good Until: After production rollout and stabilization
	 */
	mepForLargeQuotes = 'mepForLargeQuotes',

	/**
	 * Enables OBO (Approve on Behalf Of) for Multi-Entity Proposals deal-level approval.
	 * When ON: deal-level OBO button + wizard are shown.
	 * When OFF: deal-level shows only regular Approve/Reject (no OBO).
	 * Per-quote OBO is NOT affected by this flight.
	 * Owner/Requester: Prasanna
	 * Good Until: After production rollout and stabilization
	 */
	multiTenantProposalsOboEnablement = 'multiTenantProposalsOboEnablement',
	/**
	 * Gates the per-proposal OBO eligibility classifier for Multi-Entity Proposals.
	 * When ON: each pending proposal is evaluated independently for OBO eligibility
	 *   via batched getPolicies + validateEmpowerment calls, so sibling proposals
	 *   sharing the same empowerment all route to "Approve on behalf of".
	 * When OFF: falls back to the previous deal-wide single-shot useCanApproveOnBehalf
	 *   + approvalId equality check (pre-fix master behavior).
	 * Child rollout flag for multiTenantProposalsOboEnablement; no effect when the
	 * parent flight is OFF.
	 * Owner/Requester: Prasanna
	 * Good Until: After per-proposal rollout and stabilization
	 */
	multiTenantProposalsOboPerProposalEligibility = 'multiTenantProposalsOboPerProposalEligibility',
	/**
	 * use grid for labels in details pane
	 *
	 * Owner/Requester: Can
	 * Release date: When the work to migrate non-grid parts to grid is done
	 */
	enableDetailsPaneLabelGrid = 'enabledetailspanelabelgrid',
	/**
	 * Enable EA Enrollment Protected Fields with updated Validations
	 * Owner/Requester: Harish
	 * Release date: Unknown
	 */
	enableEaEnrollmentProtected = 'enableEaEnrollmentProtected',
	/**
	 * enable new lineItem type for meters lineItems
	 *
	 * Owner/Requester: Hongyu
	 * Release date: Unknown
	 */
	enableMetersLineItem = 'enableMetersLineItem',
	/**
	 * enable use of preferred communication languages
	 *
	 * Owner/Requester: ramatta
	 * Release date: Unknown
	 */
	usePreferredCommunicationLanguages = 'usePreferredCommunicationLanguages',
	/**
	 * Enable service desk attachment functionality
	 * Owner/Requester: Can
	 * Release date: After the new service desk 1PA attachment functionality is ready
	 */
	enableServiceDeskAttachment = 'enableServiceDeskAttachment',
	/**
	 * Enable new stamp config v2
	 *
	 * Owner/Requester: Niti
	 * Release date: Unknown
	 */
	enableStampConfigV2 = 'enableStampConfigV2',

	/**
	 * DD360 QCS migration enable endpoint to 1P
	 * Good Until: Unknown
	 */
	enableQCSMigrationwith1PADD360 = 'enableQCSMigrationwith1PADD360',

	/**
	 * Gates all backend optimization changes.
	 *
	 * Good Until: Unknown
	 */
	enableQcOptimizations = 'enableQcOptimizations',

	/**
	 * Enable QC Optimizations: Fragment DataLoader Keys
	 *
	 * Good Until: Unknown
	 */
	enableFragmentdProductReadForOptimization = 'enableFragmentdProductReadForOptimization',

	/**
	 * Uses to enabl and disable BD360 attachment using graphQl(QCS migration)
	 * Good Until: Unknown
	 */
	enableDD360AttachmentGQL = 'enableDD360AttachmentGQL',

	/**
	 * Uses a quicker search method for shared meters
	 * Owner/Requester: Can
	 */
	enableQuickLookupForSharedMeters = 'enablequicklookupforsharedmeters',
	/**
	 * Owner/Requester: Team consensus in standup
	 * Good Until: PERMANENT - TEST ONLY
	 */
	enableReferralCloseButtonForTesting = 'enableReferralCloseButtonForTesting',

	/**
	 * Owner/Requester: Sonam
	 * Good Until: Month after prod release
	 */
	enableTAXIDForAllMarket = 'enableTAXIDForAllMarket',

	/**
	 * Enables the new VAT ID flow
	 *
	 * Owner/Requester: Can
	 * Good Until: Unknown
	 */
	enableNewVatIDs = 'enableNewVatIDs',

	/**
	 * Enables France-specific tax IDs (PublicSectorId, NationalIdentificationNumber, EInvoicingCode, NonRegistrationAcknowledgement)
	 *
	 * Owner/Requester: Can
	 * Good Until: Unknown
	 */
	enableFranceTaxIds = 'enableFranceTaxIds',

	/**
	 * Enables the new "Your Tax ID is required" banner for France organizations
	 * whose tax status is NonCompliant. When off, the existing
	 * "Tax Id(s) not found" banner is shown.
	 */
	enableFranceNonCompliantTaxBanner = 'enableFranceNonCompliantTaxBanner',

	/**
	 * Enables the new "Your Tax ID is required" banner for organizations
	 * whose tax status is NonCompliant. When off, the existing
	 * "Tax Id(s) not found" banner is shown.
	 */
	enableNonCompliantTaxBanner = 'enableNonCompliantTaxBanner',

	/**
	 * Enables test products
	 *
	 * Owner/Requester: Manshu
	 */
	enableTestProducts = 'enableTestProducts',

	/**
	 * Owner/Requester:Product Team
	 * Good Until: 2024-07
	 * Leap Year and all endDates alignment
	 */
	endDateAdjustment = 'endDateAdjustment',
	/**
	 * Enables passing target end date in immediate conversion scenario
	 *
	 * Owner/Requester: evuriharish
	 * Good Until: Unknown
	 */
	endDateForImmediateConversion = 'endDateForImmediateConversion',
	/**
	 * Enables Enterprise Support Phase 2 - Cancellation features
	 *
	 * Owner/Requester: Unknown
	 * Good Until: Unknown
	 */
	enterpriseSupportPhase2Cancellation = 'enterpriseSupportPhase2Cancellation',
	/**
	 * Prevents duplicate Enterprise Support mid-term cancellations when an asset already has
	 * a scheduled action.
	 *
	 * Owner/Requester: L2O Enterprise Support
	 * Good Until: After production rollout and stabilization
	 */
	enterpriseSupportRPDuplicateCancellation = 'enterpriseSupportRPDuplicateCancellation',
	/**
	 * Allows overriding currency for eurozone Nordic/DACH markets (Denmark, Sweden, Switzerland, Norway)
	 *
	 * Owner/Requester: v-dhbhardwaj
	 * Good Until: Unknown
	 */
	eurozoneCurrencyException = 'eurozoneCurrencyException',
	/**
	 * Change text to reflect ES for Azure are graduated
	 *
	 * Owner/Requester: Harry/Tiffany
	 * Good Until: Month after prod release
	 */
	esGraduatedPricingOnlyForAzure = 'esGraduatedPricingOnlyForAzure',
	/**
	 * Enable ESTS-R on the backend auth flow
	 *
	 * Owner/Requester: Eliud
	 * Good Until: Unknown
	 */

	estsrRegionAutodetect = 'estsrRegionAutodetect',

	/**
	 * Enable Expiration Message Banner for Proposal Screen
	 *
	 * Owner/Requester: Aniket Harmalkar
	 * Good Until: Unknown
	 */
	expiryBanner = 'expiryBanner',

	/**
	 * Shows Etag mismatch dialog when an etag error occurs.
	 *
	 * Owner/Requester: annaalla
	 * Good Until: Unknown
	 */
	pagination = 'pagination',
	/**
	 *
	 *
	 * Owner/Requester:
	 * Good Until: Unknown
	 */
	est = 'est',
	/**
	 * Gates GetProductFilteredSkus so it only fires for SimpleSkuPicker terms (the only
	 * term type whose panels consume the fetched SKU data). Removes the per-SKU
	 * /products/lookup storm for all other term types.
	 *
	 * Owner/Requester:
	 * Good Until: Unknown
	 */
	gateProductFilteredSkus = 'gateProductFilteredSkus',
	/**
	 *
	 *
	 * Owner/Requester:
	 * Good Until: Unknown
	 */
	estLookupOptimization = 'estLookupOptimization',
	/**
	 * Fetch `isESTSupported` only for the selected SKU via `Product.sku(skuId:)`
	 * instead of the bulk `skus` list. OFF = current behaviour (one catalog
	 * lookup per SKU), ON = optimized (a single lookup for the selected SKU).
	 * Frontend-only query shaping; no backend change.
	 *
	 * Owner/Requester: akshatbatra
	 * Good Until: Unknown
	 */
	estSingleSkuLookup = 'estSingleSkuLookup',
	/**
	 * Fetch `isESTSupported` for the asset relationship target SKU via the
	 * relationship-level `sku` field instead of resolving it for every SKU in the
	 * target product's `skus` list. OFF = current behaviour (one catalog lookup per
	 * SKU per relationship target), ON = one lookup per relationship target.
	 * All other SKU fields are unchanged in both states.
	 *
	 * Requires the backend relationship `sku` field to be deployed first.
	 *
	 * Owner/Requester: akshatbatra
	 * Good Until: Unknown
	 */
	subscriptionAssetTargetEstLookup = 'subscriptionAssetTargetEstLookup',
	/**
	 * Enable Backdated EST Adjust/Convert flows
	 * Allows users to perform backdated EST adjustments and conversions
	 *
	 * Owner/Requester: guptavrinda
	 * Good Until: Unknown
	 */
	estBackdatedFlows = 'estBackdatedFlows',
	/**
	 * For EST partial convert, only the base (0th-index) late-renewal line item
	 * retains transactionIntent = BackDatedLateRenewal; all other line items get
	 * null/undefined. Sent to the backend via the `flights` request header so the
	 * backend can gate the transactionIntent-nulling behavior.
	 *
	 * Owner/Requester: prak
	 * Good Until: After production rollout and stabilization
	 */
	estPartialConvertIntent = 'estPartialConvertIntent',
	/**
	 * Enable estMock
	 *
	 * Owner/Requester:
	 * Good Until: Unknown
	 */
	estMock = 'estMock',
	/**
	 * Enables Azure promotions in new promotion experience
	 *
	 * Owner/Requester: Manshu
	 * Good Until: Unknown
	 */
	enableAzurePromos = 'enableAzurePromos',
	/**
	 * Gates sending IsDailyInvoicingEligible to Quote Service
	 *
	 * Owner/Requester: Samiksha
	 */
	enableNceDailyInvoicing = 'enableNceDailyInvoicing',
	/**
	 * Enables mock data for Azure promotions (for testing when API is not available)
	 *
	 * Owner/Requester: Manshu
	 * Good Until: Unknown
	 */
	azurePromoMockData = 'azurePromoMockData',
	excludeSavingsPlan = 'excludeSavingsPlan',
	//#endregion

	//#region F
	/**
	 * Enables Fairfax Billing Profile feature
	 *
	 * Owner/Requester:
	 * Good Until:
	 */
	fairfaxBillingProfile = 'fairfaxBillingProfile',
	/**
	 * Only display eligible Billing Account Owners when selecting billing account owner
	 *
	 * Owner/Requester: Jennie
	 * Good Until: Until it is not needed
	 */
	filterForBillingAccountOwners = 'filterforbillingaccountowners',
	/**
	 * Only show products that have SKU and availability
	 *
	 * Owner/Requester: Hongyu
	 * Good Until: One month after deployment
	 */
	filterNoSkuNoAvailabilityProducts = 'filterNoSkuNoAvailabilityProducts',
	/**
	 * Fix passes & software subs lineitems which have expired availabilities
	 *
	 * Owner/Requester: Sreeraj
	 * Good Until: One month after deployment
	 */
	fixQuoteWithExpiredAvailabilities = 'fixQuoteWithExpiredAvailabilities',
	/**
	 * Enables the Flex Spend Plan (FSP) quoting experience.
	 *
	 * Owner/Requester: kmondal
	 * Good Until: FSP GA
	 */
	flexSpendPlan = 'flexSpendPlan',
	/**
	 * Enables the FSP (Flex Spend Plan) quotability experience: the "Select an action" dialog
	 * offering "Purchase now" (quotable FSP) vs "Reserve discounts for later purchase" (future
	 * discount). When this flight is off, only the existing future-discount flow is available.
	 *
	 * Owner/Requester: kmondal
	 * Good Until: FSP GA
	 */
	flexSpendPlanQuotability = 'flexSpendPlanQuotability',
	/**
	 * Forces future discount options for products using SubscriptionProductConfigurationPanel
	 *
	 * Owner/Requester: jejungk
	 * Good Until: PERMANENT - TEST ONLY
	 */
	forceFutureDiscountOptions = 'forceFutureDiscountOptions',
	/**
	 * Controls the priorQuantity feature for legacy to modern migration
	 *
	 * Owner/Requester: Ankush Shrivastava
	 * Good Until: Unknown
	 */
	fromSAEnabled = 'fromSAEnabled',
	/**
	 * Owner/Requester: Can
	 * Good Until: After I verify this in test
	 */
	fixAccidentalShowingOfAllDiscountsAddedInSharedDiscountPanel = 'fixAccidentalShowingOfAllDiscountsAddedInSharedDiscountPanel',
	//#endregion

	//#region G
	/**
	 * Owner/Requester: Vijay/Shahnaz
	 * Good Until: Test only
	 */
	graphAuthorizationUsingQCApp = 'graphAuthorizationUsingQCApp',
	/**
	 * Owner/Requester: Vijay/Shahnaz
	 * Good Until: Test only
	 */
	graphToCreateSPNUsingQCApp = 'graphToCreateSPNUsingQCApp',
	/**
	 * Enables to retrieve MCAPI footprint for legacy enrollment using GSM API
	 *
	 * Owner/Requester: Nico Scalzo
	 * Good Until: Unknown
	 */
	gsmProject = 'gsmProject',
	/**
	 * Enables guided tour for quote center
	 *
	 * Owner/Requester: Nanor
	 * Good Until: Unknown
	 */
	guidedTour = 'guidedTour',
	//#endregion

	//#region H

	/**
	 * Enables hidden offer experience to show hidden offers for products at different granularity.
	 * Owner/Requester: Manshu/Arpit
	 * Good Until: unknown
	 */
	hiddenOffers = 'hiddenOffers',

	/**
	 * Enables mock data for hidden offer experience to show hidden offers for products at different granularity.
	 * Owner/Requester: Manshu/Arpit
	 * Good Until: unknown
	 */
	hiddenOffersMockData = 'hiddenOffersMockData',

	/**
	 * Enables mock data for hidden offer experience to show hidden offers for products at different granularity  in the pricelist featur.
	 * Owner/Requester: Adithya
	 * Good Until: Testing Completion
	 */
	hiddenOffersPriceListMockData = 'hiddenOffersPriceListMockData',

	/**
	 * Do not display Affiliat for Federal Government Direct or Indirect on the Organization Wizard
	 * Owner/Requester: nicoscalzo
	 * Good Until: Unknown

	 */
	hideAffiliateFedGov = 'hideAffiliateFedGov',
	/**
	 * Hides option to download shared meters
	 *
	 * Owner/Requestor: Jenn/Julie
	 * Good Until: TBD
	 */
	hideSharedMeters = 'hideSharedMeters',
	/**
	 * Hides Product Config Details for unconfigured products
	 * Good Until: TBD
	 */
	hideUnconfiguredProductConfigDetails = 'hideUnconfiguredProductConfigDetails',
	//#endregion

	//#region I
	/**
	 * Enables Info Summary Cards for Upcoming Expirations
	 *
	 * Owner/Requester: Megha
	 * Good Until: Unknown
	 */
	infoSummaryCards = 'infoSummaryCards',
	/**
	 * There are some quotes that are returned in search index but they actually do not exist, the search index is out of sync;
	 * this enables to return search results on quotes with ignoring those ones
	 *
	 * Owner/Requestor:Can
	 * Good Until: PERMANENT
	 */
	ignoreNonExistingQuotesOnSearchIndex = 'ignoreNonExistingQuotesOnSearchIndex',
	/**
	 * Ignore test email validation in test environment
	 *
	 * Owner/Requestor:Megan/Can
	 * Good Until : PERMANENT - TEST ONLY
	 */
	ignoreTestEmailValidation = 'ignoretestemailvalidation',
	/**
	 * Ignore sold-to mapping for pending quotes
	 *
	 * Owner/Requestor: Raghavendra
	 * Good Until: Unknown
	 */
	ignoreSoldToMappingPendingQuotes = 'ignoreSoldToMappingPendingQuotes',
	/**
	 * Allows indirect commercial for china quotes to use nonDFD flow
	 *
	 * Owner/Requester: Nanor / Pallavi / Julie
	 * Good Until: testing complete
	 */
	indirectComChinaNonDFD = 'indirectcomchinanondfd',
	/**
	 * Allows indirect commercial for CSP quotes to use nonDFD flow
	 *
	 * Owner/Requester: Nanor / Pallavi / Julie
	 * Good Until: testing complete
	 */
	indirectComCSPNonDFD = 'indirectcomcspnondfd',
	/**
	 * Allows indirect-gov quotes to use nonDFD flow
	 *
	 * Owner/Requester: Nanor / Pallavi / Julie
	 * Good Until: testing complete
	 */
	indirectGovNonDFD = 'indirectgovnondfd',
	/**
	 * Changes retry code for indirect partner customer footprint
	 *
	 * Owner/Requester: nicoscalzo
	 * Good Until: unknown
	 */
	indirectPartnerCustomerFootprintRetry = 'indirectPartnerCustomerFootprintRetry',
	/**
	 * Add Flight for HRDD Doc Hold for Testing
	 *
	 * Owner/Requester: Sita/Mohanraj
	 * Good Until: Permanent - Test only
	 */
	enableHRDDDocHold = 'enableHRDDDocHold',
	//#endregion

	//#region J
	/**
	 * Allow Jamaica for Direct quotes
	 *
	 * Owner/Requester: Jason Soden
	 * Good Until: A month after release - 6/1
	 */
	//#endregion

	//#region K
	//#endregion

	//#region L
	/**
	 * Uses QS v13 to support Large Quotes
	 *
	 * Owner/Requester: jejungk/titung
	 * Good Until: March 2025
	 */
	largeQuote1 = 'largeQuote1',
	/**
	 * Load product filters after other lineItems details load
	 *
	 * Owner/Requestor: Mariam
	 * Good Until: TBD
	 */
	lazyLoadProductFilters = 'lazyLoadProductFilters',
	/**
	 * Enables lead/affiliate functionality
	 *
	 * Owner/Requestor: aditinarang
	 * Good Until: Unknown
	 */
	leadAffiliate = 'leadAffiliate',
	/**
	 * Allows legacy quotes to use nonDFD flow
	 *
	 * Owner/Requester: Nanor / Pallavi / Julie
	 * Good Until: testing complete
	 */
	legacyNonDFD = 'legacynondfd',
	/**
	 * Organization Creation/Search should be limited to the market of the quote
	 *
	 * Owner/Requester: cassandraho
	 * Good Until: Unknown
	 */
	limitBillingAccountByMarket = 'limitBillingAccountByMarket',
	/**
	 * Owner/Requester: Jason Soden
	 * Good Until: PERMANENT
	 */
	/**
	 * Owner/Requester: Dixya
	 * Good Until: unknown
	 */
	lineItemLimitIncrease = 'lineitemlimitincrease',
	/**
	 * Enables reordering and sorting of line items in the quote editor.
	 * Owner/Requester: sachundru/sudonthineni
	 * Good Until: 1 month after go live
	 */
	productLineItemReorder = 'productLineItemReorder',
	/**
	 * Owner/Requester: Hongyu
	 * Good Until: 1 month after release
	 */
	loadMinimumRequiredPagesForSharedDiscount = 'loadMinimumRequiredPagesForSharedDiscount',
	/**
	 * Enables non-Azure shared discount flows (ItemizedCustomPrice path, UI panel enhancements).
	 *
	 * Owner/Requester: Anshuman
	 * Good Until: Unknown
	 */
	nonAzureSharedDiscounts = 'nonAzureSharedDiscounts',
	/**
	 * When enabled, excludes shared discount candidates whose
	 * `isEligibleForLineItemInQuote` is false from the Add Shared Discounts panel.
	 * When disabled, all candidates are shown regardless of eligibility (existing behavior).
	 *
	 * Owner/Requester: Ankit
	 * Good Until: Rollout complete
	 */
	excludeIneligibleSharedDiscounts = 'excludeIneligibleSharedDiscounts',
	/**
	 * Allows monthly prices to be visible in subscritpion dropdown in product configuration Panel.
	 *
	 * Owner/Requester: Sonam
	 * Good Until: Unknown
	 */
	lppSubPriceConfigurePanel = 'lppSubPriceConfigurePanel',
	/**
	 * When used together with the largeQuote1 flight, to use updated version of Arbitration endpoint
	 *
	 * Owner/Requester: jejungk/titung
	 * Good Until: March 2025
	 */
	lq1Arbitration = 'lq1Arbitration',
	/**
	 * When used together with the largeQuote1 flight, calls existing sync flow for SubmitQuote
	 *
	 * Owner/Requester: jejungk/titung
	 * Good Until: March 2025
	 */
	lq1ForSubmit = 'lq1ForSubmit',
	/**
	 * When used together with the largeQuote1 flight, passes largeQuote1 flight to QS
	 *
	 * Owner/Requester: jejungk/titung
	 * Good Until: March 2025
	 */
	lq1ForQS = 'lq1ForQS',
	/**
	 * Adding new features for MCA-E LSA work
	 *
	 * Owner/Requester: nebagla
	 * Good Until: December 2026
	 */
	lsa = 'lsa',
	/**
	 * Handling LSA mock data for MCA-E LSA work
	 *
	 * Owner/Requester: nebagla
	 * Good Until: December 2026
	 */
	lsaMockData = 'lsaMockData',
	/**
	 * Handling LSA Billing RP Agreement for MCA-E LSA work
	 *
	 * Owner/Requester: v-shremittal
	 * Good Until: December 2026
	 */
	lsaBillingRPAgreement = 'lsaBillingRPAgreement',
	/**
	 * Handling LSA Billing RP debugging
	 *
	 * Owner/Requester: vansha
	 * Good Until: December 2026
	 */
	lsaBRPdebug = 'lsaBRPdebug',
	/**
	 * Enables new logic for LSA/SA Start Date selection
	 * Owner/Requester: v-shremittal
	 * Good Until: December 2026
	 */
	lsaStartDateEnabled = 'lsaStartDateEnabled',
	/**
	 * Handles LSA/SA Derived Offer Coterm end date
	 * Owner/Requester: sokushwaha
	 * Good Until: December 2026
	 */
	lsaDerivedOfferCoterm = 'lsaDerivedOfferCoterm',
	/**
	 * Enables redesign of True-up flow in LSA
	 * Owner/Requester: sokushwaha
	 * Good Until: December 2026
	 */
	lsaTrueupRedesign = 'lsaTrueupRedesign',
	/**
	 * Enables mock data for redesigned True-up flow in LSA
	 * Owner/Requester: sokushwaha
	 * Good Until: December 2026
	 */
	lsaTrueupRedesignMockData = 'lsaTrueupRedesignMockData',
	/**
	 * Enables LSA V3 virtual bundling (split L/SA true-ups + association grouping)
	 * Owner/Requester: anshumanjain
	 * Good Until: December 2026
	 */
	lsaVirtualBundles = 'lsaVirtualBundles',
	/**
	 * Enables the LSA virtual bundling UI: the collapsible family header in the
	 * products grid and the proposal PDF, the group level delete, and the true-up
	 * discount pricing preview. Separate from `lsaVirtualBundles`, which governs
	 * the data shape, so the presentation can be trialled on its own.
	 * Owner/Requester: anshumanjain
	 * Good Until: December 2026
	 */
	lsaVirtualBundlesNewUI = 'lsaVirtualBundlesNewUI',
	/**
	 * List Price Presentment Proposal PDF Changes
	 *
	 * Owner/Requester: ramatta
	 * Good Until: Unknown
	 */
	lppDownloadQuotePdf = 'lppDownloadQuotePdf',
	/**
	 * Allows LPP to use the billing schedule API
	 *
	 * Owner/Requester: ramatta
	 * Good Until:
	 */
	lppUseBillingScheduleAPI = 'lppUseBillingScheduleAPI',
	/**
	 * LPP Products list changes
	 *
	 * Owner/Requester: ramatta
	 * Good Until:
	 */
	lppProductsList = 'lppProductsList',
	/**
	 * PROPOSAL_PAGE_PERF_V1: Master kill-switch for the Proposal Page
	 * performance optimizations targeting Large Quotes (100+ line items).
	 *
	 * Gates the user-visible behavior changes only:
	 *   - Row virtualization in ProductList (slice rendering, spacers)
	 *   - data-virtualization-scroll marker on the QuoteList scroll container
	 *   - FocusZone preventFocusRestoration on QuoteListSection (scroll-jump fix)
	 *   - Deferred loadProposal call in QuotesList (effect vs inline)
	 *
	 * Pure memoization wins (useMemo/useCallback/React.memo, Set lookups)
	 * are NOT gated — they have no observable behavior change.
	 *
	 * Owner/Requester: prak
	 * Good Until:
	 */
	proposalPagePerfV1 = 'proposalPagePerfV1',
	/**
	 * LPP Custom Format Subtotal Column in Excel
	 *
	 * Owner/Requester: aryankarkra
	 * Good Until: Testing Complete
	 */
	lppCustomFormatSubtotalColumn = 'lppCustomFormatSubtotalColumn',
	//#endregion
	/**
	 * Owner/Requester: Chaitri Gudhka
	 * Good Until: MACC Milestone features goes live
	 */
	lockProposal = 'lockProposal',
	//#region M
	/**
	 * Owner/Requester: Chaitri Gudhka
	 * Good Until: MACC Milestone features goes live
	 */
	maccMilestone = 'maccMilestone',
	/**
	 * Owner/Requester: v-patidard
	 * Good Until: milestone end-date validation rollout completes for testing purpose.
	 */
	maccMilestoneEndDateValidation = 'maccMilestoneEndDateValidation',
	/**
	 * Owner/Requester: Cassandra Ho
	 * Good Until: CWA MACC goes live
	 */
	maccModifyCancelPanelCWA = 'maccModifyCancelPanelCWA',
	/**
	 * Owner/Requester: Prashant kumar
	 */
	eaToMcaManageLineItemWizard = 'eaToMcaManageLineItemWizard',
	/**
	 * allows Malaysia for direct Quotes
	 *
	 * Owner/Requester: Jason Soden
	 * Good Until: 4 weeks after release - 1/1/22
	 */
	/**
	 * Shows maximum SKU limit reached line item error message returned from Validate API
	 *
	 * Owner/Requester: Manisha Sivaiah/Julie Ginesi
	 * Good Until: 9/20/2023
	 */
	maximumSkuLimitReachedMessage = 'maximumSkuLimitReachedMessage',
	/**
	 *  Measure shared meter performance
	 *
	 * Owner/Requester: Can
	 * Good Until: Test Flight so after we done the testing
	 */
	measureSharedMetersPerformance = 'measureSharedMetersPerformance',
	/**
	 * Owner/Requester: Can
	 * Good Until: 8/10/2024
	 */
	multiSelectTeachingBubble = 'multiSelectTeachingBubble',
	/**
	 * Enables MIM Terms Reordering actions in Agreement terms list
	 *
	 * Owner/Requester: NX Products
	 * Good Until: Unknown
	 */
	mimTermsReordering = 'mimTermsReordering',
	/**
	 * Reconciles missing Standard Azure Plan messages after Azure Plan mutations
	 *
	 * Owner/Requester: NX Products
	 * Good Until: Unknown
	 */
	missingStandardAzurePlan = 'missingStandardAzurePlan',
	/**
	 * Enforce authorization on mutations
	 *
	 * Owner/Requester: Eliud
	 * Good Until: Unknown
	 */
	mutationAuth = 'mutationAuth',
	//#endregion

	//#region N
	/**
	 * Enables the new authentication flow
	 *
	 * Owner/Requestor: Eliud
	 * Good Until: Unknown
	 */
	newAuthFlow = 'newAuthFlow',
	/**
	 * Enables the new billing plans
	 *
	 * Owner/Requestor: Harish
	 * Good Until: Unknown
	 */
	newBillingPlans = 'newBillingPlans',
	/**
	 * Allows testing with no test headers
	 * DO NOT TURN ON!!!!
	 *
	 * Owner/Requester: Mark
	 * Good Until: PERMANENT - TEST ONLY
	 */
	noTestHeaderTesting = 'notestheadertesting',
	/**
	 * Allows non standard framework quotes to use nonDFD flow
	 *
	 * Owner/Requester: Nanor / Pallavi / Julie
	 * Good Until: testing complete
	 */
	nonStandardFrameworkNonDFD = 'nonstandardframeworknondfd',
	/**
	 * Validates NSPT order-acceptance dates against existing negotiated payment terms.
	 *
	 * Owner/Requester: v-raghgupta
	 * Good Until: TBD
	 */
	nsptAcceptanceDateOverlapValidation = 'nsptAcceptanceDateOverlapValidation',
	/**
	 * Enables the new notification deep link
	 *
	 * Owner/Requester: Saket Kumar Singh
	 * Good Until: Unknown
	 */
	notifDeepLink = 'notifDeepLink',
	//#endregion

	//#region O
	/**
	 * Identifies translated strings where translation is not available.
	 *
	 * Owner/Requester: Ozgun
	 * Good Until: PERMANENT - TEST ONLY
	 */
	obfuscateTranslations = 'obfuscatetranslations',

	//#region O
	/**
	 * New approach allows to create offline agreement and patch the participants without deleting and creating a new agreement.
	 *
	 * Owner/Requester: vchayammagar
	 * Good Until: TBD
	 */
	offlineAgreementNewFlow = 'offlineAgreementNewFlow',

	//#region O
	/**
	 * Allows One Time V2 discounts in Future Discount Terms.
	 *
	 * Owner/Requester: cgudhka
	 * Good Until: TBD
	 */
	onetimeV2 = 'onetimeV2',
	//#endregion

	//#region P
	/**
	 * Per user promotions
	 *
	 * Owner/Requester: vansha
	 * Good Until: Unknown
	 */
	perUserPromotionsEnhanced = 'perUserPromotionsEnhanced',
	/**
	 * Enables promotional discounts for subscription lifecycle flows
	 * (upgrade, renewal, EST conversion)
	 *
	 * Owner/Requester: rishabhpahwa
	 * Good Until: TBD
	 */
	promotionsOnSubscriptionLifecycle = 'promotionsOnSubscriptionLifecycle',
	/**
	 * Routes promo eligibility validation to SaaS Hub RP instead of Publisher
	 * for subscription lifecycle flows only (no impact to new purchases).
	 *
	 * Owner/Requester: rishabhpahwa
	 * Good Until: TBD
	 */
	promoEligibilityViaSaaSHubRP = 'promoEligibilityViaSaaSHubRP',
	/**
	 * Enables mock promo data for subscription lifecycle flows (for testing when API is not available)
	 *
	 * Owner/Requester: rishabhpahwa
	 * Good Until: TBD
	 */
	subscriptionPromoMockData = 'subscriptionPromoMockData',
	/**
	 *
	 * Owner/Requestor: Mariam
	 * Good Until: TBD
	 */
	/**
	 * Allows Physical Signature for UK Framework
	 *
	 * Owner/Requester: Neha
	 * Good Until: A month after release - 05/01
	 */
	physicalSignForUkccf = 'physicalSignForUkccf',
	/**
	 * Enables search for a product based on just the PID
	 *
	 * Owner/Requester: iabowers
	 * Good Until: PERMANENT - TEST ONLY - this is now on in Prod, is still Permanent?
	 */
	pidSearch = 'pidsearch',
	/**
	 * Enables Pricelist feature
	 *
	 * Owner/Requester: Manisha/Natalia
	 * Good Until: 12/5
	 */
	pricelist = 'pricelist',
	/**
	 * Pricelist v2 Phase 2A
	 *
	 * Owner/Requester: Aryan Karkra
	 * Good Until: Test
	 */
	pricelistV2Phase2A = 'pricelistV2Phase2A',
	/**
	 * Pricelist v2 Phase 2B
	 *
	 * Owner/Requester: Aryan Karkra
	 * Good Until: Test
	 */
	pricelistV2Phase2B = 'pricelistV2Phase2B',
	/**
	 * Pricelist v2 Phase 3
	 *
	 * Owner/Requester: Aryan Karkra
	 * Good Until: Test
	 */
	pricelistV2Phase3 = 'pricelistV2Phase3',
	/**
	 * Pricelist v2 Phase 3A
	 *
	 * Owner/Requester: Raga Deepa
	 * Good Until: Test
	 */
	pricelistV2Phase3A = 'pricelistV2Phase3A',
	/**
	 * Pricelist v2 Phase 4
	 *
	 * Owner/Requester: Aryan Karkra
	 * Good Until: Test
	 */
	pricelistV2Phase4 = 'pricelistV2Phase4',
	/**
	 * Enables Cart across pricelist ability
	 *
	 * Owner/Requester: Manisha/Natalia
	 * Good Until: 12/5
	 */
	pricelistCartAcross = 'pricelistCartAcross',
	/**
	 * Enables Cart across pricelist ability
	 *
	 * Owner/Requester: Manisha/Natalia
	 * Good Until: 12/5
	 */
	pricelistExpandedView = 'pricelistExpandedView',
	/**
	 * Aligns Catalog Claim filters to valid QC Quote Context combinations
	 *
	 * Owner/Requester: Manisha/Natalia
	 * Good Until: 12/5
	 */
	pricelistQuoteFilters = 'pricelistQuoteFilters',
	/**
	 * Enables downloading full price list generated using pricing ADLS
	 *
	 * Owner/Requester: Sowmya/Natalia
	 * Good Until: 2/15
	 */
	pricelistFullDownload = 'pricelistFullDownload',
	/**
	 * Enables downloading price list with PSAT identifiers to help in gap analysis
	 *
	 * Owner/Requester: Sowmya/Natalia
	 * Good Until: 2/15
	 */
	pricelistDebugColumns = 'pricelistDebugColumns',
	/**
	 * Enables downloading price sheet
	 *
	 * Owner/Requester: Aryan Karkra
	 * Good Until: Unknown
	 */
	priceSheetDownload = 'priceSheetDownload',
	/**
	 * Enables performance optimizations for switching between the Products and Agreement
	 * tabs on a proposal (keep-both-tabs-mounted, memoized line-item derivation, and a
	 * stable Pivot items reference so the active-tab indicator does not lag).
	 *
	 * Owner/Requester: Mohammad
	 * Good Until: Unknown
	 */
	proposalTabSwitchPerfOptimization = 'proposalTabSwitchPerfOptimization',
	/**
	 * DEV ONLY
	 * Enables Product Inclusion Checker Panel where devs and Pm's can check the details about if a product is included in QC.
	 * Owner/Requester: Can
	 * Good Until: Unknown
	 *
	 */
	productInclusionCheckerPanel = 'productInclusionCheckerPanel',
	/**
	 * Increases number of product search results pages from 3 to 6
	 *
	 * Owner/Requester: Hongyu
	 * Good Until: A month after release
	 */
	productSearchMoreResults = 'productSearchMoreResults',
	/**
	 * Prevents productSearch to show duplicate products in gov context when switching nationalCloud tabs
	 *
	 * Owner/Requester: Nanor
	 * Good Until: turned on in prod
	 */
	productSearchRemoveDuplicateResult = 'productSearchRemoveDuplicateResult',
	/**
	 * Enables latest product search UI
	 * Owner/Requester: Manikuttan Sivadas
	 * Good Until: Unknown
	 */
	enableLatestProductSearch = 'enableLatestProductSearch',
	/**
	 * Routes the latest product search to the LDSS smart services search API
	 * instead of the search2 backend
	 * Owner/Requester: Manikuttan Sivadas
	 * Good Until: Unknown
	 */
	enableLdssProductSearch = 'enableLdssProductSearch',
	/**
	 * Shows the LDSS versus Search2 product search comparator on the What's New page.
	 * Owner/Requester: Harsha Maddineni
	 * Good Until: Unknown
	 */
	productSearchComparator = 'productSearchComparator',
	/**
	 * Bug Fix for Promotion Panel to handle multiple promotions
	 *
	 * Owner/Requester: Pallavi Sathe
	 * Good Until: Unknown
	 */
	promotionProductOwnerShipFix = 'promotionProductOwnerShipFix',
	/**
	 * Fixes the cancel button not reverting expiration date in the Good Until date picker
	 *
	 * Owner/Requester: Raghavendra
	 * Good Until: A month after release
	 */
	proposalExpirationBug = 'proposalExpirationBug',
	/**
	 * Enable to display Proposal steps for all Non21v quotes.
	 *
	 * Owner/Requester: Navya Jeevan/Natalie/Steve
	 * Good Until: TBD
	 */
	proposalSteps = 'proposalSteps',

	/**
	 * Enables Expiration and Status filter pills on the Proposals list page
	 *
	 * Owner/Requester: v-uvenkatesh
	 * Good Until: TBD
	 */
	proposalStatusFilter = 'proposalStatusFilter',

	/**
	 * Enables the 1P scope for attachment service
	 *
	 * Owner/Requester: Scott
	 * Good Until: Enabled in Prod
	 */
	proposalAttachment1P = 'proposalAttachment1P',
	//#endregion

	//#region Q
	/**
	 * MSX Portal
	 *
	 * Owner/Requester: Sowmya/Jason Schneider
	 * Good Until: Permanent
	 */
	qcInMSX = 'qcinmsx',
	/**
	 * MCAPI Policy
	 */
	mcapiPolicy = 'mcapiPolicy',
	/**
	 * Enable QCS Migration Service Desk Attachment 1PA
	 * Owner/Requester: Can/ Natalia
	 */
	qcsMigrationServiceDeskAttachment1PA = 'qcsMigrationServiceDeskAttachment1PA',
	/**
	 * Signals QS to enforce the use of ELM roles during requests
	 *
	 * Owner/Requester: Eliud
	 * Good Until: Unknown
	 */
	qsElmEnforce = 'qsElmEnforce',
	/**
	 * GQL does not process lineItems for messages
	 *
	 * Owner/Requester: jejungk
	 * Good Until: Nov 2024
	 */
	quoteHeaderMessages = 'quoteHeaderMessages',
	/**
	 * Adding new features for MCA-E Ramped Discounting work
	 *
	 * Owner/Requester: nebagla
	 * Good Until: Unknown
	 */
	quoteRampedDiscounting = 'quoteRampedDiscounting',
	/**
	 * Enable Quote Creation Version V2
	 *
	 * Owner/Requester: anjaisw
	 * Good Until: Unknown
	 */
	quoteVersionV2 = 'quoteVersionV2',
	/**
	 * Enable compressed quote responses
	 *
	 * Owner/Requester: Manikuttan Sivadas
	 * Good Until: Unknown
	 */
	enableCompressedQuoteResponse = 'enableCompressedQuoteResponse',
	/**
	 * Adding new features for MCA-E Ramped Discounting Assets work
	 *
	 * Owner/Requester: mrjha
	 * Good Until: Unknown
	 */
	quoteRampedAssets = 'quoteRampedAssets',
	/**
	 * Adding new features for MCA-E Renewals work
	 *
	 * Owner/Requester: simranpujji
	 * Good Until: unknown
	 */
	quoteRenewals = 'quoteRenewals',
	/**
	 * Show subscription data from billingRP instead of CommerceCache
	 *
	 * Owner/Requester: simranpujji
	 * Good Until: unknown
	 */
	quoteRenewalsBillingRP = 'quoteRenewalsBillingRP',
	/**
	 * Use mock data for MCA-E Renewals API calls
	 *
	 * Owner/Requester: harryhtet
	 * Good Until: unknown
	 */
	quoteRenewalsMockData = 'quoteRenewalsMockData',
	/**
	 * Enable sorting for quotes list to fix Global/Fairfax endpoint ordering
	 */
	quotesListSorting = 'quotesListSorting',
	/**
	 * Enable sorting for all columns (Name, Deal ID, Opportunity, Status) in the quotes list
	 */
	quotesListAllColumnsSorting = 'quotesListAllColumnsSorting',
	//#endregion

	//#region R
	/**
	 * Refactor IsDirectCommercial
	 * Owner/Requester: Can
	 * Good Until: 1 month after release
	 */
	refactorIsDirectCommercial = 'refactorIsDirectCommercial',
	/**
	 * Use refetch after AddBillingGroup mutation instead of update cache
	 *
	 * Owner/Requester: jejungk
	 * Good Until: done testing (Oct 2024)
	 */
	refetchAfterBg = 'refetchAfterBg',
	/**
	 * Removal of Cross Cloud (21v & Gov)
	 *
	 * Owner/Requester: simranpujji
	 * Good Until: unknown
	 */
	removalOfCrossCloud = 'removalOfCrossCloud',
	/**
	 * Remove display of discounts on product details pane
	 *
	 * Owner/Requester: Hongyu
	 * Good Until: a month after release
	 */
	removeDisplayOfDiscounts = 'removeDisplayOfDiscounts',
	/**
	 * Removes the z-index from the header row
	 *
	 * Owner/Requester: Harry
	 * Good Until: Unknown
	 */
	removeHeaderRowZIndex = 'removeHeaderRowZIndex',
	/**
	 * Removes the "All savings plans" meta option from ACD configuration,
	 * showing only individual savings plan checkboxes instead
	 *
	 * Owner/Requester: sudonthineni
	 * Good Until: Unknown
	 */
	removeAllSavingsPlanOption = 'removeAllSavingsPlanOption',
	/**
	 * Restricts the Add on validation to only add on skus
	 *
	 * Owner/Requester: Harish Evuri
	 * Good Until: Unknown
	 */
	restrictAddOnValidationToAddOnSkus = 'restrictAddOnValidationToAddOnSkus',
	/**
	 * Switches the renew to mca create proposal to the v2 version
	 *
	 * Owner/Requester: cassandraho
	 * Good Until: Unknown
	 */
	createProposalPanelV2 = 'createProposalPanelV2',
	/**
	 * Adds the market suggestion feature to the create quote panel
	 *
	 * Owner/Requester: mariamarab
	 * Good Until: Unknown
	 */
	createProposalMarketSuggestion = 'createProposalMarketSuggestion',
	/**
	 * Credit needs to be available to publish a quote
	 *
	 * Owner/Requester: Rakesh
	 * Good Until: PERMANENT - TEST ONLY
	 */
	requiredCredit = 'requiredcredit',
	/**
	 * Review and Publish Page style change
	 *
	 * Owner/Requester: Fiona
	 * Good Until: Unknow
	 * For Testing Only
	 */
	reviewAndPublishStyle = 'reviewAndPublishStyle',
	/**
	 * Enable RI Configuration Panel
	 *
	 * Owner/Requester: Can
	 * Good Until: Unknown
	 */
	riConfigurationPanel = 'riConfigurationPanel',

	rampedDiscount = 'rampedDiscount',
	/**
	 * Ramped Discount
	 *
	 * Owner/Requester: Sukanya Dutta
	 * Good Until: Unknow
	 * For Testing Only
	 */

	rampedDiscountMock = 'rampedDiscountMock',
	/**
	 * Ramped Discount Mock Data
	 *
	 * Owner/Requester: Saket Kumar Singh
	 * Good Until: Unknow
	 * For Testing Only
	 */

	/**
	 * Redirect Price Concession calls to QS API instead of configureprice api
	 *
	 * Owner/Requester: Sugubb
	 * Good Until: Unknown
	 */
	redirectConcessionPriceCallsToQS = 'redirectConcessionPriceCallsToQS',
	//#endregion

	//#region S
	/**
	 * Uses onboarded email address to create DD360 ticket, instead of user email
	 *
	 * Owner/Requestor: Jenn/Megan
	 * Good Until: PERMANENT - TEST ONLY
	 */
	safeListedBd360Requestor = 'safelistedbd360requestor',
	/**
	 * Credit check uses a safelisted organization
	 *
	 * Owner/Requester: Jason
	 * Good Until: Replace with test headers
	 */
	safelistedCreditCheck = 'safelistedcreditcheck',
	/**
	 * Creates a sandbox organization
	 *
	 * Owner/Requester: Vineetha
	 * Good Until: Unknown
	 */
	sandboxOrganizationCreation = 'sandboxOrganizationCreation',
	/**
	 * Enforce Sandbox accouts for E2E Testing
	 *
	 * Owner/Requester: Sugubb
	 * Good Until: Unknown
	 */
	sandboxAccountsEnforceForE2ETesting = 'sandboxAccountsEnforceForE2ETesting',
	/**
	 * Save API Response to InMemory Cache
	 *
	 * Owner/Requester: Manshu
	 * Good Until: Unknown
	 * This flight is for lower environments(not for Prod and Insider) to save the API response to in memory cache
	 * */
	saveAPIResponseToBlobCache = 'saveAPIResponseToBlobCache',
	/**
	 * Enables Scheduled Events for Subscriptions
	 *
	 * Owner/Requester: Megha
	 * Good Until: Unknown
	 */
	scheduledEvents = 'scheduledEvents',
	/**
	 * Using Mock data for Upcoming Expiration
	 *
	 * Owner/Requestor: Keshav
	 *  Good Until: Unknown
	 */
	scheduledEventsMock = 'scheduledEventsMock',
	/**
	 * Scheduled Mid-Term Upgrade for Subscriptions
	 *
	 * Owner/Requestor: ramatta
	 *  Good Until: Unknown
	 */
	scheduleMidTermUpgrade = 'scheduleMidTermUpgrade',
	/**
	 * Scheduled Mid-Term Upgrade Mocks
	 *
	 * Owner/Requestor: ramatta
	 *  Good Until: Unknown
	 */
	scheduleMidTermUpgradeMock = 'scheduleMidTermUpgradeMock',
	/**
	 * Schedule Mid-Term Upgrade for US Gov
	 *
	 * Owner/Requestor: v-sanmali
	 * Good Until: Unknown
	 */
	scheduleMidTermUpgradeUSGOV = 'scheduleMidTermUpgradeUSGOV',
	/**
	 * Use longer axios timeout for searchByMeterId
	 *
	 * Owner/Requester: Harry
	 * Good Until: TBD
	 */

	searchByMeterIdLongerTimeout = 'searchByMeterIdLongerTimeout',
	/**
	 * Enables user to specify a seat cap on a discounted subscription or future price/discount
	 *
	 * Owner/Requester: Swarnali
	 * Good Until: Unknown
	 */
	seatCap = 'seatCap',
	/**
	 * seat cap mock on a discounted subscription or future price/discount
	 *
	 * Owner/Requester: Sugubb
	 * Good Until: Unknown
	 */
	seatCapMock = 'seatCapMock',
	/**
	 * Make sequential calls of Download Shared Meters GQL calls
	 *
	 * Owner/Requester: Harry
	 * Good Until: TBD
	 */
	sequenceDownloadSharedMetersGql = 'sequenceDownloadSharedMetersGql',
	/**
	 * Migrate Service Desk API to v3
	 *
	 * Owner/Requester: Mariam Arab
	 * Good Until: A month after release - 02/15/2024
	 */
	/**
	 * Simulate credit check to get null
	 *
	 * Owner/Requester:Vijay
	 * Good Until: Unknown
	 */
	simulateCreditCheckNull = 'simulateCreditCheckNull',
	/**
	 * Simulate credit check to get manual cancelled
	 *
	 * Owner/Requester: cassandraho
	 * Good Until: Unknown
	 */
	simulateCreditCheckManualCancelled = 'simulateCreditCheckManualCancelled',
	/**
	 * Simulate credit check to get manual rejected
	 *
	 * Owner/Requester: cassandraho
	 * Good Until: Unknown
	 */
	simulateCreditCheckManualRejected = 'simulateCreditCheckManualRejected',
	/**
	 * Simulate credit check to get manual review
	 *
	 * Owner/Requester: cassandraho
	 * Good Until: Unknown
	 */
	simulateCreditCheckManualReview = 'simulateCreditCheckManualReview',
	/**
	 * Simulate credit check to get pending no credit
	 *
	 * Owner/Requester: cassandraho
	 * Good Until: Unknown
	 */
	simulateCreditCheckPendingNoCredit = 'simulateCreditCheckPendingNoCredit',
	/**
	 * Simulate credit check to get pending review
	 *
	 * Owner/Requester: cassandraho
	 * Good Until: Unknown
	 */
	simulateCreditCheckPendingReview = 'simulateCreditCheckPendingReview',
	/**
	 * Simulate tradeScreen status to get need screening
	 *
	 * Owner/Requester:Vijay
	 * Good Until: Unknown
	 */
	simulateTradeStatusNeedScreening = 'simulateTradeStatusNeedScreening',
	/**
	 * Show Date Is In The Past Error For Shared Discount
	 * Owner/Requester: Can
	 * Good Until: Unknown
	 */
	showDateIsInThePastErrorForSharedDiscount = 'showDateIsInThePastErrorForSharedDiscount',
	/**
	 * Enables Software Subscriptions feature
	 *
	 * Owner/Requester: jejungk
	 * Good Until: Release tenatively July 2024 - task.ms/49474376
	 */
	softwareSubs = 'softwareSubs',
	/**
	 * Enables TrueUp amendment mock data for Software Subscriptions
	 *
	 * Owner/Requester: Testing
	 * Good Until: Testing only
	 */
	softwareRPTrueUpMock = 'softwareRPTrueUpMock',
	/**
	 * Enables sovereign cloud renewal policy governance.
	 * For Delos (Germany) cloud: hides auto-renew option for license-based products.
	 *
	 * Owner/Requester: samkaushik
	 * Good Until: Testing
	 */
	sovereignCloudRenewalPolicy = 'sovereignCloudRenewalPolicy',
	/**
	 * Enables sovereign cloud purchase governance.
	 * For Delos (Germany) cloud license-based (Passes) products:
	 *  - FR1: restricts subscription start dates to the 1st of a future month (no backdating).
	 *
	 * Owner/Requester: samkaushik
	 * Good Until: Testing
	 */
	sovereignPurchaseGovernanceForDelos = 'sovereignPurchaseGovernanceForDelos',
	/**
	 * Enables combined availability token generation for V1 future discount/promo redemption.
	 * Required for AGC (USGov) cross-cloud hydration fix.
	 *
	 * Owner/Requester: samkaushik
	 * Good Until: Testing
	 */
	combinedAvailabilityTokenForPromotions = 'combinedAvailabilityTokenForPromotions',
	/**
	 * Enables Future Discounting for Software Subscriptions
	 *
	 * Owner/Requester: jejungk
	 * Good Until: Release sometime after July 2024 - task.ms/51210056 and task.ms/51210082
	 */
	swSubFutureDiscounts = 'swSubFutureDiscounts',
	/**
	 * Enables co-terming for Software Subscriptions
	 *
	 * Owner/Requester: swarnalidey
	 * Good Until: Unknown
	 */
	swSubCoterm = 'swSubCoterm',
	/**
	 * Co-terming Software Subscriptions using mock data
	 *
	 * Owner/Requester: swarnalidey
	 * Good Until: Unknown
	 */
	swSubCotermMockData = 'swSubCotermMockData',
	/**
	 * True-up Software Subscriptions
	 *
	 * Owner/Requester: nebagla
	 * Good Until: Unknown
	 */
	swSubTup = 'swSubTup',
	/**
	 * Discoverability and configuration of service speficic credits (SSC) and contingent service specific credits (CSSC)
	 *
	 * Owner/Requester: Julie/Manisha/Jenn
	 * Good Until: Unknown
	 */
	ssc = 'ssc',
	/**
	 * Enable the ability to create proposal with service specific credits (SSC) context, which includes new SSC line item and changes to quote calculation and quote details to accommodate SSCs
	 *
	 * Owner/Requester: Imran/Chaitri
	 * Good Until: Unknown
	 */
	sscaco = 'sscaco',
	/**
	 * This enables the ability to create Legacy proposal alone with service speficic credits (SSC) context
	 *
	 * Owner/Requester: Julie/Vijay
	 * Good Until: Unknown
	 */
	sscLegacy = 'sscLegacy',
	/**
	 * Enable standard acceleration for reference line item.
	 *
	 * Owner/Requester: Anurag
	 * Good Until: Unknown
	 */
	standardAcceleration = 'standardAcceleration',
	/**
	 * Enable opitimized load of data under subscription management
	 *
	 * Owner/Requester:
	 * Good Until:
	 */
	subscriptionLoadOptimization = 'subscriptionLoadOptimization',
	/**
	 * Allows future start date for subscription management
	 *
	 * Owner/Requester: Nanor/Tiffany
	 * Good Until: a month after release
	 */
	subscriptionManagementFutureStartDate = 'subscriptionManagementFutureStartDate',
	/**
	 * Enable wizard experience for Subscription Update + Configuration
	 *
	 * Owner/Requester: Harry/Tiffany
	 * Good Until: a month after release
	 */
	subscriptionWizard = 'subscriptionWizard',
	/**
	 * Enable panel experience for submit proposal
	 *
	 * Owner/Requester: mariamarab
	 * Good Until: a month after release
	 */
	submitProposalPanelEnabled = 'submitProposalPanelEnabled',
	/**
	 * Removes Selected Approver count check
	 *
	 * Owner/Requester: aryankarkra
	 * Good Until: TEST ONLY
	 */
	submitProposalPanelRemoveApproverCount = 'submitProposalPanelRemoveApproverCount',
	/**
	 * Enables structured UI telemetry for proposal lifecycle events (create, submit, publish).
	 * Events flow to Application Insights customEvents table, queryable via Kusto.
	 *
	 * Owner/Requester: prak
	 * Good Until: Unknown
	 */
	proposalTelemetry = 'proposalTelemetry',
	//#endregion
	//#region T
	/**
	 * Removes tenantAdmin call
	 *
	 * Owner/Requester: cassandraho
	 * Good Until: Unknown
	 */
	tenantAdminDeprecation = 'tenantAdminDeprecation',
	/**
	 * Enable dynamic configuration for term date
	 *
	 * Owner/Requester: Anurag
	 * Good Until: Unknown
	 */
	termLengthAcceleration = 'termLengthAcceleration',
	/**
	 * Allows searching of negotiated terms in the Finder
	 *
	 * Owner/Requester: Julie
	 * Good Until: PERMANENT - TEST ONLY
	 */
	termsFinderSearch = 'termsFinderSearch',
	/**
	 * Test header retention to 3 years instead of 6 months.
	 *
	 * Owner/Requester: Vijay
	 * Good Until: PERMANENT - TEST ONLY
	 */
	testHeader3YearsRetention = 'testHeader3YearsRetention',
	/**
	 * Console log flights
	 *
	 * Owner/Requester: Ozgun
	 * Good Until: PERMANENT - TEST ONLY
	 */
	TestFlight1 = 'testflight1',
	/**
	 * use test Flight to test the Token Validation changes
	 *
	 * Owner: Naveen
	 * Good Until: TEST ONLY
	 */
	testFlightMSAV1ENTRAV2 = 'testFlightMSAV1ENTRAV2',
	/**
	 * Throttle Download Shared Meters' Catalog Products Lookup call
	 *
	 * Owner/Requester: Harry
	 * Good Until: TBD
	 */
	throttleSearchByMeterId = 'throttleSearchByMeterId',
	/**
	 * Test Flight for testing changes to enable the ability to create a large quote with DFD and non-DFD products
	 */
	testLargeQuoteDFDNONDFD = 'testLargeQuoteDFDNONDFD',
	/**
	 * Re-architure covert to custom term button
	 *
	 * Owner/Requester: vchayammagar
	 * Good Until: Until Terms fragment gets build
	 */
	termsHarmonyConvertButton = 'termsHarmonyConvertButton',
	//#endregion
	/**
	 * Adding new features for MCA-E Unified for Partners work
	 *
	 * Owner/Requester: nebagla
	 * Good Until: December 2026
	 */
	unifiedForPartners = 'unifiedForPartners',
	/**
	 * Using Mock data for Upcoming Expiration
	 *
	 * Owner/Requestor: Keshav
	 *  Good Until: Unknown
	 */
	upcomingExpirationMock = 'upcomingExpirationMock',
	/**
	 * Use AAD Auth For Project calls
	 *
	 * Owner/Requestor: vrachamallu
	 * Good Until: TBD
	 */
	useAADForProjects = 'useAADForProjects',
	/**
	 * Use AAD Auth For Recipient calls
	 *
	 * Owner/Requestor: vrachamallu
	 * Good Until: TBD
	 */
	useAADForRecipients = 'useAADForRecipients',
	/**
	 * Fetch cached product data from storage account blob
	 *
	 * Owner/Requestor: Hongyu
	 * Good Until: Validation complete
	 */
	useBlobForCatalogCaching = 'useBlobForCatalogCaching',
	/**
	 * Routes Commerce Agent chat to the UAT Uber Orchestrator endpoint instead of DEV.
	 *
	 * Owner/Requester: aryankarkra
	 * Good Until: Commerce Agent UAT validation complete
	 */
	useCommerceAgentUat = 'useCommerceAgentUat',
	/**
	 * New logic to determine the maximum limit for custom terms.
	 *
	 * Owner/Requester: anuragkumar
	 * Good Until: March 2025
	 */
	useCustomTermLimit = 'useCustomTermLimit',
	/**
	 * Enables the use of find and retrieve apis for auto-complete address.
	 * Owner/Requester: arpitagarwal
	 * Good Until: unknown
	 */
	useFindAndRetrieveForAutoCompleteAddress = 'useFindAndRetrieveForAutoCompleteAddress',
	/**
	 * Use new 1PA Scope for EA Admin
	 *
	 * Owner/Requestor: Ritesh
	 * Good Until: Validation complete
	 */
	useNewEAAdminScope = 'useNewEAAdminScope',
	/**
	 * Uses fluent panel for Azure Plan
	 *
	 * Owner/Requestor: Harry
	 * Good Until: After repo migration to Harmony SolidJS
	 */
	useFluentPanelForAzurePlan = 'useFluentPanelForAzurePlan',
	/**
	 * Uses fluent panel for ACD
	 * Owner/Requestor: Harry
	 * Good Until: After repo migration to Harmony SolidJS
	 */
	useFluentPanelForACD = 'useFluentPanelForACD',
	/**
	 * Uses fluent panel for Discount configuration
	 * Owner/Requestor: Harry
	 * Good Until: After repo migration to Harmony SolidJS
	 */
	useFluentPanelForDiscountConfig = 'useFluentPanelForDiscountConfig',
	/**
	 * Uses fluent panel for Meters
	 * Owner/Requestor: Hongyu
	 * Good Until: After repo migration to Harmony SolidJS
	 */
	useFluentPanelForMeters = 'useFluentPanelForMeters',
	/**
	 * Uses fluent panel for Modern Office
	 * Owner/Requestor: Harry
	 * Good Until: After repo migration to Harmony SolidJS
	 */
	useFluentPanelForModernOffice = 'useFluentPanelForModernOffice',
	/**
	 * Uses fluent panel for Monetary
	 * Owner/Requestor: Harry
	 * Good Until: After repo migration to Harmony SolidJS
	 */
	useFluentPanelForMonetary = 'useFluentPanelForMonetary',
	/*
	 * Uses non-dfd schema for all sales motion and all Azure RI product, PCD having both purchase and renew action.
	 * Owner/Requestor: Manshu
	 * Good Until: TBD
	 */
	useNonDFDForRIProduct = 'useNonDFDForRIProduct',
	/**
	 * Uses node workers to parse large product data in parallel
	 *
	 * Owner/Requestor: Mariam
	 * Good Until: TBD
	 */
	/**
	 * Adds programCode to quote for Direct-Commercial quote
	 * Tells GQL to use template info returned by Quotes service
	 *
	 * Owner/Requestor: Jenn/Jason Schneider
	 * Good Until: TBD
	 */
	useQuoteProgramCode = 'useQuoteProgramCode',
	/**
	 * Uses the duration, enddate, and startDate values straight off of the quote line item
	 *
	 * Owner/Requestor: Manisha
	 * Good Until: TBD
	 */
	useRawDateAndDurationValues = 'useRawDateAndDurationValues',
	/**
	 * Owner/Requester: Lavina Sanghvi
	 * Good Until: Unknown
	 */
	useQSProd = 'useQSProd',
	/**
	 * Use term description for commitment dropdown to display term duration value
	 *
	 * Owner/Requestor: manshulnu
	 * Good Until: TBD
	 */
	useTermComponentDescriptionForCommitment = 'useTermComponentDescriptionForCommitment',
	/**
	 * Use US Gov headers for BigCat calls
	 *
	 * Owner/Requestor: vrachamallu
	 * Good Until: TBD
	 */
	useUSGovHeadersForBigCat = 'useUSGovHeadersForBigCat',
	/**
	 * Owner/Requester: Lavina Sanghvi
	 * Good Until: Us gov, us sec , us Nat changes
	 */
	usGovTerm = 'usGovTerm',
	/**
	 * Uses FIC as credential in backend to acquire token from 1PA instead of certificate.
	 *
	 * Owner/Requestor: Navya Jeevan
	 * Good Until: TBD
	 */
	use1PAFIC = 'use1PAFIC',
	/**
	 * Useing mock data for UFP.
	 *
	 * Owner/Requestor: sokushwaha
	 * Good Until: TBD
	 */
	ufpMockData = 'ufpMockData',
	//#endregion

	//#region V
	/**
	 * For checking ECIF Amount validation.
	 *
	 * Owner/Requester: Lavina Sanghvi
	 * Good Until: Unknown
	 */
	validPurchaseTermUnits = 'validPurchaseTermUnits',
	/**
	 * Add test header to scan virus via MSDefender
	 *
	 * Owner/Requester: Neha/Harry
	 * Release date: 05/07
	 */
	virusScanTestHeader = 'virusScanTestHeader',
	/**
	 * Display VPN message in standalone, when not in AirCapi
	 *
	 * Owner/Requester: Jesus
	 * Release date: TBD
	 */
	vpnMessageBar = 'vpnMessageBar',
	useMIForUSGovAadGraph = 'useMIForUSGovAadGraph',
	useProdApp = 'useProdApp',
	useFICForAccountExtensions = 'useFICForAccountExtensions',
	eaToMcae = 'eaToMcae',
	/**
	 *
	 *
	 * Owner/Requester:
	 * Good Until: Unknown
	 */

	// Switch between old and new Tax message in dialog.
	useNewTaxIdMessage = 'useNewTaxIdMessage',
	/**
	 * Adding new features for MCA-E Tranche work
	 *
	 * Owner/Requester: aditinarang
	 * Good Until: December 2026
	 */
	tranche = 'tranche',
	tranchePostCall = 'tranchePostCall',
	billingProfileCloud = 'billingProfileCloud',
	/**
	 * Enable Sync button when line items are added via Subscription Management
	 *
	 * Owner/Requester: aditinarang
	 * Good Until: December 2026
	 */
	trancheSubscriptionList = 'trancheSubscriptionList',
	modernAccountOrg = 'modernAccountOrg',
	globalTaxId = 'globalTaxId',
	taxIdMetadataApi = 'taxIdMetadataApi',
	aircapiDefaultTenantType = 'aircapiDefaultTenantType',
	aiAutonomous = 'aiAutonomous',
	aiSmbPermissionCheck = 'aiSmbPermissionCheck',
	/**
	 * Validates lead organization has an active signed agreement before publish
	 *
	 * Owner/Requester: aryankarkra
	 * Good Until: December 2026
	 */
	MEPenableMultiTenantLeadAgreementSignedValidation = 'MEPenableMultiTenantLeadAgreementSignedValidation',
	/**
	 * Enables the AI ChatBot (VLC GHCP Assistant) floating button
	 *
	 * Owner/Requester: tanishkgupta
	 * Good Until: Unknown
	 */
	aiChatBot = 'aiChatBot',
	/**
	 * Renders the AI ChatBot as a full-page window instead of the docked side panel
	 *
	 * Owner/Requester: aryankarkra
	 * Good Until: Unknown
	 */
	fullPageAiChatBot = 'fullPageAiChatBot',
	searchUfp = 'searchUfp',
	isSubmitApprovalSkip = 'isSubmitApprovalSkip',
	/**
	 * Use UPN to derive term ID and availability ID during reconfiguration
	 * to prevent mismatch when BigCat rotates IDs.
	 *
	 * Owner/Requester: Shreyas
	 * Good Until: Month after prod release
	 */
	useUpnForTermResolution = 'useUpnForTermResolution',
	/**
	 * Kill-switch that deprecates the UI-driven flight resolution pipeline.
	 * When ON, the UI relies exclusively on the values returned by the
	 * GraphQL `getFlightsV2` query and stops sending the `flights` request
	 * header on outgoing GraphQL operations. Local defaults, LocalStorage
	 * caches, URL overrides, and `forceEnableInEnvs` are all bypassed.
	 *
	 * Effective in EVERY environment — turn it ON in Control Tower for a
	 * given environment (Latest/Stable/Prod/etc.) and the new behavior takes
	 * over there; turn it OFF and the legacy behavior is preserved
	 * byte-for-byte.
	 *
	 * When OFF (default), behavior is unchanged: defaults + URL/forceEnable
	 * overrides + LocalStorage caches are merged with the server response,
	 * and the `flights` header continues to be sent.
	 *
	 * This flight is itself read from the most recent successful
	 * `getFlightsV2` response (via the `localflights` cache for boot), with a
	 * safe fallback of OFF so that the rollout and rollback are non-breaking.
	 *
	 * Owner/Requester: PMW Platform
	 * Good Until: After backend-driven flights migration is fully rolled out
	 */
	deprecateUIDrivenFlights = 'deprecateUIDrivenFlights',

	//#endregion

	//#region W
	/**
	 * Enables the redesigned Withdraw proposal confirmation dialog with a
	 * dedicated deal-impact warning message bar and a separated trailing
	 * confirmation question. When OFF, the legacy single-paragraph copy is
	 * used.
	 * Owner/Requester: Prasanna
	 * Good Until: After production rollout and stabilization
	 */
	multiTenantProposalsWithdrawRedesign = 'multiTenantProposalsWithdrawRedesign',
	/**
	 * Controls visibility of the What's New page and entry points.
	 *
	 * Owner/Requester: Unknown
	 * Good Until: Unknown
	 */
	whatsNew = 'whatsNew',
	//#endregion

	//#region X
	//#endregion

	//#region Y
	//#endregion

	//#region Z
	//#endregion
}

// Any flights enabled here will override control tower
export const productionFlights: Record<Flight, boolean> = {
	//#region Temporary Flights
	// --- Temporary Flights: Remove after a month in Production ---------
	// Please update 'Good Until' date above when turning a flight ON to track cleanup
	[Flight.AADTenants]: true,
	[Flight.accountExtensionsOrgSearchMoreResults]: false,
	[Flight.addOnMaxPurchaseInfo]: false,
	[Flight.aiAutonomous]: true,
	[Flight.aiSmbPermissionCheck]: true,
	[Flight.MEPenableMultiTenantLeadAgreementSignedValidation]: true,
	[Flight.aiChatBot]: false,
	[Flight.fullPageAiChatBot]: false,
	[Flight.allowEndDateWithoutStartDateForAzureCommitmentDiscount]: false,
	[Flight.approvalCommentsVisibleOnSubmit]: false,
	[Flight.enableApproverSearchSelection]: true,
	[Flight.approveOnBehalfFix]: false,
	[Flight.assetEvents]: false,
	[Flight.parentbillingAcountId]: false,
	[Flight.assetFilters]: true,
	[Flight.assetPanelUxChanges]: false,
	[Flight.azureSupportConfigFlyInPanel]: false,
	[Flight.azuregovforcommercialcustomers]: false,
	[Flight.azuregovforcommercialcustomersUSGov]: false,
	[Flight.acoStartEndDateFairFax]: false,
	[Flight.acoStartEndDateAirGapped]: false,
	[Flight.addTenantIdOnQuote]: false,
	[Flight.addOnBehalfOfToCatalog]: false,
	[Flight.allowUnspecifiedOptionInLocationFilters]: true,
	[Flight.backdatelateRenewalsTest]: false,
	[Flight.baSearchExperience]: false,
	[Flight.batchOrganizationLoad]: false,
	[Flight.dedupeAadOrganizationCall]: false,
	[Flight.batchOrgAgreementLoad]: false,
	[Flight.dedupeGetQuoteLoad]: false,
	[Flight.propertiesTabDedupe]: false,
	[Flight.billingProfileForDiscounts]: false,
	[Flight.billingProfileForDiscountsForObx]: false,
	[Flight.billingProfileForDiscountsForRockCreek]: false,
	[Flight.billingProfileChina21V]: false,
	[Flight.billingRPAssetMigration]: false,
	[Flight.bulkImportV1]: false,
	[Flight.asyncProductExport]: false,
	[Flight.breadcrumbs]: false,
	[Flight.flexSpendPlan]: false,
	[Flight.flexSpendPlanQuotability]: false,
	[Flight.ciSearchExperience]: true,
	[Flight.caco]: true,
	[Flight.chatbot]: false,
	[Flight.creditCheck]: true,
	[Flight.conditionalACOLive]: true,
	[Flight.canCancelAsset]: false,
	[Flight.cancelExistingACOMock]: false,
	[Flight.cloneProposal]: false,
	[Flight.cloneProposalAgent]: false,
	[Flight.cloneProposalVersionV2]: false,
	[Flight.configurableConversionWindows]: false,
	[Flight.convertDatesToISOStringOnBulkDiscount]: true,
	[Flight.normalizeDiscountDatesToSeconds]: true,
	[Flight.convergence]: false,
	[Flight.cotermWithLineItemFromProposal]: true,
	[Flight.cotermWithLineItemFromProposalMockData]: false,
	[Flight.csatFeedback]: true,
	[Flight.csatAuthMigration]: true,
	[Flight.csatFloodgate]: true,
	[Flight.cwaAgreementRevamp]: true,
	[Flight.cwaAgreementRevampMock]: false,
	[Flight.cwaOverviewTabRevamp]: true,
	[Flight.cwaDebug]: false,
	[Flight.cwaDirectCommercialFilterCI]: false,
	[Flight.cwaCacheService]: false,
	[Flight.cwaCaco]: true,
	[Flight.cwaCacoActualProductData]: false,
	[Flight.cwaCacoMock]: false,
	[Flight.cwaSsCaco]: true,
	[Flight.cwaEst]: true,
	[Flight.cwaSsCacoMock]: false,
	[Flight.cwaEcif]: true,
	[Flight.cwaEcifMock]: false,
	[Flight.cwaEnterpriseSupportPhase2]: false,
	[Flight.cwaEnterpriseSupportPhase2Mock]: false,
	[Flight.cwaEvidenceOfSignature]: true,
	[Flight.cwaEvidenceOfSignatureMock]: false,
	[Flight.cwaExpiringProposalsViewAllFilter]: true,
	[Flight.cwaControlPanel]: true,
	[Flight.cwaLateRenewals]: true,
	[Flight.cwaLsaClpView]: false,
	[Flight.cwaLsaClpViewMock]: false,
	[Flight.cwaLsaAssociatedPurchases]: false,
	[Flight.cwaMaccMilestone]: true,
	[Flight.cwaMaccMilestoneMock]: false,
	[Flight.cwaMultiEntitySupport]: false,
	[Flight.cwaMultiEntitySupportMock]: false,
	[Flight.cwaMultiMaccContriEntity]: false,
	[Flight.cwaOverviewTabTableRevamp]: true,
	[Flight.cwaPlannedAccounts]: false,
	[Flight.cwaScheduledMidTermUpgrades]: false,
	[Flight.cwaShortfallPostPaidAllowZero]: false,
	[Flight.cwaShortfallPanelChanges]: false,
	[Flight.cwaShortfallRefetchingQuote]: true,
	[Flight.cwaSkipBillingAccountForProposal]: true,
	[Flight.cwaSpecialBillingPlan]: true,
	[Flight.cwaTaco]: true,
	[Flight.cwaTrueUp]: false,
	[Flight.cwaTrueUpMock]: false,
	[Flight.cwaTacoMock]: false,
	[Flight.cwaTelemetry]: false,
	[Flight.cwaTenantAccountCheck]: true,
	[Flight.cwaUpcomingExpirationTabNew]: true,
	[Flight.cwaUnifiedForPartners]: true,
	[Flight.cwaUnifiedForPartnersMock]: false,
	[Flight.cwaRemoveLogs]: false,
	[Flight.cwaRightNowTab]: true,
	[Flight.cwaConcessionSearch]: true,
	[Flight.cwaConcessionPrefetch]: false,
	[Flight.dateDiscrepancyBug]: false,
	[Flight.dealTotalityBenefitsOnQuote]: true,
	[Flight.deletedTenantCheck]: false,
	[Flight.deduplicateProductIdsOnMultiSelect]: false,
	[Flight.delaySearchByMeterId]: false,
	[Flight.disableSagasAndEpics]: true,
	[Flight.fixAccidentalShowingOfAllDiscountsAddedInSharedDiscountPanel]: true,
	[Flight.graphAuthorizationUsingQCApp]: true,
	[Flight.graphToCreateSPNUsingQCApp]: false,
	[Flight.demoMode]: false,
	[Flight.directComNonDFD]: true,
	[Flight.directFGOE]: false,
	[Flight.directGov]: false,
	[Flight.directGovNonDFD]: true,
	[Flight.doNotUpdateLineItemRecipientAndAssetTo]: true,
	[Flight.downloadPDFConvertChanges]: false,
	[Flight.docuSignV1]: true,
	[Flight.docuSignV2]: false,
	[Flight.dualProduct]: true,
	[Flight.dualUseRightsForFromSA]: true,
	[Flight.ecifModifyCancelFlight]: true,
	[Flight.enterpriseSupportCommit]: false,
	[Flight.enterpriseSupportCommitMacc]: false,
	[Flight.enterpriseSupportMultiEntity]: false,
	[Flight.ecifAmendmentFlight]: false,
	[Flight.usGovEcifModifyFlight]: false,
	[Flight.eeaSettlement]: false,
	[Flight.e2Fragments]: false,
	[Flight.e2Router]: true,
	[Flight.enableApolloRequestInspectorClientFilters]: false,
	[Flight.enableCacheVersionNine]: true,
	[Flight.enableCacheWorkerPool]: false,
	[Flight.multiTenantProposals]: true,
	[Flight.MEPdealDetachmentOnBillingAccountChange]: true,
	[Flight.mepForLargeQuotes]: true,
	[Flight.multiTenantProposalsOboEnablement]: true,
	[Flight.multiTenantProposalsOboPerProposalEligibility]: true,
	[Flight.enableDetailsPaneLabelGrid]: false,
	[Flight.enableEaEnrollmentProtected]: true,
	[Flight.enableMetersLineItem]: false,
	[Flight.usePreferredCommunicationLanguages]: false,
	[Flight.enableQuickLookupForSharedMeters]: false,
	[Flight.enableTAXIDForAllMarket]: false,
	[Flight.enableServiceDeskAttachment]: true,
	[Flight.enableTestProducts]: false,
	[Flight.endDateAdjustment]: false,
	[Flight.endDateForImmediateConversion]: false,
	[Flight.enterpriseSupportPhase2Cancellation]: false,
	[Flight.enterpriseSupportRPDuplicateCancellation]: false,
	[Flight.eurozoneCurrencyException]: true,
	[Flight.esGraduatedPricingOnlyForAzure]: true,
	[Flight.estsrRegionAutodetect]: true,
	[Flight.est]: true,
	[Flight.gateProductFilteredSkus]: false,
	[Flight.estLookupOptimization]: false,
	[Flight.estSingleSkuLookup]: false,
	[Flight.subscriptionAssetTargetEstLookup]: false,
	[Flight.expiryBanner]: false,
	[Flight.estBackdatedFlows]: true,
	[Flight.estPartialConvertIntent]: false,
	[Flight.pagination]: true,
	[Flight.estMock]: false,
	[Flight.enableAzurePromos]: false,
	[Flight.enableNceDailyInvoicing]: true,
	[Flight.azurePromoMockData]: false,
	[Flight.enableStampConfigV2]: false,
	[Flight.enableQCSMigrationwith1PADD360]: false,
	[Flight.enableQcOptimizations]: true,
	[Flight.enableFragmentdProductReadForOptimization]: true,
	[Flight.enableDD360AttachmentGQL]: false,
	[Flight.fairfaxBillingProfile]: true,
	[Flight.filterNoSkuNoAvailabilityProducts]: false,
	[Flight.fixQuoteWithExpiredAvailabilities]: false,
	[Flight.globalTaxId]: true,
	[Flight.taxIdMetadataApi]: false,
	[Flight.gsmProject]: false,
	[Flight.guidedTour]: false,
	[Flight.hiddenOffers]: false,
	[Flight.hiddenOffersMockData]: false,
	[Flight.hiddenOffersPriceListMockData]: false,
	[Flight.hideSharedMeters]: false,
	[Flight.hideAffiliateFedGov]: false,
	[Flight.hideUnconfiguredProductConfigDetails]: true,
	[Flight.infoSummaryCards]: true,
	[Flight.indirectComChinaNonDFD]: true,
	[Flight.indirectComCSPNonDFD]: true,
	[Flight.indirectGovNonDFD]: true,
	[Flight.indirectPartnerCustomerFootprintRetry]: true,
	[Flight.largeQuote1]: false,
	[Flight.lazyLoadProductFilters]: false,
	[Flight.leadAffiliate]: true,
	[Flight.legacyNonDFD]: true,
	[Flight.limitBillingAccountByMarket]: false,
	[Flight.loadMinimumRequiredPagesForSharedDiscount]: false,
	[Flight.nonAzureSharedDiscounts]: false,
	[Flight.excludeIneligibleSharedDiscounts]: true,
	[Flight.lq1Arbitration]: false,
	[Flight.lppSubPriceConfigurePanel]: false,
	[Flight.lq1ForSubmit]: false,
	[Flight.lq1ForQS]: false,
	[Flight.lppDownloadQuotePdf]: false,
	[Flight.lppUseBillingScheduleAPI]: false,
	[Flight.lppProductsList]: false,
	[Flight.proposalPagePerfV1]: true,
	[Flight.lppCustomFormatSubtotalColumn]: false,
	[Flight.maccMilestone]: true,
	[Flight.maccMilestoneEndDateValidation]: false,
	[Flight.lsa]: false,
	[Flight.lsaMockData]: false,
	[Flight.lsaBillingRPAgreement]: false,
	[Flight.lsaBRPdebug]: false,
	[Flight.lsaStartDateEnabled]: false,
	[Flight.lsaDerivedOfferCoterm]: false,
	[Flight.lsaTrueupRedesign]: false,
	[Flight.lsaTrueupRedesignMockData]: false,
	[Flight.lsaVirtualBundles]: false,
	[Flight.lsaVirtualBundlesNewUI]: false,
	[Flight.lockProposal]: true,
	[Flight.maccModifyCancelPanelCWA]: false,
	[Flight.modernAccountOrg]: true,
	[Flight.eaToMcaManageLineItemWizard]: true,
	[Flight.maximumSkuLimitReachedMessage]: false,
	[Flight.multiSelectTeachingBubble]: true,
	[Flight.mimTermsReordering]: false,
	[Flight.missingStandardAzurePlan]: false,
	[Flight.mutationAuth]: false,
	[Flight.newAuthFlow]: true,
	[Flight.newBillingPlans]: true,
	[Flight.nonStandardFrameworkNonDFD]: true,
	[Flight.nsptAcceptanceDateOverlapValidation]: false,
	[Flight.offlineAgreementNewFlow]: false,
	[Flight.onetimeV2]: true,
	[Flight.perUserPromotionsEnhanced]: true,
	[Flight.pricelist]: true,
	[Flight.pricelistV2Phase2A]: false,
	[Flight.pricelistV2Phase2B]: false,
	[Flight.pricelistV2Phase3]: false,
	[Flight.pricelistV2Phase3A]: false,
	[Flight.pricelistV2Phase4]: false,
	[Flight.pricelistCartAcross]: true,
	[Flight.pricelistExpandedView]: true,
	[Flight.pricelistQuoteFilters]: true,
	[Flight.pricelistFullDownload]: true,
	[Flight.pricelistDebugColumns]: false,
	[Flight.priceSheetDownload]: false,
	[Flight.productInclusionCheckerPanel]: false,
	[Flight.productSearchMoreResults]: false,
	[Flight.productSearchRemoveDuplicateResult]: true,
	[Flight.enableLatestProductSearch]: false,
	[Flight.enableLdssProductSearch]: false,
	[Flight.productSearchComparator]: false,
	[Flight.promotionProductOwnerShipFix]: false,
	[Flight.promotionsOnSubscriptionLifecycle]: false,
	[Flight.promoEligibilityViaSaaSHubRP]: false,
	[Flight.subscriptionPromoMockData]: false,
	[Flight.proposalExpirationBug]: false,
	[Flight.proposalSteps]: false,
	[Flight.proposalStatusFilter]: true,
	[Flight.proposalAttachment1P]: true,
	[Flight.qcInMSX]: false,
	[Flight.mcapiPolicy]: false,
	[Flight.qcsMigrationServiceDeskAttachment1PA]: true,
	[Flight.qsElmEnforce]: false,
	[Flight.quoteHeaderMessages]: true,
	[Flight.quoteRampedDiscounting]: false,
	[Flight.quoteVersionV2]: false,
	[Flight.enableCompressedQuoteResponse]: false,
	[Flight.quoteRampedAssets]: false,
	[Flight.quoteRenewals]: true,
	[Flight.quoteRenewalsBillingRP]: true,
	[Flight.quoteRenewalsMockData]: false,
	[Flight.quotesListSorting]: true,
	[Flight.quotesListAllColumnsSorting]: true,
	[Flight.refactorIsDirectCommercial]: false,
	[Flight.eaToMcae]: true,
	[Flight.refetchAfterBg]: false,
	[Flight.removalOfCrossCloud]: false,
	[Flight.removeAllSavingsPlanOption]: true,
	[Flight.removeDisplayOfDiscounts]: true,
	[Flight.removeHeaderRowZIndex]: false,
	[Flight.restrictAddOnValidationToAddOnSkus]: true,
	[Flight.createProposalPanelV2]: false,
	[Flight.createProposalMarketSuggestion]: false,
	[Flight.reviewAndPublishStyle]: true,
	[Flight.riConfigurationPanel]: false,
	[Flight.rampedDiscount]: true,
	[Flight.sandboxOrganizationCreation]: false,
	[Flight.sandboxAccountsEnforceForE2ETesting]: false,
	[Flight.scheduledEvents]: true,
	[Flight.scheduledEventsMock]: false,
	[Flight.scheduleMidTermUpgrade]: false,
	[Flight.scheduleMidTermUpgradeMock]: false,
	[Flight.scheduleMidTermUpgradeUSGOV]: false,
	[Flight.searchByMeterIdLongerTimeout]: false,
	[Flight.searchUfp]: true,
	[Flight.seatCap]: true,
	[Flight.seatCapMock]: false,
	[Flight.sequenceDownloadSharedMetersGql]: false,
	[Flight.showDateIsInThePastErrorForSharedDiscount]: false,
	[Flight.softwareSubs]: false,
	[Flight.softwareRPTrueUpMock]: false,
	[Flight.sovereignCloudRenewalPolicy]: false,
	[Flight.sovereignPurchaseGovernanceForDelos]: false,
	[Flight.combinedAvailabilityTokenForPromotions]: false,
	[Flight.swSubFutureDiscounts]: false,
	[Flight.swSubCoterm]: true,
	[Flight.swSubCotermMockData]: false,
	[Flight.swSubTup]: false,
	[Flight.proposalTabSwitchPerfOptimization]: false,
	[Flight.ssc]: false,
	[Flight.sscaco]: true,
	[Flight.sscLegacy]: false,
	[Flight.standardAcceleration]: false,
	[Flight.subscriptionLoadOptimization]: true,
	[Flight.subscriptionManagementFutureStartDate]: false,
	[Flight.subscriptionWizard]: false,
	[Flight.submitProposalPanelEnabled]: true,
	[Flight.submitProposalPanelRemoveApproverCount]: false,
	[Flight.proposalTelemetry]: true,
	[Flight.tranche]: true,
	[Flight.tranchePostCall]: false,
	[Flight.billingProfileCloud]: false,
	[Flight.trancheSubscriptionList]: true,
	[Flight.tenantAdminDeprecation]: false,
	[Flight.termLengthAcceleration]: false,
	[Flight.termsHarmonyConvertButton]: false,
	[Flight.testFlightMSAV1ENTRAV2]: false,
	[Flight.throttleSearchByMeterId]: false,
	[Flight.unifiedForPartners]: true,
	[Flight.upcomingExpirationMock]: false,
	[Flight.useAADForProjects]: false,
	[Flight.useAADForRecipients]: false,
	[Flight.useBlobForCatalogCaching]: true,
	[Flight.ufpMockData]: false,

	[Flight.useCommerceAgentUat]: false,
	[Flight.useCustomTermLimit]: false,
	[Flight.useFindAndRetrieveForAutoCompleteAddress]: true,
	[Flight.useNewEAAdminScope]: false,
	[Flight.useFluentPanelForAzurePlan]: true,
	[Flight.useFluentPanelForModernOffice]: true,
	[Flight.useFluentPanelForMonetary]: true,
	[Flight.useFluentPanelForACD]: true,
	[Flight.useFluentPanelForDiscountConfig]: true,
	[Flight.useFluentPanelForMeters]: false,
	[Flight.useNonDFDForRIProduct]: true,
	[Flight.useQuoteProgramCode]: false,
	[Flight.useQSProd]: false,
	[Flight.useRawDateAndDurationValues]: false,
	[Flight.useTermComponentDescriptionForCommitment]: true,
	[Flight.use1PAFIC]: false,
	[Flight.validPurchaseTermUnits]: true,
	[Flight.virusScanTestHeader]: false,
	[Flight.vpnMessageBar]: false,
	[Flight.multiTenantProposalsWithdrawRedesign]: true,
	[Flight.whatsNew]: false,
	[Flight.useMIForUSGovAadGraph]: true,
	[Flight.useProdApp]: false,
	[Flight.useFICForAccountExtensions]: true,
	[Flight.useNewTaxIdMessage]: false,
	[Flight.useUSGovHeadersForBigCat]: false,
	[Flight.usGovTerm]: false,
	[Flight.aircapiDefaultTenantType]: false,
	[Flight.isSubmitApprovalSkip]: false,
	[Flight.useUpnForTermResolution]: true,
	[Flight.deprecateUIDrivenFlights]: false,

	//#endregion
	//#region Permanent Flights
	// --- Permanent Flights: DO NOT REMOVE ---------------------
	// Generally, these flights are for test, or available to assist with specific Prod issues on an as-needed basis (ie: bulkApproveTransact)
	// Put Flights for Feature work in Temporary Flights region above
	[Flight.acoStartEndDate]: true,
	[Flight.cancelExistingAco]: true,
	[Flight.airCapi]: false, // Test-only
	[Flight.approvalOverride]: false, // Test-only
	[Flight.assignDES]: false,
	[Flight.bulkApproveTransact]: false,
	[Flight.currencyOverride]: false,
	[Flight.customTermSubscriptionLength]: false,
	[Flight.cwaByModernIds]: true,
	[Flight.disableBulkEditForPasses]: true,
	[Flight.disableOneTimeDiscountForAGC]: true,
	[Flight.disableProductInclusionFilter]: false, // Test-only
	[Flight.disableTestTermRecommendations]: true, // Test-only; ALWAYS on by default so we do not expose test products in Prod
	[Flight.displayEtagsForDebugging]: false, // Test-only
	[Flight.displayTestMCAs]: false, // Test-only; NEVER turn on by default
	[Flight.enableApolloRequestInspector]: false,
	[Flight.enableHRDDDocHold]: false, // Do not enable, only for testing HRDD Doc Hold
	[Flight.enableReferralCloseButtonForTesting]: false, // Test-only
	[Flight.enableNewVatIDs]: false,
	[Flight.enableFranceTaxIds]: true,
	[Flight.enableFranceNonCompliantTaxBanner]: true,
	[Flight.enableNonCompliantTaxBanner]: false,
	[Flight.excludeSavingsPlan]: false,
	[Flight.filterForBillingAccountOwners]: false,
	[Flight.forceFutureDiscountOptions]: false, // Test-only; NEVER turn on by default
	[Flight.fromSAEnabled]: false,
	[Flight.ignoreNonExistingQuotesOnSearchIndex]: false,
	[Flight.ignoreTestEmailValidation]: false, // Test-only; NEVER turn on by default
	[Flight.ignoreSoldToMappingPendingQuotes]: false,
	[Flight.lineItemLimitIncrease]: false, // Test-only; To be used with test headers only
	[Flight.productLineItemReorder]: false,
	[Flight.measureSharedMetersPerformance]: false, // Test-only; To use to measure some possible performance improvements NEVER turn on by default
	[Flight.noTestHeaderTesting]: false, // should always be false since is used from control tower for specific aliases. See configurations.ts for more info if you need.
	[Flight.notifDeepLink]: true,
	[Flight.obfuscateTranslations]: false, // Test-only
	[Flight.physicalSignForUkccf]: false, // Test-only
	[Flight.pidSearch]: true,
	[Flight.requiredCredit]: true, // Test-only; ALWAYS on by default so we don't skip credit requirements in Prod
	[Flight.safeListedBd360Requestor]: false, // Test-only; NEVER turn on by default
	[Flight.safelistedCreditCheck]: false, // Test-only; NEVER turn on by default
	[Flight.saveAPIResponseToBlobCache]: false, // Test-only; NEVER turn on by default
	[Flight.simulateCreditCheckNull]: false, //Test -only
	[Flight.simulateCreditCheckManualCancelled]: false, //Test -only
	[Flight.simulateCreditCheckManualRejected]: false, //Test -only
	[Flight.simulateCreditCheckManualReview]: false, //Test -only
	[Flight.simulateCreditCheckPendingNoCredit]: false, //Test -only
	[Flight.simulateCreditCheckPendingReview]: false, //Test -only+
	[Flight.simulateTradeStatusNeedScreening]: false, //Test -only
	[Flight.termsFinderSearch]: false, // Test-only
	[Flight.TestFlight1]: false, // Test-only
	[Flight.testHeader3YearsRetention]: false, // Test-only
	[Flight.testLargeQuoteDFDNONDFD]: true, // Test-only
	[Flight.rampedDiscountMock]: false, //Test-only
	[Flight.redirectConcessionPriceCallsToQS]: true, //Test-only
	[Flight.approveOnBehalfLogs]: false,
	//#endregion
};

export const latestFlights: Record<Flight, boolean> = {
	...productionFlights,
	[Flight.addOnMaxPurchaseInfo]: true,
	[Flight.allowEndDateWithoutStartDateForAzureCommitmentDiscount]: true,
	[Flight.assetEvents]: true,
	[Flight.azureSupportConfigFlyInPanel]: true,
	[Flight.breadcrumbs]: true,
	[Flight.bulkImportV1]: true,
	[Flight.asyncProductExport]: false,
	[Flight.flexSpendPlan]: false,
	[Flight.flexSpendPlanQuotability]: false,
	[Flight.deletedTenantCheck]: true,
	[Flight.disableTestTermRecommendations]: false,
	[Flight.downloadPDFConvertChanges]: false,
	[Flight.enableLatestProductSearch]: false,
	[Flight.lineItemLimitIncrease]: true,
	[Flight.largeQuote1]: true,
	[Flight.limitBillingAccountByMarket]: true,
	[Flight.lq1Arbitration]: true,
	[Flight.lq1ForSubmit]: true,
	[Flight.lq1ForQS]: true,
	[Flight.mutationAuth]: true,
	[Flight.pidSearch]: true,
	[Flight.pricelistFullDownload]: true,
	[Flight.productSearchMoreResults]: true,
	[Flight.promotionProductOwnerShipFix]: true,
	[Flight.proposalExpirationBug]: true,
	[Flight.proposalSteps]: true,
	[Flight.proposalTelemetry]: true,
	[Flight.riConfigurationPanel]: true,
	[Flight.refactorIsDirectCommercial]: true,
	[Flight.removeAllSavingsPlanOption]: true,
	[Flight.safelistedCreditCheck]: true,
	[Flight.softwareSubs]: true,
	[Flight.tenantAdminDeprecation]: true,
	[Flight.termsFinderSearch]: true,
	[Flight.TestFlight1]: true,
	[Flight.useFluentPanelForAzurePlan]: true,
	[Flight.useFluentPanelForMeters]: true,
	[Flight.useQuoteProgramCode]: true,
	[Flight.quoteHeaderMessages]: true,
	[Flight.qsElmEnforce]: true,
	[Flight.useNewEAAdminScope]: true,
	[Flight.useRawDateAndDurationValues]: true,
	[Flight.virusScanTestHeader]: true,
	[Flight.use1PAFIC]: true,
	[Flight.vpnMessageBar]: true,
	[Flight.standardAcceleration]: true,
	[Flight.termLengthAcceleration]: true,
	[Flight.testFlightMSAV1ENTRAV2]: true,
	[Flight.useMIForUSGovAadGraph]: true,
	[Flight.enableTAXIDForAllMarket]: true,
	[Flight.enableNewVatIDs]: true,
	[Flight.useNewTaxIdMessage]: true,
	[Flight.lppCustomFormatSubtotalColumn]: true,
	[Flight.lppDownloadQuotePdf]: true,
	[Flight.lppProductsList]: true,
	[Flight.proposalPagePerfV1]: true,
	[Flight.lppSubPriceConfigurePanel]: true,
	[Flight.priceSheetDownload]: true,
	[Flight.pricelistV2Phase2A]: true,
	[Flight.dateDiscrepancyBug]: true,
	[Flight.approveOnBehalfFix]: true,
	[Flight.usePreferredCommunicationLanguages]: true,
	[Flight.scheduleMidTermUpgrade]: true,
	[Flight.cwaScheduledMidTermUpgrades]: true,
	[Flight.estPartialConvertIntent]: true,
};

export const stableFlights: Record<Flight, boolean> = {
	...productionFlights,
	[Flight.addOnMaxPurchaseInfo]: true,
	[Flight.allowEndDateWithoutStartDateForAzureCommitmentDiscount]: true,
	[Flight.assetEvents]: true,
	[Flight.azureSupportConfigFlyInPanel]: true,
	[Flight.flexSpendPlan]: false,
	[Flight.flexSpendPlanQuotability]: false,
	[Flight.disableTestTermRecommendations]: false,
	[Flight.downloadPDFConvertChanges]: false,
	[Flight.lineItemLimitIncrease]: true,
	[Flight.largeQuote1]: true,
	[Flight.limitBillingAccountByMarket]: true,
	[Flight.lq1Arbitration]: true,
	[Flight.lq1ForSubmit]: true,
	[Flight.lq1ForQS]: true,
	[Flight.mutationAuth]: true,
	[Flight.pidSearch]: true,
	[Flight.productSearchMoreResults]: true,
	[Flight.promotionProductOwnerShipFix]: true,
	[Flight.refactorIsDirectCommercial]: true,
	[Flight.removeHeaderRowZIndex]: true,
	[Flight.riConfigurationPanel]: true,
	[Flight.safelistedCreditCheck]: true,
	[Flight.softwareSubs]: true,
	[Flight.tenantAdminDeprecation]: true,
	[Flight.termsFinderSearch]: false,
	[Flight.testFlightMSAV1ENTRAV2]: true,
	[Flight.TestFlight1]: true,
	[Flight.useFluentPanelForAzurePlan]: true,
	[Flight.useFluentPanelForMeters]: true,
	[Flight.useNewEAAdminScope]: true,
	[Flight.useQuoteProgramCode]: true,
	[Flight.quoteHeaderMessages]: true,
	[Flight.useRawDateAndDurationValues]: true,
	[Flight.virusScanTestHeader]: true,
	[Flight.use1PAFIC]: true,
	[Flight.vpnMessageBar]: true,
	[Flight.standardAcceleration]: true,
	[Flight.termLengthAcceleration]: true,
	[Flight.useMIForUSGovAadGraph]: true,
	[Flight.enableTAXIDForAllMarket]: true,
	[Flight.enableNewVatIDs]: true,
	[Flight.useNewTaxIdMessage]: true,
	[Flight.lppCustomFormatSubtotalColumn]: true,
	[Flight.lppDownloadQuotePdf]: true,
	[Flight.lppProductsList]: true,
	[Flight.lppSubPriceConfigurePanel]: true,
	[Flight.priceSheetDownload]: true,
	[Flight.azuregovforcommercialcustomers]: true,
	[Flight.azuregovforcommercialcustomersUSGov]: true,
	[Flight.useUSGovHeadersForBigCat]: true,
	[Flight.usGovTerm]: true,
	[Flight.pricelistV2Phase2A]: true,
	[Flight.proposalExpirationBug]: true,
	[Flight.proposalTelemetry]: true,
	[Flight.dateDiscrepancyBug]: true,
	[Flight.approveOnBehalfFix]: true,
	[Flight.usePreferredCommunicationLanguages]: true,
	[Flight.scheduleMidTermUpgrade]: true,
	[Flight.cwaScheduledMidTermUpgrades]: true,
};

export const testFlights: Record<Flight, boolean> = {
	...stableFlights,
	[Flight.breadcrumbs]: true,
	[Flight.gsmProject]: true,
	[Flight.proposalSteps]: true,
	[Flight.qsElmEnforce]: true,
	[Flight.azuregovforcommercialcustomers]: true,
	[Flight.azuregovforcommercialcustomersUSGov]: true,
	[Flight.useUSGovHeadersForBigCat]: true,
	[Flight.usGovTerm]: true,
};

export const aircapiFlights: Record<Flight, boolean> = {
	...productionFlights,
	[Flight.addOnMaxPurchaseInfo]: true,
	[Flight.aiAutonomous]: false,
	[Flight.aiSmbPermissionCheck]: false,
	[Flight.allowEndDateWithoutStartDateForAzureCommitmentDiscount]: true,
	[Flight.assetEvents]: true,
	[Flight.azureSupportConfigFlyInPanel]: true,
	[Flight.creditCheck]: false,
	[Flight.cwaTenantAccountCheck]: false,
	[Flight.disableTestTermRecommendations]: false,
	[Flight.downloadPDFConvertChanges]: false,
	[Flight.enableFranceTaxIds]: false,
	[Flight.fairfaxBillingProfile]: false,
	[Flight.lineItemLimitIncrease]: true,
	[Flight.globalTaxId]: false,
	[Flight.largeQuote1]: true,
	[Flight.leadAffiliate]: false,
	[Flight.limitBillingAccountByMarket]: true,
	[Flight.lq1Arbitration]: true,
	[Flight.lq1ForSubmit]: true,
	[Flight.lq1ForQS]: true,
	[Flight.modernAccountOrg]: false,
	[Flight.mutationAuth]: true,
	[Flight.pidSearch]: true,
	[Flight.productSearchMoreResults]: true,
	[Flight.promotionProductOwnerShipFix]: true,
	[Flight.refactorIsDirectCommercial]: true,
	[Flight.removeHeaderRowZIndex]: true,
	[Flight.riConfigurationPanel]: true,
	[Flight.safelistedCreditCheck]: true,
	[Flight.softwareSubs]: true,
	[Flight.tenantAdminDeprecation]: true,
	[Flight.termsFinderSearch]: false,
	[Flight.TestFlight1]: true,
	[Flight.tranche]: false,
	[Flight.tranchePostCall]: false,
	[Flight.trancheSubscriptionList]: false,
	[Flight.useFluentPanelForAzurePlan]: true,
	[Flight.useFluentPanelForMeters]: true,
	[Flight.useNewEAAdminScope]: true,
	[Flight.useQuoteProgramCode]: true,
	[Flight.quoteHeaderMessages]: true,
	[Flight.useRawDateAndDurationValues]: true,
	[Flight.virusScanTestHeader]: true,
	[Flight.use1PAFIC]: true,
	[Flight.vpnMessageBar]: true,
	[Flight.searchUfp]: true,
	[Flight.standardAcceleration]: true,
	[Flight.termLengthAcceleration]: true,
	[Flight.testFlightMSAV1ENTRAV2]: true,
	[Flight.useMIForUSGovAadGraph]: true,
	[Flight.breadcrumbs]: true,
	[Flight.cwaShortfallPanelChanges]: true,
	[Flight.gsmProject]: true,
	[Flight.proposalSteps]: true,
	[Flight.qsElmEnforce]: true,
	[Flight.acoStartEndDate]: false,
	[Flight.acoStartEndDateFairFax]: false,
	[Flight.acoStartEndDateAirGapped]: false,
	[Flight.useAADForProjects]: false,
	[Flight.useAADForRecipients]: false,
	[Flight.sovereignCloudRenewalPolicy]: true,
	[Flight.sovereignPurchaseGovernanceForDelos]: true,
};

export const insiderFlights: Record<Flight, boolean> = {
	...productionFlights,
	[Flight.TestFlight1]: true,
};

export const demoFlights: Record<Flight, boolean> = {
	...productionFlights,
	[Flight.approvalOverride]: true,
	[Flight.demoMode]: true,
	[Flight.requiredCredit]: false,
	[Flight.safelistedCreditCheck]: true,
	[Flight.TestFlight1]: true,
};

export const qcInMSXLatestFlights: Record<Flight, boolean> = {
	...latestFlights,
	[Flight.qcInMSX]: true,
	[Flight.guidedTour]: true,
};

export const qcInMSXStableFlights: Record<Flight, boolean> = {
	...stableFlights,
	[Flight.qcInMSX]: true,
	[Flight.guidedTour]: true,
};

export const qcInMSXProdFlights: Record<Flight, boolean> = {
	...productionFlights,
	[Flight.qcInMSX]: true,
	[Flight.guidedTour]: true,
};

export const usxDemoFlights: Record<Flight, boolean> = {
	...qcInMSXLatestFlights,
};

export const fedSalesDev1Flights: Record<Flight, boolean> = {
	...qcInMSXLatestFlights,
};

export const flightList = Object.keys(productionFlights) as Flight[];

export interface FlightInformation {
	display: string;
	description: string;
	disableInEnvs?: AppEnvironment[];
	/**
	 * Do not use this to enable flights, only use it in very specific circumstances where you need to force enable some flights in dev environments
	 */
	forceEnableInEnvs?: AppEnvironment[];
	expirationDate?: Date;
	needsPageRefreshToActivate?: boolean;
}

export const flights: Record<Flight, FlightInformation> = {
	//#region A
	[Flight.AADTenants]: {
		display: 'AAD Tenants Only',
		description: 'Restricts billing account creation to AAD tenants only',
	},
	[Flight.accountExtensionsOrgSearchMoreResults]: {
		display: 'CWA - Billing Account Search Expanded Record Results',
		description: 'Increases Organization Search Results from 10 to 50 when flight is on',
	},
	[Flight.acoStartEndDate]: {
		display: 'ACO for Direct Start date/End date',
		description: 'New start date/end date picker requirements for Direct ACO',
		needsPageRefreshToActivate: true,
	},
	[Flight.acoStartEndDateFairFax]: {
		display: 'ACO for FairFax Start date/End date',
		description: 'New start date/end date picker requirements for Government ACO with USGov cloud',
		needsPageRefreshToActivate: true,
	},
	[Flight.acoStartEndDateAirGapped]: {
		display: 'ACO for AirGappedClouds Start date/End date',
		description:
			'New start date/end date picker requirements for Government ACO with UsSec/UsNat clouds',
		needsPageRefreshToActivate: true,
	},
	[Flight.addOnMaxPurchaseInfo]: {
		display: 'Add-on max seats constraint details',
		description: 'Provides more details regarding seat constraints to the user',
	},
	[Flight.airCapi]: {
		description: 'Allows Air Capi cloud testing',
		display: 'AirCapi',
		disableInEnvs: [AppEnvironment.Prod],
	},
	[Flight.allowEndDateWithoutStartDateForAzureCommitmentDiscount]: {
		description: 'Allow end date without start date for Azure Commitment Discount',
		display: 'Allow end date without start date for Azure Commitment Discount',
		expirationDate: new Date('November 1 2024'),
	},
	[Flight.allowUnspecifiedOptionInLocationFilters]: {
		display: 'Allow Unspecified option',
		description: 'Users can pick the Unspecified option in config cards for location',
		expirationDate: new Date('July 12 2024'),
	},
	[Flight.eaToMcae]: {
		display: 'EA to MCAE Late Renewals',
		description: 'Enables EA-MCAE Features',
	},
	[Flight.approvalCommentsVisibleOnSubmit]: {
		display: 'Approval Comments Visible On Submit',
		description: 'Allows comments visible in Approvals page after submitting quote',
	},
	[Flight.enableApproverSearchSelection]: {
		display: 'Enable Approver Search Selection',
		description: 'Enables the new approver search and selection experience in QC submit dialog',
	},
	[Flight.approvalOverride]: {
		display: 'Approval Override',
		description: 'Auto approve/reject a quote when submitted',
		disableInEnvs: [AppEnvironment.Prod],
		needsPageRefreshToActivate: true,
	},
	[Flight.assignDES]: {
		display: 'Assign DES',
		description: 'Enables Approval Exceptions functionality for Direct Commercial/Gov proposals',
	},
	[Flight.assetEvents]: {
		display: 'Asset Events',
		description: 'Properly filters events for latestPurchaseRecordId in GQL',
	},
	[Flight.parentbillingAcountId]: {
		display: 'Parent Billing Account ID',
		description: 'Enables Parent Billing Account ID feature',
	},
	[Flight.assetFilters]: {
		display: 'Asset Filters',
		description: 'Pass filters to Commerce Cache',
	},
	[Flight.assetPanelUxChanges]: {
		display: 'Asset Management Ux change',
		description: 'New UX experience for Asset Panel-Subscription Management Panel',
	},
	[Flight.azureSupportConfigFlyInPanel]: {
		display: 'Azure support config flyinpanel',
		description: 'Show Azure support config flyinpanel',
	},
	[Flight.azuregovforcommercialcustomers]: {
		display: 'Azure Gov for Commercial Customers',
		description: 'Support Proposals for Azure Gov and Commercial Customers',
	},
	[Flight.azuregovforcommercialcustomersUSGov]: {
		display: 'Azure Gov for Commercial Customers Us Gov',
		description: 'Support Proposals for Azure Gov and Commercial Customers Us Gov',
	},
	[Flight.approveOnBehalfLogs]: {
		display: 'Enable Approve on Behalf Logs',
		description: 'Enables Approve on Behalf Logs',
	},
	[Flight.approveOnBehalfFix]: {
		display: 'Enable Approve on Behalf Fix',
		description: 'Enables Approve on Behalf Fix',
	},
	[Flight.addTenantIdOnQuote]: {
		display: 'Enable Tenant ID on Quote',
		description: 'Enables tenant ID on quote for promo filtering',
	},
	[Flight.addOnBehalfOfToCatalog]: {
		display: 'Set onBehalfOf true to catalog',
		description: 'Sets on behalf of as true to catalog for correct promo eligibility',
	},
	[Flight.cwaTaco]: {
		display: 'CWA - TACO',
		description: 'Use BenefitsRP and CCM to fetch data',
		needsPageRefreshToActivate: true,
	},
	[Flight.cwaTrueUp]: {
		display: 'CWA - True-Up',
		description: 'Enables True-Up enhancements',
		needsPageRefreshToActivate: true,
	},
	[Flight.cwaTrueUpMock]: {
		display: 'CWA - True-Up Mock Data',
		description: 'Enables True-Up Mock Data',
		needsPageRefreshToActivate: true,
	},
	[Flight.cwaTacoMock]: {
		display: 'CWA - TACO Mock Data',
		description: 'Use Mock data for TACO',
		needsPageRefreshToActivate: true,
	},
	[Flight.ciSearchExperience]: {
		display: 'CI search experience',
		description:
			'Enables the new Commerce Insights (CI) search experience on the Home Customers page.',
	},
	[Flight.enableStampConfigV2]: {
		display: 'enableStampConfigV2',
		description: 'Calls StampCofigV2 api to get all the list for aircapienvironment',
	},
	[Flight.enableQCSMigrationwith1PADD360]: {
		display: 'Enable QCS migration with 1PA - DD360',
		description: 'DD360 QCS migration enable endpoint to 1P',
	},
	[Flight.enableQcOptimizations]: {
		display: 'Enable QC Optimizations: Normalize DataLoader Keys',
		description: 'Enable QC Optimizations: Normalize DataLoader Keys',
	},
	[Flight.enableFragmentdProductReadForOptimization]: {
		display: 'Enable QC Optimizations: Fragment DataLoader Keys',
		description: 'Enable QC Optimizations: Fragment DataLoader Keys',
	},
	[Flight.enableDD360AttachmentGQL]: {
		display: 'Enable DD360 Attachment GQL',
		description: 'Enables DD360 upload attachemnt via graphQL',
	},
	//#endregion
	//#region B
	[Flight.backdatelateRenewalsTest]: {
		display: 'Backdate Late Renewals',
		description: 'Enables backdated late renewals flow',
	},
	[Flight.baSearchExperience]: {
		display: 'BA search experience',
		description: 'Enables the new Billing Account (BA) search experience on the Customer tab.',
	},
	[Flight.batchOrganizationLoad]: {
		display: 'Batch organization load',
		description:
			'Batches per-organization getOrganization/Modern Agreement calls into a single bulk getOrganizations request on the Properties tab.',
	},
	[Flight.dedupeAadOrganizationCall]: {
		display: 'Dedupe AAD organization call',
		description:
			'Deduplicates the AAD Graph /organization call within a single request so tenant lookups share one GET instead of three.',
	},
	[Flight.batchOrgAgreementLoad]: {
		display: 'Batch org agreement load',
		description:
			'Collapses per-organization Modern Agreement calls on the Properties tab into a single account-scoped query, filtered locally per organization.',
	},
	[Flight.dedupeGetQuoteLoad]: {
		display: 'Dedupe getQuote load',
		description:
			'Routes the base quote fetch through the shared quotes DataLoader so field resolvers reuse a single GET /quotes/{id} instead of firing a duplicate.',
	},
	[Flight.propertiesTabDedupe]: {
		display: 'Properties tab dedupe (umbrella)',
		description:
			'Umbrella flight that enables the four proven-safe Properties-tab dedupe optimizations at once (dedupe AAD organization call, batch org agreement load, dedupe getQuote load, batch organization load). Batch organization load joined once its skipBulk fix was validated on Test.',
	},
	[Flight.billingProfileForDiscounts]: {
		display: 'Billing Profile to scope all discount for GSA',
		description: 'Enables customer Billing Profiles to scope all discounts for GSA',
		needsPageRefreshToActivate: true,
	},
	[Flight.billingProfileForDiscountsForObx]: {
		display: 'Billing Profile to scope all discount for Outer Banks',
		description: 'Enables customer Billing Profiles to scope all discounts for Outer Banks',
		needsPageRefreshToActivate: true,
	},
	[Flight.billingProfileForDiscountsForRockCreek]: {
		display: 'Billing Profile to scope all discount for Rock Creek',
		description: 'Enables customer Billing Profiles to scope all discounts for Rock Creek',
		needsPageRefreshToActivate: true,
	},
	[Flight.billingProfileChina21V]: {
		display: 'BillingProfileChina21V',
		description: 'Switch to new api for customer partner relationship for china 21 v',
	},
	[Flight.billingRPAssetMigration]: {
		display: 'Billing RP Asset Migration',
		description: 'Enables Billing RP Asset Migration',
	},
	[Flight.breadcrumbs]: {
		display: 'Breadcrumbs',
		description: 'Enables breadcrumbs in the Navigation Bar.',
		expirationDate: new Date('October 1 2020'),
	},
	[Flight.bulkApproveTransact]: {
		display: 'Enables bulk approve transact',
		description: 'Enables bulk approve transact',
	},
	[Flight.bulkImportV1]: {
		display: 'Enables Bulk import V1',
		description: 'Enables Bulk import V1',
	},
	[Flight.asyncProductExport]: {
		display: 'Asynchronous product export',
		description: 'Prepares import-compatible product workbooks in the GQL background worker.',
	},
	[Flight.flexSpendPlan]: {
		display: 'Flex Spend Plan',
		description: 'Enables the Flex Spend Plan (FSP) quoting experience.',
	},
	[Flight.flexSpendPlanQuotability]: {
		display: 'Flex Spend Plan quotability',
		description:
			'Enables FSP quotability: the "Purchase now" (quotable FSP) vs "Reserve discounts for later purchase" (future discount) selection. When off, only the future-discount flow is available.',
	},
	//#endregion
	//#region C
	[Flight.caco]: {
		display: 'CACO',
		description: 'Enable CACO',
	},
	[Flight.chatbot]: {
		display: 'Chatbot',
		description: 'Enable Chatbot',
	},
	[Flight.creditCheck]: {
		display: 'Credit Check for National Clouds',
		description:
			'Enables credit check for all national clouds (US-Gov, US-Sec, US-Nat, CN-Sovereign, FR-SOV), not just Global',
	},
	[Flight.conditionalACOLive]: {
		display: 'Conditional ACO Live',
		description: 'Only live CACO actions are shown when enabled',
	},
	[Flight.canCancelAsset]: {
		display: 'Can Cancel Asset',
		description: 'Allows to cancel Asset',
		needsPageRefreshToActivate: true,
	},
	[Flight.convertDatesToISOStringOnBulkDiscount]: {
		display: 'Convert dates to ISO String on Bulk Discount',
		description: 'Convert dates to ISO String on Bulk Discount',
		expirationDate: new Date('December 5 2024'),
		needsPageRefreshToActivate: true,
	},
	[Flight.normalizeDiscountDatesToSeconds]: {
		display: 'Normalize Discount Dates to Seconds',
		description: 'Normalize discount dates to seconds precision for applyDiscount mutations',
		needsPageRefreshToActivate: true,
	},
	[Flight.convergence]: {
		display: 'Convergence',
		description: 'Convergence Workspace Experience',
	},
	[Flight.cotermWithLineItemFromProposal]: {
		display: 'Coterm with Line Item from Proposal',
		description: 'Allows to coterm with line item from proposal',
	},
	[Flight.cotermWithLineItemFromProposalMockData]: {
		display: 'Coterm with Line Item from Proposal using Mock Data',
		description: 'Allows to coterm with line item from proposal using Mock Data',
	},
	[Flight.csatFeedback]: {
		display: 'CSAT Feedback',
		description: 'Enables CSAT feedback survey on successful proposal submission',
	},
	[Flight.csatAuthMigration]: {
		display: 'CSAT Auth Migration',
		description: 'Gates Authenticated Petrol migration — when OFF uses legacy getUserAccessToken',
	},
	[Flight.csatFloodgate]: {
		display: 'CSAT Floodgate Surveys',
		description:
			'Enables Floodgate system-initiated surveys with sampling/cooldown at feedback trigger points',
	},
	[Flight.cloneProposal]: {
		display: 'Clone proposal',
		description: 'Enables a button in quote summary that allows user to clone a proposal',
	},
	[Flight.cloneProposalAgent]: {
		display: 'Clone Proposal Agent',
		description: 'Enables the Clone Proposal Agent chatbot widget on the proposals page',
	},
	[Flight.cloneProposalVersionV2]: {
		display: 'Clone Proposal Version V2',
		description:
			'Enables the async Clone Proposal Version V2 flow (async createQuote/patchQuote + progress indicator). Requires Enable Quote Creation Version V2 (quoteVersionV2) to also be on.',
	},
	[Flight.currencyOverride]: {
		display: 'Currency Override',
		description: 'Use the currency override for this market',
		disableInEnvs: [AppEnvironment.Prod],
		needsPageRefreshToActivate: true,
	},
	[Flight.customTermSubscriptionLength]: {
		display: 'Custom Term Subscription Length',
		description: 'Enables custom term subscription length and supporting documents',
	},
	[Flight.cwaAgreementRevamp]: {
		display: 'CWA - Agreement Revamp',
		description:
			'Enables the revamped Agreement experience: customer Overview page tour and the new CustomerNavBar billing-accounts dropdown.',
	},
	[Flight.cwaAgreementRevampMock]: {
		display: 'CWA - Agreement Revamp Mock',
		description:
			'Enables mock data for the Agreement Revamp experience. Used for local development and testing without backend dependencies.',
	},
	[Flight.cwaOverviewTabRevamp]: {
		display: 'CWA - Overview Tab Revamp',
		description:
			'Enables the revamped filter experience on the upcoming expiration and schedule event tab.',
	},
	[Flight.cwaByModernIds]: {
		display: 'CWA - CWA by modern ids',
		description:
			'Debug only. Enables using CWA by org id or tenant id instead of tpid. Only for testing purposes in CWA',
	},
	[Flight.cwaDebug]: {
		display: 'CWA - Debug',
		description: 'Enables debug information in CWA',
	},
	[Flight.cwaDirectCommercialFilterCI]: {
		display: 'CWA - Direct Commercial Filter',
		description:
			'Restricts Commerce Insights proposal creation to only billing accounts with a direct purchase context',
		needsPageRefreshToActivate: true,
	},
	[Flight.cwaCacheService]: {
		display: 'CWA - Cache Service',
		description: 'Enables CWA to use Cache Service for data retrieval',
		needsPageRefreshToActivate: true,
	},
	[Flight.cwaCaco]: {
		display: 'CWA - CACO',
		description: 'Use BenefitsRP and CCM to fetch data',
		needsPageRefreshToActivate: true,
	},
	[Flight.cwaCacoActualProductData]: {
		display: 'CWA - CACO Actual Product Data',
		description: 'Use actual product data for CACO instead of mock data',
		needsPageRefreshToActivate: true,
	},
	[Flight.cwaCacoMock]: {
		display: 'CWA - CACO Mock Data',
		description: 'Use Mock data for CACO',
		needsPageRefreshToActivate: true,
	},
	[Flight.cwaSsCaco]: {
		display: 'CWA - SS CACO',
		description: 'Enables Service Specific Conditional Azure Credit Offer (SS-CACO) features',
		needsPageRefreshToActivate: true,
	},
	[Flight.cwaSsCacoMock]: {
		display: 'CWA - SS CACO Mock Data',
		description: 'Enables mock data for SS-CACO specific fields (requires cwaSsCaco)',
		needsPageRefreshToActivate: true,
	},
	[Flight.cwaEst]: {
		display: 'CWA - EST',
		description: 'Enables CWA to use EST features',
	},
	[Flight.cwaControlPanel]: {
		display: 'CWA - CWA Control Panel Changes',
		description: 'Enables CWA to be used control panel',
	},
	[Flight.cwaEcif]: {
		display: 'CWA - ECIF',
		description: 'Use BenefitsRP and CCM to fetch data',
		needsPageRefreshToActivate: true,
	},
	[Flight.cwaEcifMock]: {
		display: 'CWA - ECIFMock',
		description: 'Use BenefitsRP and CCM to fetch data',
		needsPageRefreshToActivate: true,
	},
	[Flight.cwaEnterpriseSupportPhase2]: {
		display: 'CWA - Enterprise Support Phase 2',
		description: 'Enables CWA Enterprise Support Phase 2',
		needsPageRefreshToActivate: true,
	},
	[Flight.cwaEnterpriseSupportPhase2Mock]: {
		display: 'CWA - Enterprise Support Phase 2 Mock',
		description: 'Enables CWA Enterprise Support Phase 2 Mock Data',
		needsPageRefreshToActivate: true,
	},
	[Flight.cwaEvidenceOfSignature]: {
		display: 'CWA - Evidence of Signature',
		description: 'Enables CWA Evidence of Signature Feature',
	},
	[Flight.cwaEvidenceOfSignatureMock]: {
		display: 'CWA - Evidence of Signature Mock',
		description: 'Enables CWA Evidence of Signature Mock Data',
		needsPageRefreshToActivate: true,
	},
	[Flight.cwaExpiringProposalsViewAllFilter]: {
		display: 'CWA - Expiring Proposals View All Filter',
		description:
			'Enables enhanced View All link with expiration and billing account ID filters on the RightNowTab',
	},
	[Flight.cwaLateRenewals]: {
		display: 'CWA - Late Renewals',
		description: 'Enables CWA - Late Renewals',
	},
	[Flight.cwaConcessionSearch]: {
		display: 'CWA - Concession Search',
		description: 'Enables searching concessions by Resource ID in CWA',
		needsPageRefreshToActivate: true,
	},
	[Flight.cwaConcessionPrefetch]: {
		display: 'CWA - Concession Prefetch',
		description: 'Enables searching concessions by Resource ID in CWA using Mock Data',
		needsPageRefreshToActivate: true,
	},
	[Flight.cwaLsaClpView]: {
		display: 'CWA - LSA CLP View',
		description: 'Enables LSA CLP view in CWA',
	},
	[Flight.cwaLsaClpViewMock]: {
		display: 'CWA - LSA CLP View Mock',
		description: 'Enables LSA CLP view in CWA using Mock Data',
	},
	[Flight.cwaLsaAssociatedPurchases]: {
		display: 'CWA - LSA Associated Purchases',
		description: 'Enables LSA Associated Purchases in CWA',
	},
	[Flight.cwaMaccMilestone]: {
		display: 'CWA - MACC Milestone',
		description: 'Features for testing macc milestone changes',
	},
	[Flight.cwaMaccMilestoneMock]: {
		display: 'MACC Milestone Mock Data',
		description: 'Feature flag for testing macc milestone mock data',
	},
	[Flight.cwaMultiEntitySupport]: {
		display: 'CWA - Multi Entity Support',
		description: 'Enables CWA to support multiple entities in a single CWA instance',
	},
	[Flight.cwaMultiEntitySupportMock]: {
		display: 'CWA - Multi Entity Support Mock',
		description:
			'Enables CWA to support multiple entities in a single CWA instance using Mock Data',
	},
	[Flight.cwaMultiMaccContriEntity]: {
		display: 'CWA - Display Contributors ME MACC',
		description: 'Displays COntributors list for Primary BA if exists',
	},
	[Flight.cwaOverviewTabTableRevamp]: {
		display: 'CWA - Overview Tab Table Revamp',
		description:
			'Enables the Quantity, Future discount and Future amount columns on the Customer Overview Upcoming Expirations and Schedule Event grid',
	},
	[Flight.cwaPlannedAccounts]: {
		display: 'CWA - Show Planned accounts in Billing Accounts section',
		description: 'Shows dropdown and planned accounts in Billing Accounts',
	},
	[Flight.cwaScheduledMidTermUpgrades]: {
		display: 'CWA - Scheduled Mid Term Upgrades',
		description: 'Enables Scheduled Mid Term Upgrades in CWA',
	},
	[Flight.cwaShortfallPostPaidAllowZero]: {
		display: 'CWA - MACC shortfall allow zero for post paid',
		description: 'Enables entering "0" for the amount for post paid MACC shortfall invoices.',
	},
	[Flight.cwaShortfallPanelChanges]: {
		display: 'CWA - Shortfall Panel Changes',
		description: 'Shows and updated shortfall panel without billing account owner',
	},
	[Flight.cwaShortfallRefetchingQuote]: {
		display: 'CWA - MACC Shortfall Refetch Quote Flow',
		description: 'Enables the refetch and publish workflow for MACC shortfall quotes',
	},
	[Flight.cwaSkipBillingAccountForProposal]: {
		display: 'CWA - Skip Billing Account For Proposal',
		description:
			'Skips passing the billing account when creating a proposal from the Commerce Insights Overview tabs',
	},
	[Flight.cwaSpecialBillingPlan]: {
		display: 'CWA - Special Billing Plan',
		description: 'Enables Special Billing Plan',
		needsPageRefreshToActivate: true,
	},
	[Flight.cwaTelemetry]: {
		display: 'CWA - Telemetry',
		description: 'Enables telemetry in CWA',
	},
	[Flight.cwaTenantAccountCheck]: {
		display: 'CWA - Enable Tenant Account Check',
		description: 'Enable checking if the tenant is associated with a valid MCAPI account',
	},
	[Flight.cwaUpcomingExpirationTabNew]: {
		display: 'CWA - Upcoming Expiration Tab New',
		description: 'Enables the new Upcoming Expiration tab in CWA',
	},
	[Flight.cwaUnifiedForPartners]: {
		display: 'CWA - Unified For Partners',
		description: 'Enables Unified For Partners feature in CWA',
	},
	[Flight.cwaUnifiedForPartnersMock]: {
		display: 'CWA - Unified For Partners Mock',
		description: 'Enables Unified For Partners feature in CWA using Mock Data',
	},
	[Flight.cancelExistingAco]: {
		display: 'Cancel existing ACO',
		description: 'Enable cancel existing ACO panel for Direct ACO',
	},
	[Flight.cancelExistingACOMock]: {
		display: 'ACO Cancellation Mock Data',
		description: 'Use this flight for TACO Cancellation Mock data',
	},
	[Flight.configurableConversionWindows]: {
		display: 'Configurable Conversion Windows',
		description: 'Enables configurable conversion windows for subscription change actions',
		needsPageRefreshToActivate: true,
	},
	[Flight.cwaRemoveLogs]: {
		display: 'CWA - Remove Logs',
		description: 'Removes logs from CWA',
		needsPageRefreshToActivate: true,
	},
	[Flight.cwaRightNowTab]: {
		display: 'CWA - Right Now Tab',
		description: 'Enables new flight-controlled RightNowTab with enhanced features',
	},

	//#endregion
	//#region D
	[Flight.dateDiscrepancyBug]: {
		display: 'Date Discrepancy Bug Fix',
		description:
			'Fixes date discrepancy bug where Created on date displays local time instead of UTC',
		expirationDate: new Date('October 31 2026'),
	},
	[Flight.dealTotalityBenefitsOnQuote]: {
		display: 'Deal Totality benefits on Quote',
		description: 'Allows us see Approved benefits and benefits on quote separately',
	},
	[Flight.deduplicateProductIdsOnMultiSelect]: {
		display: 'Deduplicate Product Ids on Multi Select',
		description: 'Deduplicate Product Ids on Multi Select',
		needsPageRefreshToActivate: true,
	},
	[Flight.delaySearchByMeterId]: {
		display: 'Delay Search By Meter Id',
		description: 'Delays the download of shared meters',
	},
	[Flight.deletedTenantCheck]: {
		display: 'Deleted tenant check',
		description:
			"Enables publish-blocking messages to check if the partner or customer's tenant still exists.",
		needsPageRefreshToActivate: true,
	},
	[Flight.demoMode]: {
		display: 'Demo mode theme',
		description: 'Enables Demo mode theme',
		expirationDate: new Date('October 1 2020'),
		disableInEnvs: [AppEnvironment.Prod],
	},
	[Flight.directComNonDFD]: {
		display: 'Direct-Commercial Non-DFD',
		description: 'Allows direct-commercial quotes to be pass through non-DFD flow',
	},
	[Flight.directFGOE]: {
		display: 'Direct FGOE',
		description: 'Allows selection of fgoe on a direct-goverment quote',
		expirationDate: new Date('November 1 2020'),
	},
	[Flight.directGov]: {
		display: 'Direct-Gov',
		description: 'Allows direct-gov quotes to be created',
		expirationDate: new Date('November 1 2020'),
	},
	[Flight.directGovNonDFD]: {
		display: 'Direct-Gov Non-DFD',
		description: 'Allows direct-gov quotes to be pass through non-DFD flow',
	},
	[Flight.disableBulkEditForPasses]: {
		display: 'Disable Bulk Edit for Passes Product',
		description: 'Disable Bulk Edit for Passes Product',
	},
	[Flight.disableOneTimeDiscountForAGC]: {
		display: 'Disable One-Time Discount for AGC',
		description:
			'Disable one-time discount option for Passes/Entra products in Government Contractor scenarios with USNat or USSec clouds',
	},
	[Flight.disableSagasAndEpics]: {
		display: 'Disable Sagas and Epics',
		description: 'Disable Sagas and Epics',
	},
	[Flight.displayEtagsForDebugging]: {
		display: 'Display Etags',
		description: 'Display Etags for debugging purposes',
	},
	[Flight.displayTestMCAs]: {
		display: 'CWA - Display Production Quote Data',
		description:
			'TESTING ONLY. Causes all quote data to be loaded from production. Never turn on by default; only for testing purposes in CWA.',
		disableInEnvs: [AppEnvironment.Prod],
		needsPageRefreshToActivate: true,
	},
	[Flight.disableProductInclusionFilter]: {
		display: 'Search all products',
		description: 'disable filters applied after product search',
		needsPageRefreshToActivate: true,
	},
	[Flight.disableTestTermRecommendations]: {
		display: 'Disable test term recommendations',
		description: 'Disable test term recommendations.',
		needsPageRefreshToActivate: true,
	},
	[Flight.doNotUpdateLineItemRecipientAndAssetTo]: {
		display: 'Do not update line item recipient and asset to',
		description:
			'Do not update line item recipient and asset to when we have a customized price(NON-DFD) on the line item',
		needsPageRefreshToActivate: true,
	},
	[Flight.downloadPDFConvertChanges]: {
		display: 'PDF UX passes product lineitem Changes',
		description: 'Enables the PDF UX enhancements for passes product lineitem',
	},
	[Flight.docuSignV1]: {
		display: 'DocuSign V1',
		description: 'For Signing Tool selection in Agreement creation on Review and Publish page.',
	},
	[Flight.docuSignV2]: {
		display: 'DocuSign V2',
		description:
			'Signature optimization: extended market modes (SA/RU/EG), Microsoft acceptance mode, customer acceptance mode rename on Review and Publish.',
	},
	[Flight.dualProduct]: {
		display: 'Dual Product',
		description: 'Enable for Dual Product',
	},
	[Flight.dualUseRightsForFromSA]: {
		display: 'Dual Use Rights For From SA',
		description: 'Features for testing Dual Use Rights for From SA',
	},
	//#endregion
	//#region E
	[Flight.e2Fragments]: {
		display: 'E2 Fragments',
		description: 'Enables the use of E2 Fragments',
		needsPageRefreshToActivate: true,
	},
	[Flight.ecifModifyCancelFlight]: {
		display: 'Enable ECIF Modify/Cancel',
		description:
			'Enables the ECIF Modify/Cancel feature for modification of ECIF Agreement in quotes/proposal',
		needsPageRefreshToActivate: true,
	},
	[Flight.ecifAmendmentFlight]: {
		display: 'Enable ECIF Amendment',
		description:
			'Enables the ECIF Amendment feature for amendment of ECIF Agreement in quotes/proposal',
		needsPageRefreshToActivate: true,
	},
	[Flight.usGovEcifModifyFlight]: {
		display: 'US Gov - Enable ECIF Modify/Cancel',
		description:
			'US Gov - Enables the ECIF Modify/Cancel feature for modification of ECIF Agreement in quotes/proposal',
		needsPageRefreshToActivate: true,
	},
	[Flight.enterpriseSupportCommit]: {
		display: 'Enterprise Support Phase 2',
		description:
			'Enables Enterprise Support Commit Phase 2 features: search, configuration, future discount, and post-sale management',
		needsPageRefreshToActivate: true,
	},
	[Flight.enterpriseSupportCommitMacc]: {
		display: 'Enterprise Support - MACC flow',
		description:
			'Enables the Enterprise Support Commit MACC flow: base-offer requirement selection on MACC create, ESC base-offer auto-add/remove, the MACC ESC banner, and Required ESC line delete protection. Requires Enterprise Support Phase 2.',
		needsPageRefreshToActivate: true,
	},
	[Flight.enterpriseSupportMultiEntity]: {
		display: 'Enterprise Support - Multi-Entity',
		description:
			'Enables Multi-Entity Enterprise Support in Quote Center: capability surfacing, the Create new / Contribute to existing action panel, the allow-contributors toggle, and the contribution search/apply flow',
		needsPageRefreshToActivate: true,
	},
	[Flight.eeaSettlement]: {
		display: 'Enable validations for EEA Settlement',
		description: 'Enables validations on line items to mandate M1261 amendment',
	},
	[Flight.e2Router]: {
		display: 'E2 Router',
		description: 'Enables the use of E2 Router',
		needsPageRefreshToActivate: true,
	},
	[Flight.enableApolloRequestInspector]: {
		display: 'Enable Apollo Request Inspector',
		// Turning this flight on won't by itself enable the apollo request inspector, for it to be enabled it should also be enabled in the backend in appsettings.json of the environment AND you should have the necessary role.
		disableInEnvs: [AppEnvironment.Stable, AppEnvironment.Prod],
		description:
			'Enables Apollo Request Inspector, When turned off, you would not get any debug headers in the response.',
		needsPageRefreshToActivate: true,
	},
	[Flight.enableApolloRequestInspectorClientFilters]: {
		display: 'Enable Apollo Request Inspector Client Filters',
		description: 'Enables Apollo Request Inspector Client Filters',
		disableInEnvs: [AppEnvironment.Stable, AppEnvironment.Prod],
		needsPageRefreshToActivate: true,
	},
	[Flight.enableCacheVersionNine]: {
		display: 'Enable Cache Version Nine',
		description: 'Enables Cache Version Nine',
	},
	[Flight.enableCacheWorkerPool]: {
		display: 'Enable GQL Worker Pool For Processing Quote',
		description: 'Use this flight to use worker pool for processing quotes in backend GQL layer',
	},
	[Flight.multiTenantProposals]: {
		display: 'Enable Multi-Tenant Proposals',
		description:
			'Enables Multi-Tenant Proposals feature with Deal ID support in quotes list and details pane',
		needsPageRefreshToActivate: false,
	},
	[Flight.MEPdealDetachmentOnBillingAccountChange]: {
		display: 'Enable MEP - Deal detachment on Billing Account Change',
		description:
			'Auto-detaches the linked dealId from a quote after a successful billing-account change (Edit / Add new / Select existing / Create account+org).',
		needsPageRefreshToActivate: false,
	},
	[Flight.mepForLargeQuotes]: {
		display: 'Enable MEP for Large Quotes',
		description:
			'Enables Multi-Entity Proposals deal flow for Large Quotes. Requires Enable Multi-Tenant Proposals to also be enabled.',
		needsPageRefreshToActivate: false,
	},
	[Flight.multiTenantProposalsOboEnablement]: {
		display: 'Enable Multi-Entity Proposals OBO',
		description:
			'Enables Approve on Behalf Of (OBO) for deal-level approval in Multi-Entity Proposals. Per-quote OBO is not affected.',
		needsPageRefreshToActivate: false,
	},
	[Flight.multiTenantProposalsOboPerProposalEligibility]: {
		display: 'Enable Multi-Entity Per-Proposal OBO Eligibility',
		description:
			'Evaluates OBO eligibility per proposal (batched) instead of deal-wide single-shot. Child of Multi-Entity Proposals OBO.',
		needsPageRefreshToActivate: false,
	},
	[Flight.enableDetailsPaneLabelGrid]: {
		description: 'uses css grids for the labels on details pane',
		display: 'Details pane grid',
	},
	[Flight.enableEaEnrollmentProtected]: {
		display: 'Enable EA Enrollment Protected',
		description: 'Enable EA Enrollment Protected',
	},
	[Flight.enableMetersLineItem]: {
		display: 'Enable metersLineItem type',
		description: 'Enable metersLineItem type',
	},
	[Flight.usePreferredCommunicationLanguages]: {
		display: 'Enable use of preferred communication languages',
		description: 'Enables use of preferred communication languages',
	},
	[Flight.enableNewVatIDs]: {
		display: 'Enable New VatIDs',
		description: 'Enable New VatIDs',
		needsPageRefreshToActivate: true,
	},
	[Flight.enableFranceTaxIds]: {
		display: 'Enable France Tax IDs',
		description:
			'Enable France-specific tax IDs (PublicSectorId, NationalIdentificationNumber, EInvoicingCode, NonRegistrationAcknowledgement)',
		needsPageRefreshToActivate: true,
	},
	[Flight.enableFranceNonCompliantTaxBanner]: {
		display: 'Enable France NonCompliant Tax Banner',
		description:
			'Enables the new "Your Tax ID is required" banner for France organizations whose tax status is NonCompliant. When off, the existing "Tax Id(s) not found" banner is shown.',
		needsPageRefreshToActivate: true,
	},
	[Flight.enableNonCompliantTaxBanner]: {
		display: 'Enable NonCompliant Tax Banner',
		description:
			'Enables the new "Your Tax ID is required" banner for organizations whose tax status is NonCompliant. When off, the existing "Tax Id(s) not found" banner is shown.',
		needsPageRefreshToActivate: true,
	},
	[Flight.enableQuickLookupForSharedMeters]: {
		description:
			'Enable quick lookup for shared meters download (does not affect search shared meters option in UX)',
		display: 'Quick lookup for shared meters download',
		expirationDate: new Date('September 1 2024'),
		needsPageRefreshToActivate: true,
	},
	[Flight.enableReferralCloseButtonForTesting]: {
		description: 'Enable referral close button for testing',
		display: 'Enable Close Button',
		disableInEnvs: [AppEnvironment.Prod],
	},
	[Flight.enableTAXIDForAllMarket]: {
		display: 'Enable TAXID for all market',
		description: 'Enables TAXID for all market',
		needsPageRefreshToActivate: true,
	},
	[Flight.enableServiceDeskAttachment]: {
		display: 'Enable Service Desk Attachment',
		description: 'Enables Service Desk Attachment',
	},
	[Flight.enableTestProducts]: {
		display: 'Enable Test Products for Testing',
		description: 'Enable Test Products for Testing',
	},
	[Flight.endDateAdjustment]: {
		description: 'Enables the end date adjustment for the quote',
		display: 'End Date Adjustment',
		expirationDate: new Date('July 1 2024'),
	},
	[Flight.endDateForImmediateConversion]: {
		description: 'Enables passing target end date in immediate conversion scenario',
		display: 'End Date For Immediate Conversion',
	},
	[Flight.enterpriseSupportPhase2Cancellation]: {
		display: 'Enterprise Support Phase 2 - Cancellation',
		description: 'Enables Enterprise Support Phase 2 Cancellation features',
	},
	[Flight.enterpriseSupportRPDuplicateCancellation]: {
		display: 'Enterprise Support RP - Duplicate Cancellation',
		description:
			'Disables duplicate Enterprise Support mid-term cancellation when the subscription already has a scheduled action',
		needsPageRefreshToActivate: true,
	},
	[Flight.eurozoneCurrencyException]: {
		display: 'Eurozone Currency Exception Check',
		description:
			'Enables Eurozone currency conflict checking for Nordic/DACH markets (Denmark, Sweden, Switzerland, Norway)',
	},
	[Flight.esGraduatedPricingOnlyForAzure]: {
		display: 'Ent Support Graduated Pricing Only For Azure',
		description: 'Update text to reflect Ent Support Graduated Pricing Only For Azure',
	},
	[Flight.estsrRegionAutodetect]: {
		display: 'ESTS-R Region Autodetect',
		description: 'Enables ESTS-R in the backend',
	},
	[Flight.est]: {
		display: 'EST',
		description: 'Enables EST Features',
	},
	[Flight.gateProductFilteredSkus]: {
		display: 'GateProductFilteredSkus',
		description:
			'Only fires GetProductFilteredSkus for SimpleSkuPicker terms, removing per-SKU EST lookups for other term types',

		// so the flight is forced ON in non-prod environments for telemetry gathering.
		forceEnableInEnvs: [AppEnvironment.Test],
	},
	[Flight.estLookupOptimization]: {
		display: 'EST Lookup Optimization',
		description: 'Enables optimizations for EST lookups',
	},
	[Flight.estSingleSkuLookup]: {
		display: 'EST Single SKU Lookup',
		description:
			'Fetches isESTSupported for the selected SKU only (via Product.sku) instead of every SKU.',
	},
	[Flight.subscriptionAssetTargetEstLookup]: {
		display: 'Subscription Asset Target EST Lookup',
		description:
			'Fetches isESTSupported for asset relationship target SKUs only, instead of every SKU in each target product.',
	},
	[Flight.expiryBanner]: {
		display: 'Expiration Message Banner',
		description: 'Enables Expiration Message Banner for Proposal Screen',
	},
	[Flight.estBackdatedFlows]: {
		display: 'EST Backdated Flows',
		description: 'Enables backdated EST adjust and convert flows',
	},
	[Flight.estPartialConvertIntent]: {
		display: 'EST Partial Convert Transaction Intent',
		description:
			'For EST partial convert, retains BackDatedLateRenewal transactionIntent only on the base (0th-index) late-renewal line item and nulls it on all other line items. Gates the corresponding backend behavior via the flights request header.',
	},
	[Flight.pagination]: {
		display: 'EST-Subscription-Pagination-Sorting',
		description: 'Enables EST Subscription Pagination Sorting Features',
	},
	[Flight.estMock]: {
		display: 'EST Mock',
		description: 'Enables estMock',
	},
	[Flight.enableAzurePromos]: {
		display: 'Enable Azure Promos',
		description: 'Enables Azure promotions in new promotion experience',
	},
	[Flight.enableNceDailyInvoicing]: {
		display: 'Enable NCE Daily Invoicing',
		description: 'Gates sending IsDailyInvoicingEligible stamp to Quote Service',
	},
	[Flight.azurePromoMockData]: {
		display: 'Azure Promo Mock Data',
		description: 'Enables mock data for Azure promotions (for testing when API is not available)',
	},
	[Flight.excludeSavingsPlan]: {
		display: 'Exclude SavingsPlan',
		description: 'Exclude SavingsPlan from inclusion list',
		needsPageRefreshToActivate: true,
	},
	//#endregion
	//#region F
	[Flight.fairfaxBillingProfile]: {
		display: 'Fairfax Billing Profile',
		description: 'Enables get call for Billing Profile',
	},
	[Flight.filterForBillingAccountOwners]: {
		display: 'Filter For Billing Account Owners',
		description:
			'Only display eligible Billing Account Owners when selecting billing account owner',
	},
	[Flight.filterNoSkuNoAvailabilityProducts]: {
		display: 'Filter No Sku and Availability Products',
		description: 'Only display products that have sku and availability',
	},
	[Flight.fixQuoteWithExpiredAvailabilities]: {
		display: 'Fix Quote With Expired Availabilities',
		description: 'Fixes quotes that have passes/software lineitems with expired availabilityId',
	},
	[Flight.forceFutureDiscountOptions]: {
		display: 'Force Future Discount Options',
		description: 'Forces SubscriptionProductConfigurationPanel to show future discount options',
		disableInEnvs: [AppEnvironment.Prod],
	},
	[Flight.fromSAEnabled]: {
		display: 'From SA Enabled',
		description: 'Controls the priorQuantity feature for legacy to modern migration',
	},
	[Flight.fixAccidentalShowingOfAllDiscountsAddedInSharedDiscountPanel]: {
		display: 'Fix Accidental Showing Of All Discounts Added In Shared Discount Panel',
		description: 'Fix Accidental Showing Of All Discounts Added In Shared Discount Panel',
	},
	//#endregion
	//#region G
	[Flight.graphAuthorizationUsingQCApp]: {
		display: 'Graph authorization using QC',
		description: 'Graph authorization using QC',
	},
	[Flight.graphToCreateSPNUsingQCApp]: {
		display: 'Graph Service Principal using QC',
		description: 'Graph Service Principal using QC',
	},
	[Flight.gsmProject]: {
		display: 'GSM Project',
		description: 'Enables to retrieve MCAPI footprint for legacy enrollment using GSM API.',
	},
	[Flight.guidedTour]: {
		display: 'Guided Tour',
		description: 'Enables guided tour for quote center',
	},
	//#endregion
	//#region H
	[Flight.hiddenOffers]: {
		display: 'Hidden Offers',
		description:
			'Enables hidden offer experience to show hidden offers for products at different granularity',
	},
	[Flight.hiddenOffersMockData]: {
		display: 'Hidden Offers Mock Data',
		description:
			'Enables mock data for hidden offer experience to show hidden offers for products at different granularity',
	},
	[Flight.hiddenOffersPriceListMockData]: {
		display: 'Hidden Offers Price List Mock Data',
		description:
			'Enables mock data for hidden offer price list experience to show hidden offers for products at different granularity',
	},
	[Flight.hideAffiliateFedGov]: {
		display: 'CWA - Hides Affiliate for FedGov',
		description: 'Hides the Affiliate FedGov option',
	},
	[Flight.hideSharedMeters]: {
		display: 'Hide shared meters download',
		description: 'Hides the option to download shared meters',
	},
	[Flight.hideUnconfiguredProductConfigDetails]: {
		display: 'Hide unconfigured product config details',
		description:
			'Hides the Product configuration section in details pane if product is not configured',
	},
	//#endregion
	//#region I
	[Flight.infoSummaryCards]: {
		display: 'Info Summary Cards',
		description: 'Enables Info Summary Cards to display categorized expiration data',
	},
	[Flight.ignoreNonExistingQuotesOnSearchIndex]: {
		display: 'Ignore non existing quotes',
		description:
			'There are some quotes that are returned in search index but they actually do not exist, the search index is out of sync, this enables to return search results on quotes with ignoring those ones',
		needsPageRefreshToActivate: true,
	},
	[Flight.ignoreTestEmailValidation]: {
		display: 'Ignore test email validation',
		description: 'Ignore test email validation in test environment',
		needsPageRefreshToActivate: true,
	},
	[Flight.ignoreSoldToMappingPendingQuotes]: {
		display: 'Ignore Sold-To Mapping for Pending Quotes',
		description: 'Ignore sold-to mapping for pending quotes',
	},
	[Flight.indirectComChinaNonDFD]: {
		display: 'Indirect-Commercial China Non-DFD',
		description: 'Allows indirect-commercial China quotes to be pass through non-DFD flow',
	},
	[Flight.indirectComCSPNonDFD]: {
		display: 'Indirect-Commercial CSP Non-DFD',
		description: 'Allows indirect-commercial CSP quotes to be pass through non-DFD flow',
	},
	[Flight.indirectGovNonDFD]: {
		display: 'Indirect-Gov Non-DFD',
		description: 'Allows indirect-gov quotes to be pass through non-DFD flow',
	},
	[Flight.indirectPartnerCustomerFootprintRetry]: {
		display: 'CWA - Indirect Partner Customer Footprint Retry',
		description: 'Changes the retry logic for indirect partner customer footprint',
	},
	[Flight.enableHRDDDocHold]: {
		display: 'Enable HRDD Doc Hold',
		description: 'Enable HRDD Doc Hold',
		needsPageRefreshToActivate: true,
	},
	//#endregion
	//#region J
	//#endregion
	//#region K
	//#endregion
	//#region L
	[Flight.largeQuote1]: {
		display: 'LQ1 - Large Quote 1',
		description: 'Uses QS v13 to support crafting Large Quotes',
	},
	[Flight.lazyLoadProductFilters]: {
		display: 'Lazy load product filters',
		description: 'Load product filters after other line item details',
	},
	[Flight.leadAffiliate]: {
		display: 'Lead Affiliate',
		description: 'Enables lead/affiliate functionality',
	},
	[Flight.legacyNonDFD]: {
		display: 'Legacy Non-DFD',
		description: 'Allows legacy quotes to be pass through non-DFD flow',
	},
	[Flight.limitBillingAccountByMarket]: {
		display: 'LQ1 - Limit Billing Account By Market',
		description: 'Limits organization search/creation by the market of the quote',
	},
	[Flight.lineItemLimitIncrease]: {
		display: 'Line Item Limit Increase',
		description: 'Removes the lineitem limit restrictions',
	},
	[Flight.productLineItemReorder]: {
		display: 'Product Line Item Reorder',
		description:
			'Enables in-quote line-item management: reorder (selection checkbox + Move Up / Down / Top / Bottom buttons and drag-and-drop), click-to-sort column headers with a "Sort by" dropdown, and pagination of the main ProductList',
	},
	[Flight.loadMinimumRequiredPagesForSharedDiscount]: {
		display: 'load minimum required pages for shared discount',
		description: 'Get the minimum required pages to decide on enabling shared discounts',
	},
	[Flight.nonAzureSharedDiscounts]: {
		display: 'Non-Azure Shared Discounts',
		description:
			'Enables non-Azure shared discount flows including ItemizedCustomPrice line item creation and UI panel enhancements',
	},
	[Flight.excludeIneligibleSharedDiscounts]: {
		display: 'Exclude Ineligible Shared Discounts',
		description:
			'When enabled, hides shared discount candidates whose isEligibleForLineItemInQuote is false from the Add Shared Discounts panel',
	},
	[Flight.lppSubPriceConfigurePanel]: {
		display: 'LPP: Enable Monthly Estimates in Subscription dropdown',
		description:
			'LPP Product Configure Panel Changes to enable monthly estimates in the subscription dropdown',
	},

	[Flight.lq1Arbitration]: {
		display: 'LQ1 - updated Arbitration',
		description: 'Utilize updated request/response format for arbitration',
	},
	[Flight.lq1ForSubmit]: {
		display: 'LQ1 - Use isLargeQuote flag',
		description: 'Uses isLargeQuote flag from QS to determine if we can use sync Submit flow',
	},
	[Flight.lq1ForQS]: {
		display: 'LQ1 - Pass largeQuote1 flight to QS',
		description: 'Pass largeQuote1 flight to QS when largeQuote1 flight is on',
	},
	[Flight.lsa]: {
		display: 'LSA',
		description: 'Enables LSA for the quote center',
	},
	[Flight.lsaMockData]: {
		display: 'LSA Mock Data',
		description: 'Enables LSA mock data for testing',
	},
	[Flight.lsaBillingRPAgreement]: {
		display: 'LSA Billing RP Agreement',
		description: 'Enables LSA Billing RP Agreement integration',
	},
	[Flight.lsaBRPdebug]: {
		display: 'LSA BRP Debug',
		description: 'Enables LSA Billing RP Agreement debugging',
	},
	[Flight.lsaStartDateEnabled]: {
		display: 'LSA/SA Start Date Enabled',
		description: 'Enables new logic for LSA/SA Start Date selection.',
	},
	[Flight.lsaDerivedOfferCoterm]: {
		display: 'LSA/SA Coterming Derived Offers',
		description: 'Enables logic for LSA/SA Derived Offer Coterm end date selection',
	},
	[Flight.lsaTrueupRedesign]: {
		display: 'LSA True-up Redesign',
		description: 'Enables redesigned true-up experience for LSA',
	},
	[Flight.lsaTrueupRedesignMockData]: {
		display: 'LSA True-up Redesign Mock Data',
		description: 'Enables mock data for redesigned true-up experience for LSA',
	},
	[Flight.lsaVirtualBundles]: {
		display: 'LSA Virtual Bundles',
		description:
			'Enables LSA V3 virtual bundling: standalone License / Software Assurance bases, split L and SA true-ups, and association grouping',
	},
	[Flight.lsaVirtualBundlesNewUI]: {
		display: 'LSA Virtual Bundles - New UI',
		description:
			'Enables the LSA virtual bundling presentation: the collapsible family header in the products grid and the proposal PDF, group level delete and its regrouping warning, and the true-up discount pricing preview',
	},
	[Flight.lppDownloadQuotePdf]: {
		display: 'LPP: Proposal PDF Changes',
		description: 'List price presentment proposal pdf changes',
	},
	[Flight.lppUseBillingScheduleAPI]: {
		display: 'LPP: Use billing schedule API',
		description: 'Allows LPP to use the billing schedule API',
	},
	[Flight.lppProductsList]: {
		display: 'LPP: Products List Changes',
		description: 'List price presentment products list changes',
	},
	[Flight.proposalPagePerfV1]: {
		display: 'Proposal Page Perf V1 (Large Quote)',
		description:
			'Kill-switch for Proposal Page performance optimizations (row virtualization, scroll/focus fixes, deferred loadProposal) targeting quotes with 100+ line items.',
	},
	[Flight.lppCustomFormatSubtotalColumn]: {
		display: 'LPP: Custom Format Subtotal Column in Excel',
		description: 'List price presentment custom format subtotal column changes',
	},
	[Flight.lockProposal]: {
		display: 'Lock Proposal',
		description: 'Enable Lock Proposal feature',
	},
	//#endregion
	//#region M
	[Flight.maccMilestone]: {
		display: 'MACC Milestone',
		description: 'Enable MACC Milestones',
	},
	[Flight.maccMilestoneEndDateValidation]: {
		display: 'MACC Milestone End Date Validation',
		description: 'Enable new milestone end-date validation checks and completed-state behavior',
	},
	[Flight.maccModifyCancelPanelCWA]: {
		display: 'CWA - MACC Modify/Cancel Panel',
		description: 'Enables MACC modify/cancel panel for CWA',
	},
	[Flight.eaToMcaManageLineItemWizard]: {
		display: 'EA to MCAE Line item management wizard',
		description: 'Enables EA to MCAE Line item management wizard',
	},
	[Flight.maximumSkuLimitReachedMessage]: {
		display: 'Max SKU limit reached message',
		description: 'Maximum SKU limit reached line item message reflects Validation API',
		expirationDate: new Date('September 30 2023'),
	},
	[Flight.measureSharedMetersPerformance]: {
		display: 'Measure shared meters performance',
		description: 'Measure shared meters performance',
		needsPageRefreshToActivate: true,
	},
	[Flight.multiSelectTeachingBubble]: {
		display: 'Multi Select Teaching Bubble',
		description: 'Show teaching bubble for multi select',
		expirationDate: new Date('September 30 2024'),
	},
	[Flight.mimTermsReordering]: {
		display: 'MIM Terms Reordering',
		description: 'Enables Move actions and term reordering in Agreement terms list',
	},
	[Flight.missingStandardAzurePlan]: {
		display: 'Missing Standard Azure Plan',
		description: 'Reconciles missing Standard Azure Plan messages after Azure Plan mutations',
		needsPageRefreshToActivate: true,
	},
	[Flight.mutationAuth]: {
		display: 'Mutation Authorization',
		description: 'Enforces role authorization on all GQL mutation requests',
	},
	//#endregion
	//#region N
	[Flight.newAuthFlow]: {
		display: 'New auth flow',
		description: 'Enables the new authentication flow',
	},
	[Flight.newBillingPlans]: {
		display: 'New Billing Plans',
		description: 'Enables the new billing plans',
	},
	[Flight.noTestHeaderTesting]: {
		display: 'Do not turn this on',
		description: 'Seriously, please do not turn this on',
		disableInEnvs: [AppEnvironment.Prod, AppEnvironment.Latest, AppEnvironment.Local],
	},
	[Flight.nonStandardFrameworkNonDFD]: {
		display: 'Non-Standard Framework Non-DFD',
		description: 'Allows non-standard framework quotes to be pass through non-DFD flow',
	},
	[Flight.nsptAcceptanceDateOverlapValidation]: {
		display: 'NSPT acceptance date overlap validation',
		description:
			'Validates order-acceptance dates against existing negotiated payment terms before applying NSPT configuration',
	},
	[Flight.notifDeepLink]: {
		display: 'CWA - Notifications Deep Links',
		description: 'Enables deep link for URL Parameters',
	},
	//#endregion
	//#region O
	[Flight.obfuscateTranslations]: {
		display: 'Obfuscate translations',
		description: 'Makes $$$ out of all translations',
	},
	[Flight.offlineAgreementNewFlow]: {
		display: 'Create offline agreement new flow',
		description:
			'Allows to upload offline agreement and add/edit participants without deleting and record',
	},
	[Flight.onetimeV2]: {
		display: 'OneTime V2',
		description: 'Enables OneTime V2 discounts',
	},
	//#endregion
	//#region P
	[Flight.perUserPromotionsEnhanced]: {
		display: 'Per User Promotions',
		description: 'Per User Promotions',
	},
	[Flight.promotionsOnSubscriptionLifecycle]: {
		display: 'Promotions on Subscription Lifecycle',
		description:
			'Enables promotional discounts for subscription lifecycle flows (upgrade, renewal, EST conversion)',
	},
	[Flight.promoEligibilityViaSaaSHubRP]: {
		display: 'Promo Eligibility via SaaS Hub RP',
		description:
			'Routes promo eligibility validation to SaaS Hub RP for subscription lifecycle flows (no impact to new purchases)',
	},
	[Flight.subscriptionPromoMockData]: {
		display: 'Subscription Promo Mock Data',
		description:
			'Enables mock promo data for subscription lifecycle flows (for testing when API is not available)',
	},
	[Flight.physicalSignForUkccf]: {
		display: 'Physical Signature for UK Framework',
		description: 'Allows Physical Signature for UK Framework',
	},
	[Flight.pidSearch]: {
		display: 'Product search by PID',
		description: 'Enables search for a product in finder using only product id',
		needsPageRefreshToActivate: true,
	},
	[Flight.pricelist]: {
		display: 'Pricelist',
		description: 'Enables Pricelist for search and selection of products',
	},
	[Flight.pricelistV2Phase2A]: {
		display: 'Pricelist V2 Phase 2A',
		description:
			'Pricelist V2 Phase 2A features - Global and CN Sov cloud options, Commercial segment',
	},
	[Flight.pricelistV2Phase2B]: {
		display: 'Pricelist V2 Phase 2B',
		description:
			'Pricelist V2 Phase 2B features - US Gov cloud, Rock Creek, Outer Banks, GSA MA, GSA BPA Ascend, DOD, GCC, GCC High, Government segment',
	},
	[Flight.pricelistV2Phase3]: {
		display: 'Pricelist V2 Phase 3',
		description: 'Pricelist V2 Phase 3 features',
	},
	[Flight.pricelistV2Phase3A]: {
		display: 'Pricelist V2 Phase 3A',
		description:
			'Pricelist V2 Phase 3A features - US Gov cloud and Government segment for US Federal Sales',
	},
	[Flight.pricelistV2Phase4]: {
		display: 'Pricelist V2 Phase 4',
		description: 'Pricelist V2 Phase 4 features',
	},
	[Flight.pricelistCartAcross]: {
		display: 'Cart Across Pricelist',
		description: 'Enables cart across searches for Pricelist',
	},
	[Flight.pricelistExpandedView]: {
		display: 'Expand Pricelist products',
		description:
			'Enables expanded view of Pricelist products to see SKU, commitment, billing plan, and pricing details',
	},
	[Flight.pricelistQuoteFilters]: {
		display: 'Pricelist Quote Filters',
		description: 'Constrains Pricelist filters to valid QC Quote Contexts',
	},
	[Flight.pricelistFullDownload]: {
		display: 'Pricelist Full Download',
		description: 'Download full price list',
	},
	[Flight.pricelistDebugColumns]: {
		display: 'Pricelist Download with PSAT columns',
		description: 'Download price list with PSAT columns',
	},
	[Flight.priceSheetDownload]: {
		display: 'LPP: Price Sheet Download',
		description: 'Download price sheet',
	},
	[Flight.productInclusionCheckerPanel]: {
		display: 'Product Inclusion Checker Panel',
		description: 'Enables the Product Inclusion Checker Panel',
	},
	[Flight.productSearchMoreResults]: {
		display: 'Get more filtered pages for product search',
		description: 'Increases number of product search results pages from 3 to 6',
	},
	[Flight.productSearchRemoveDuplicateResult]: {
		display: 'Remove duplicate result from productSearch',
		description: 'Remove duplicate result from productSearch on Gov context',
	},
	[Flight.enableLatestProductSearch]: {
		display: 'Enable Latest Product Search',
		description: 'Enables latest product search UI with Add products placeholder and plus icon',
	},
	[Flight.enableLdssProductSearch]: {
		display: 'Enable LDSS Product Search',
		description:
			'Routes the latest product search to the LDSS smart services search API instead of the search2 backend',
	},
	[Flight.productSearchComparator]: {
		display: 'Product Search Comparator',
		description:
			"Shows the LDSS versus Search2 product and SKU comparison tool on the What's New page",
	},
	[Flight.proposalExpirationBug]: {
		display: 'Proposal Expiration Bug Fix',
		description:
			'Fixes the cancel button not reverting expiration date in the Good Until date picker',
		expirationDate: new Date('May 1 2026'),
	},
	[Flight.proposalSteps]: {
		display: 'Proposal Steps',
		description: 'Enable Proposal Steps Button for all Non 21v proposals',
	},
	[Flight.proposalStatusFilter]: {
		display: 'Proposal Status Filter',
		description: 'Enables Expiration and Status filter pills on the Proposals list page',
	},
	[Flight.proposalAttachment1P]: {
		display: 'Proposal Attachment 1P Scope',
		description: 'Uses the 1P scope for Proposal Attachment authentication',
	},
	[Flight.promotionProductOwnerShipFix]: {
		display: 'Promotion Product Ownership Fix',
		description: 'Fixes the product ownership issue for promotions with more number of BigIds ',
	},
	//#endregion
	//#region Q
	[Flight.qcInMSX]: {
		display: 'QC in MSX',
		description: 'Allows to view QC in MSX',
	},
	[Flight.mcapiPolicy]: {
		display: 'MCAPI Policies UX',
		description: 'MCAPI description',
	},
	[Flight.qcsMigrationServiceDeskAttachment1PA]: {
		display: 'QCS migration with 1PA - ServiceDeskAttachment',
		description: 'Enable 1PA for ServiceDeskAttachment APIs from GraphQL instead of 3PA from QCS',
	},
	[Flight.qsElmEnforce]: {
		display: 'QuoteService ELM Enforce',
		description: 'Enables ELM enforcement for QS',
	},
	[Flight.quoteHeaderMessages]: {
		display: 'Quote Header Messages',
		description: 'GQL skips processing lineItems for messages when skipLineItems is true',
	},
	[Flight.quoteVersionV2]: {
		display: 'Enable Quote Creation Version V2',
		description:
			'Enables the new Quote Creation Version V2 experience for creating quotes. Default off; server flight values can enable it per environment.',
	},
	[Flight.enableCompressedQuoteResponse]: {
		display: 'Enable Compressed Quote Response',
		description:
			'Propagates the compressed quote response flight to the backend. Default off in all environments.',
	},
	[Flight.quoteRampedDiscounting]: {
		display: 'Quote Ramped Discounting',
		description: 'Features for Quote Ramped Discounting',
	},
	[Flight.quoteRampedAssets]: {
		display: 'Quote Ramped Assets',
		description: 'Features for Quote Ramped Assets',
	},
	[Flight.quoteRenewals]: {
		display: 'Quote Renewals',
		description: 'Features for Quote Renewals',
	},
	[Flight.quoteRenewalsBillingRP]: {
		display: 'Quote Renewals - Change subscription data',
		description: 'Get Subscription Data from BillingRP instead of Commerce Cache',
	},
	[Flight.quoteRenewalsMockData]: {
		display: 'Quote Renewals Mock Data',
		description: 'Mock Data for Quote Renewals',
	},
	[Flight.quotesListSorting]: {
		display: 'Quotes List Sorting',
		description: 'Enable sorting for quotes list to fix Global/Fairfax endpoint ordering',
	},
	[Flight.quotesListAllColumnsSorting]: {
		display: 'Enable Sort Checks',
		description:
			'Enable sorting for all columns (Name, Deal ID, Opportunity, Status) in the quotes list',
	},
	//#endregion
	//#region R
	[Flight.refactorIsDirectCommercial]: {
		display: 'Refactor isDirectCommercial',
		description: 'Refactor isDirectCommercial',
	},
	[Flight.refetchAfterBg]: {
		display: 'Refetch after AddBillingGroup mutation',
		description: 'Refetch after AddBillingGroup mutation',
	},
	[Flight.removalOfCrossCloud]: {
		display: 'Removal of Cross Cloud (21v & Gov)',
		description:
			'This will prevent any cross cloud graph calls, specifically targeting China 21V and FedGov scenarios',
	},
	[Flight.removeAllSavingsPlanOption]: {
		display: 'Remove all Savings Plan options',
		description: 'Remove all Savings Plan options from the UI',
	},
	[Flight.removeDisplayOfDiscounts]: {
		display: 'Remove display of discounts on product details pane',
		description: 'Remove display of discounts on product details pane',
	},
	[Flight.removeHeaderRowZIndex]: {
		display: 'Remove headerRow z-index',
		description: 'Remove headerRow z-index',
	},
	[Flight.createProposalPanelV2]: {
		display: 'CWA - Create Proposal V2',
		description: 'Enables the new Create Proposal V2 flow',
	},
	[Flight.createProposalMarketSuggestion]: {
		display: 'Create Proposal Market Suggestion',
		description: 'Enables the Create Proposal Market Suggestion Link',
	},
	[Flight.requiredCredit]: {
		display: 'Required credit',
		description:
			'enable to make credit check mandatory for Publish/Submit, if set false credit will be optional.',
		needsPageRefreshToActivate: true,
	},
	[Flight.reviewAndPublishStyle]: {
		display: 'Review and Publlish Style',
		description:
			'enable to see new style changes to the review and publish page, if set false the style will remain previous version.',
	},
	[Flight.riConfigurationPanel]: {
		display: 'RI Configuration Panel',
		description: 'enable to see new RI Configuration Panel',
	},
	[Flight.rampedDiscount]: {
		display: 'CWA - Ramped Discount',
		description: 'Features for Ramped Discount',
	},

	[Flight.rampedDiscountMock]: {
		display: 'CWA - Ramped Discount Mock Data',
		description: 'Features for Ramped Discount Mock Data',
	},

	[Flight.redirectConcessionPriceCallsToQS]: {
		display: 'Redirect Concession Price Calls to QS',
		description: 'Features for Redirecting Concession Price Calls to QS',
	},
	[Flight.restrictAddOnValidationToAddOnSkus]: {
		display: 'Restrict AddOn Validation to AddOn SKUs',
		description: 'Restrict AddOn Validation to AddOn SKUs',
	},

	//#endregion
	//#region S
	[Flight.safeListedBd360Requestor]: {
		display: 'Safelisted DD360 Requestor',
		description: 'Overrides requestor email when creating a ticket to request Custom Terms',
		disableInEnvs: [AppEnvironment.Prod],
		needsPageRefreshToActivate: true,
	},
	[Flight.safelistedCreditCheck]: {
		display: 'Safelisted Credit Check',
		description: 'Credit check uses a safelisted organization',
		disableInEnvs: [AppEnvironment.Prod],
		needsPageRefreshToActivate: true,
	},
	[Flight.sandboxOrganizationCreation]: {
		display: 'Sandbox organization creation',
		description: 'Creates a sandbox organization',
	},
	[Flight.sandboxAccountsEnforceForE2ETesting]: {
		display: 'Sandbox Accounts Adoption for E2E Testing',
		description: 'Sandbox Accounts Adoption for E2E Testing',
	},
	[Flight.saveAPIResponseToBlobCache]: {
		display: 'Save API Response To Blob Cache',
		description: 'Saves the api response to blob cache',
	},
	[Flight.scheduledEvents]: {
		display: 'Scheduled Events',
		description: 'Enables Scheduled Events for the Quote renewal',
	},
	[Flight.scheduledEventsMock]: {
		display: 'Scheduled Events Mock Data',
		description: 'Enables Scheduled Events Mock Data for the Quote renewal',
	},
	[Flight.scheduleMidTermUpgrade]: {
		display: 'Schedule Mid-Term Upgrade',
		description: 'Enables Schedule Mid-Term Upgrade for subscriptions',
	},
	[Flight.scheduleMidTermUpgradeMock]: {
		display: 'Schedule Mid-Term Upgrade Mock Data',
		description: 'Enables Schedule Mid-Term Upgrade Mock Data',
	},
	[Flight.scheduleMidTermUpgradeUSGOV]: {
		display: 'Schedule Mid-Term Upgrade US Gov',
		description: 'Enables Schedule Mid-Term Upgrade for US Gov cloud quotes',
	},
	[Flight.searchByMeterIdLongerTimeout]: {
		display: 'Search By Meter Id Longer Timeout',
		description: 'Increases axios timeout for Search By Meter Id',
	},
	[Flight.seatCap]: {
		display: 'Seat Cap',
		description:
			'Allows users to specify a seat cap on a discounted subscription or future discount/price',
	},
	[Flight.seatCapMock]: {
		display: 'Seat Cap Mock Data',
		description: 'seat cap on a discounted subscription with mock data',
	},
	[Flight.sequenceDownloadSharedMetersGql]: {
		display: 'Sequence Download Shared Meters GQL',
		description: 'Make sequential Download Shared Meters GQL calls',
	},
	[Flight.showDateIsInThePastErrorForSharedDiscount]: {
		display: 'Show Date is in the past error for expired shared discounts',
		description: 'Show Date is in the past error for expired shared discounts',
	},
	[Flight.simulateCreditCheckNull]: {
		display: 'Simulate credit check as null',
		description: 'Simulate credit check service response to null',
	},
	[Flight.simulateCreditCheckManualCancelled]: {
		display: 'Simulate credit check manual cancelled',
		description: 'Simulate credit check service response to manual cancelled',
	},
	[Flight.simulateCreditCheckManualRejected]: {
		display: 'Simulate credit check manual rejected',
		description: 'Simulate credit check service response to manual rejected',
	},
	[Flight.simulateCreditCheckManualReview]: {
		display: 'Simulate credit check manual review',
		description: 'Simulate credit check service response to manual review',
	},
	[Flight.simulateCreditCheckPendingNoCredit]: {
		display: 'Simulate credit check pending no credit',
		description: 'Simulate credit check service response to pending no credit',
	},
	[Flight.simulateCreditCheckPendingReview]: {
		display: 'Simulate credit check pending review',
		description: 'Simulate credit check service response to pending review',
	},
	[Flight.simulateTradeStatusNeedScreening]: {
		display: 'Simulate trade status need screening',
		description: 'Simulate tradestatus service response to need screening',
	},
	[Flight.ssc]: {
		display: 'Service specific credits',
		description:
			'Discoverability and configuration of service speficic credits (SSC) and contingent service specific credits (CSSC)',
		needsPageRefreshToActivate: true,
	},
	[Flight.sscaco]: {
		display: 'Service specific credits - ACO',
		description:
			'This enables the ability to create proposal alone with service speficic credits (SSC) context in ACO',
	},
	[Flight.softwareSubs]: {
		display: 'Software Subs',
		description: 'Enables Software Subscriptions',
		needsPageRefreshToActivate: true,
	},
	[Flight.softwareRPTrueUpMock]: {
		display: 'Software RP TrueUp Mock',
		description: 'Enables TrueUp amendment mock data for Software Subscriptions',
	},
	[Flight.sovereignCloudRenewalPolicy]: {
		display: 'Sovereign Cloud Renewal Governance',
		description:
			'Enables sovereign cloud renewal policy restrictions. Hides auto-renew for Delos (Germany) cloud.',
		needsPageRefreshToActivate: true,
	},
	[Flight.sovereignPurchaseGovernanceForDelos]: {
		display: 'Sovereign Cloud Purchase Governance',
		description:
			'Enables sovereign cloud purchase restrictions for Delos (Germany) Passes products: 1st-of-future-month start dates and expiration-date capping.',
		needsPageRefreshToActivate: true,
	},
	[Flight.combinedAvailabilityTokenForPromotions]: {
		display: 'Combined Availability Token for Promotions',
		description:
			'Enables combined availability token generation for V1 future discount/promo redemption (AGC cross-cloud fix).',
		needsPageRefreshToActivate: true,
	},
	[Flight.swSubFutureDiscounts]: {
		display: 'Future Discounts for Software Subscriptions',
		description: 'Enables future discounts for Software Subscriptions',
	},
	[Flight.swSubCoterm]: {
		display: 'Coterm Software Subscriptions',
		description: 'Enables co-terming for Software Subscriptions',
	},
	[Flight.swSubCotermMockData]: {
		display: 'Coterm Software Subscriptions Mock Data',
		description: 'Enables co-terming for Software Subscriptions with mock data',
	},
	[Flight.swSubTup]: {
		display: 'TUP Software Subscriptions',
		description: 'Enables true-up for Software Subscriptions',
	},
	[Flight.proposalTabSwitchPerfOptimization]: {
		display: 'Proposal Tab Switch Performance Optimization',
		description:
			'Enables performance optimizations when switching between the Products and Agreement tabs: keeps both tabs mounted, memoizes line-item derivation, and stabilizes the Pivot items reference so the active-tab indicator does not lag.',
	},
	[Flight.sscLegacy]: {
		display: 'Service specific credits - Legacy only',
		description:
			'This enables the ability to create Legacy proposal alone with service speficic credits (SSC) context',
		needsPageRefreshToActivate: true,
	},
	[Flight.standardAcceleration]: {
		display: 'Enable Standard Acceleration',
		description: 'Enables Standard Acceleration for a Reference Line Item',
	},
	[Flight.subscriptionManagementFutureStartDate]: {
		display: 'Subscription Management Future Start Date',
		description: 'Enables future start date for subscription management',
	},
	[Flight.subscriptionLoadOptimization]: {
		display: 'Subscription Load Optimization',
		description: 'Enables optimized load of data under subscription management',
	},
	[Flight.subscriptionWizard]: {
		display: 'Subscription Wizard',
		description: 'Enables Subscription Wizard experience',
	},
	[Flight.submitProposalPanelEnabled]: {
		display: 'LQ1 - Submit Proposal Panel Enabled',
		description: 'Enables the panel experience for submit proposal',
	},
	[Flight.submitProposalPanelRemoveApproverCount]: {
		display: 'Submit Proposal Panel Remove Approver Count',
		description: 'Removes approver count from submit proposal panel',
	},
	[Flight.proposalTelemetry]: {
		display: 'Proposal Lifecycle Telemetry',
		description: 'Enables structured UI telemetry for proposal create, submit, and publish events',
	},
	//#endregion
	//#region T
	[Flight.tenantAdminDeprecation]: {
		display: 'CWA - Tenant Admin Deprecation',
		description: 'removes tenant admin call from authorized administrator',
	},
	[Flight.termLengthAcceleration]: {
		display: 'Enable Term Length Acceleration',
		description: 'Enable Term Length Acceleration',
	},
	[Flight.termsFinderSearch]: {
		display: 'Terms Finder Search',
		description: 'Allows searching of negotiated terms in the Finder',
	},
	[Flight.termsHarmonyConvertButton]: {
		display: 'Terms convert button using Harmony',
		description: 'Harmonize and keep isolated for conver to custom button',
	},
	[Flight.TestFlight1]: {
		display: 'Test Flight',
		description: 'Console log response from flight service',
	},
	[Flight.testFlightMSAV1ENTRAV2]: {
		display: 'Test Flight MSA V1 ENTRA V2',
		description: 'Test Flight MSA V1 ENTRA V2',
	},
	[Flight.testHeader3YearsRetention]: {
		display: 'Extend Test header retention to 3 years',
		description: 'Allows to pass Test header retention to 3 years',
	},
	[Flight.testLargeQuoteDFDNONDFD]: {
		display: 'TestLargeQuoteDFDNONDFD',
		description: 'test flight for large quote DFD and NONDFD',
	},
	[Flight.throttleSearchByMeterId]: {
		display: 'Throttle Shared Meters Lookup',
		description: 'Throttle Shared Meters Product Lookup calls',
	},
	//#endregion
	//#region U
	[Flight.unifiedForPartners]: {
		display: 'Unified for Partners',
		description: 'Enables Unified for Partners in the quote center',
	},
	[Flight.ufpMockData]: {
		display: 'Unified for Partners Mock Data',
		description: 'Enables Unified for Partners mock data for testing',
	},
	[Flight.upcomingExpirationMock]: {
		display: 'Upcoming Expiration Mock Data',
		description: 'Enables Upcoming Expiration Mock Data for the Quote renewal',
	},
	[Flight.useAADForProjects]: {
		display: 'Use AAD for Projects calls',
		description: 'Use AAD for Projects calls',
	},
	[Flight.useAADForRecipients]: {
		display: 'Use AAD for Recipients calls',
		description: 'Use AAD for Recipients calls',
	},
	[Flight.useBlobForCatalogCaching]: {
		display: 'Use blob for catalog caching',
		description: 'Fetch cached catalog data from storage account blob',
		needsPageRefreshToActivate: true,
	},
	[Flight.useCommerceAgentUat]: {
		display: 'Use Commerce Agent UAT',
		description: 'Routes Commerce Agent chat to the UAT Uber Orchestrator endpoint instead of DEV',
		needsPageRefreshToActivate: true,
	},
	[Flight.useCustomTermLimit]: {
		display: 'Use Custom Term Limit',
		description: 'Determines the maximum custom term limit per proposal',
	},
	[Flight.useFindAndRetrieveForAutoCompleteAddress]: {
		display: 'Use Find and Retrieve for Autocomplete',
		description: 'Use Find and Retrieve APIs for Auto Complete Address',
	},
	[Flight.useNewEAAdminScope]: {
		display: 'Use 1PA Scope for EA Admin',
		description: 'Use 1PA Scope for EA Admin',
	},
	[Flight.useFluentPanelForAzurePlan]: {
		display: 'Use Fluent panel for Azure Plan',
		description: 'Use Fluent panel for Azure Plan config panel',
	},
	[Flight.useFluentPanelForACD]: {
		display: 'Use Fluent panel for ACD',
		description: 'Use Fluent panel for ACD config panel',
	},
	[Flight.useFluentPanelForDiscountConfig]: {
		display: 'Use Fluent panel for Discount config',
		description: 'Use Fluent panel for Discount configuration panel',
	},
	[Flight.useFluentPanelForMeters]: {
		display: 'Use Fluent panel for RI Configuration Panel',
		description: 'Use Fluent panel for RI Configuration Panel',
	},
	[Flight.useFluentPanelForModernOffice]: {
		display: 'Use Fluent panel for Modern Office',
		description: 'Use Fluent panel for Modern Office config panel',
	},
	[Flight.useFluentPanelForMonetary]: {
		display: 'Use Fluent panel for Monetary',
		description: 'Use Fluent panel for Monetary config panel',
	},
	[Flight.useNonDFDForRIProduct]: {
		display: 'Use Non-Dfd for AzureRI With Purchase and Renew',
		description:
			'Use non-dfd schema for all Azure RI product, PCD having both Purchase and Renew action',
	},
	[Flight.useQuoteProgramCode]: {
		display: 'Use Quote ProgramCode',
		description:
			'Adds programCode to Quote on creation & uses agreementTemplate info from Quotes (Direct-Commercial only)',
		needsPageRefreshToActivate: true,
	},
	[Flight.useQSProd]: {
		display: 'Use QS Prod',
		description: 'Use QS Prod endpoint for all quote service calls',
	},
	[Flight.useRawDateAndDurationValues]: {
		display: 'Use Raw Date and Duration Values',
		description:
			'Removes dependency on DateAndDuration type and implements values that are on the QS quote line item',
	},
	[Flight.useTermComponentDescriptionForCommitment]: {
		display: 'Use Term Component Description for Commitment',
		description: 'Use term component description for commitment',
	},
	[Flight.useUSGovHeadersForBigCat]: {
		display: 'Use US Gov headers for BigCat calls',
		description: 'Use US Gov headers for BigCat calls',
	},
	[Flight.usGovTerm]: {
		display: 'US Gov Term',
		description: 'Enable for particular US Gov',
	},
	[Flight.use1PAFIC]: {
		display: 'Use FIC credential to acquire token from 1PA',
		description: 'Use FIC credential to acquire token from 1PA instead of certificate SN+I',
	},
	[Flight.useUpnForTermResolution]: {
		display: 'Use UPN for Term Resolution',
		description:
			'Use UPN to derive term ID and availability ID during reconfiguration to prevent mismatch when BigCat rotates IDs',
		needsPageRefreshToActivate: true,
	},
	[Flight.deprecateUIDrivenFlights]: {
		display: 'Deprecate UI-driven flights resolution (kill-switch)',
		description:
			'Environment-agnostic kill-switch: when ON, flights come solely from the server (getFlightsV2) and the `flights` header is omitted from GraphQL requests. Local defaults, LocalStorage caches, URL overrides, and `forceEnableInEnvs` are all bypassed. Default is OFF in every environment.',
		needsPageRefreshToActivate: true,
	},
	//#endregion
	//#region V
	[Flight.validPurchaseTermUnits]: {
		display: 'Valid Purchase Term Units',
		description: 'For checking ECIF Amount validation.',
	},
	[Flight.virusScanTestHeader]: {
		display: 'Virus Scan Test Header',
		description: 'Add test header to scan virus via MsDefender',
	},
	[Flight.vpnMessageBar]: {
		display: 'Display VPN message in standalone',
		description: 'Display VPN message in standalone',
	},
	[Flight.multiTenantProposalsWithdrawRedesign]: {
		display: 'Enable Multi-Entity Proposals Withdraw Redesign',
		description:
			'Renders the redesigned Withdraw proposal confirmation dialog with a dedicated deal-impact warning bar and a separated trailing question. When OFF, the legacy single-paragraph copy is used.',
		needsPageRefreshToActivate: false,
	},
	[Flight.whatsNew]: {
		display: "What's New",
		description: "Controls visibility of the What's New page and header/navigation entry points.",
		needsPageRefreshToActivate: true,
	},
	[Flight.useMIForUSGovAadGraph]: {
		display: 'MI for US Gov AAD Graph',
		description: 'Use MI for US Gov AAD Graph',
		needsPageRefreshToActivate: true,
	},
	[Flight.useProdApp]: {
		display: 'Prod App for US Gov AAD Graph',
		description: 'Use Prod App for US Gov AAD Graph',
		needsPageRefreshToActivate: true,
	},
	[Flight.useFICForAccountExtensions]: {
		display: 'FIC Auth for Account Extensions',
		description: 'FIC Auth for Account Extensions',
		needsPageRefreshToActivate: true,
	},
	[Flight.useNewTaxIdMessage]: {
		display: 'Use New Tax ID Message',
		description: 'Enables the new Tax ID message in the Tax Dialog popup',
	},
	[Flight.tranche]: {
		display: 'Tranche',
		description: 'Enables tranche for the quote center',
	},
	[Flight.tranchePostCall]: {
		display: 'TranchePostCall',
		description: 'Enables tranche post call for the quote center',
	},
	[Flight.billingProfileCloud]: {
		display: 'Billing Profile Cloud',
		description: 'Enables billing profile cloud for the quote center',
	},
	[Flight.trancheSubscriptionList]: {
		display: 'Tranche Subscription List',
		description: 'Enable Sync button when line items are added via Subscription Management',
	},
	[Flight.modernAccountOrg]: {
		display: 'Modern Account Org',
		description: 'Enables modern account org api for organization creation',
	},
	[Flight.globalTaxId]: {
		display: 'GlobalTaxId',
		description: 'Enables Global Tax Id for the quote center',
	},
	[Flight.taxIdMetadataApi]: {
		display: 'TaxIdMetadataApi',
		description: 'Enables fetching tax ID requirements from the Tax ID Metadata API',
	},
	[Flight.aiAutonomous]: {
		display: 'AI Autonomous',
		description: 'Enables AI Autonomous in MSX for the quote center',
	},
	[Flight.aiSmbPermissionCheck]: {
		display: 'AI SMB Permission Check',
		description: 'Enables SMB create permission check for the unmanaged SMB checkbox',
	},
	[Flight.MEPenableMultiTenantLeadAgreementSignedValidation]: {
		display: 'Enable Multi-Tenant Lead Signed Agreement validation',
		description: 'Enable Multi-Tenant Lead Signed Agreement validation',
	},
	[Flight.aiChatBot]: {
		display: 'AI ChatBot',
		description: 'Enables the AI ChatBot (VLC GHCP Assistant) floating button',
	},
	[Flight.fullPageAiChatBot]: {
		display: 'Full Page AI ChatBot',
		description: 'Renders the AI ChatBot as a full-page window instead of the docked side panel',
	},
	[Flight.searchUfp]: {
		display: 'Search UFP',
		description: 'Enables Search by Org ID and MPN ID',
	},
	[Flight.isSubmitApprovalSkip]: {
		display: 'Submit Approval Skip',
		description:
			'Skips Approval Service interactions (patch approvers and post to approval) during quote submission',
	},
	[Flight.aircapiDefaultTenantType]: {
		display: 'AircapiDefaultTenantType',
		description: 'Default tenant type to Managed in aircapi env',
	},
};

export function getFlight(value: string): Flight | undefined {
	return flightList.find(flight => flight.toLowerCase() === value.toLowerCase());
}

export function isFlight(value: string): value is Flight {
	return !!getFlight(value);
}
